(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["account-login-redirect"] && !Shopify.designMode) return;
  try {
    (function () {
    const GUARD_KEY = 'bv-login-redirected-at';
    const GUARD_MS = 60000;

    function redirectToLogin() {
      let last = 0;
      try { last = Number(sessionStorage.getItem(GUARD_KEY)) || 0; } catch (e) { /* storage blocked */ }
      if (Date.now() - last < GUARD_MS) return false;
      try { sessionStorage.setItem(GUARD_KEY, String(Date.now())); } catch (e) { /* storage blocked */ }
      try { sessionStorage.setItem('bv-ga4-login-pending', '1'); } catch (e) { /* storage blocked */ }
      /* Locale-aware login route, handed over from Liquid (see the marker span).
         `return_to` already carried the localized path; only this hop was wrong. */
      var loginMarker = document.querySelector('[data-login-redirect]');
      /* trim(): the Liquid doc block leaves a leading newline in the attribute. */
      var loginUrl = ((loginMarker && loginMarker.dataset.loginUrl) || '/customer_authentication/login?locale=en').trim();
      window.location.replace(
        loginUrl + '&return_to=' +
        encodeURIComponent(window.location.pathname + window.location.search)
      );
      return true;
    }
    window.bvLoginRedirect = redirectToLogin;

    const marker = document.querySelector('[data-login-redirect][data-auto]');
    if (!marker) return;
    fetch(marker.dataset.endpoint, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (res) { return res.ok ? res.json() : null; })
      .then(function (data) {
        if (data && data.status === 'not_logged_in') redirectToLogin();
      })
      .catch(function () { /* leave the inline sign-in prompt */ });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bis-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  var modal = document.getElementById('bis-modal');
  var overlay = document.getElementById('bis-modal-overlay');
  if (!modal || !overlay) return;

  var formView = modal.querySelector('[data-bis-form]');
  var successView = modal.querySelector('[data-bis-success]');
  var emailInput = modal.querySelector('[data-bis-email]');
  var submitBtn = modal.querySelector('[data-bis-submit]');

  var KEY = modal.dataset.klaviyoKey || '';
  var REVISION = modal.dataset.klaviyoRevision || '2026-01-15';
  var COUNTRY = modal.dataset.countryCode || '';

  var pendingVariantId = null;
  var onSuccessCb = null;
  var returnFocus = null;
  var focusSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  window.__bisCustomerEmail = modal.dataset.customerEmail || '';

  /* Klaviyo back-in-stock subscription — the exact contract the PDP notify
     flow uses (sections/product.liquid): BIS event only, deliberately NOT a
     marketing-list opt-in, plus an onsite identify so the browser becomes an
     identifiable profile for the restock flow's market resolution. */
  window.__bisSubscribe = function (variantId, email) {
    if (!KEY || !variantId || !email) return Promise.reject(new Error('bis: missing key/variant/email'));
    var req = fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + KEY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: { data: { type: 'profile', attributes: { email: email } } },
            channels: ['EMAIL']
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + variantId } }
          }
        }
      })
    }).then(function (r) {
      if (!r.ok && r.status !== 202) throw new Error('bis subscribe failed: ' + r.status);
    });
    try {
      var identity = { email: email };
      if (COUNTRY) identity.country_code = COUNTRY;
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(identity);
      } else if (window._learnq) {
        window._learnq.push(['identify', COUNTRY ? { '$email': email, country_code: COUNTRY } : { '$email': email }]);
      }
    } catch (e) {}
    return req;
  };

  function openModal() {
    returnFocus = document.activeElement;
    formView.style.display = '';
    successView.style.display = 'none';
    modal.classList.add('is-open');
    overlay.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    if (emailInput) { emailInput.value = ''; setTimeout(function () { emailInput.focus(); }, 50); }
  }
  function closeModal() {
    modal.classList.remove('is-open');
    overlay.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    pendingVariantId = null;
    onSuccessCb = null;
    if (returnFocus && returnFocus.focus) returnFocus.focus();
    returnFocus = null;
  }

  window.__openBisModal = function (variantId, onSuccess) {
    pendingVariantId = variantId;
    onSuccessCb = onSuccess || null;
    openModal();
  };

  function submit() {
    if (!emailInput) return;
    var email = emailInput.value.trim();
    if (!email || !emailInput.checkValidity()) { emailInput.focus(); return; }
    submitBtn.classList.add('is-loading');
    var cb = onSuccessCb;
    window.__bisSubscribe(pendingVariantId, email)
      .then(function () {
        formView.style.display = 'none';
        successView.style.display = '';
        if (cb) { try { cb(email); } catch (e) {} }
      })
      .catch(function () {
        if (window.__showQuickAddToast) window.__showQuickAddToast(modal.dataset.failText || 'Something went wrong. Please try again.', true);
      })
      .finally(function () { submitBtn.classList.remove('is-loading'); });
  }

  if (submitBtn) submitBtn.addEventListener('click', submit);
  if (emailInput) emailInput.addEventListener('keydown', function (e) {
    if (e.key === 'Enter') { e.preventDefault(); submit(); }
  });
  modal.querySelectorAll('[data-bis-close]').forEach(function (b) { b.addEventListener('click', closeModal); });
  overlay.addEventListener('click', closeModal);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    if (e.key !== 'Tab' || !modal.classList.contains('is-open')) return;
    var items = [].filter.call(modal.querySelectorAll(focusSelector), function (el) {
      return el.getClientRects().length && !el.hidden;
    });
    if (!items.length) { e.preventDefault(); modal.focus(); return; }
    var first = items[0];
    var last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  var CFG = window.__cartDrawerCfg || {};
  var drawer = document.getElementById('cart-drawer');
  if (!drawer) return;

  var overlay = document.getElementById('cart-drawer-overlay');
  var closeBtn = document.getElementById('cart-drawer-close');

  /* QA BUG-BV-85: the drawer declares role="dialog" aria-modal="true" but had no
     focus management — focus never entered it and Tab walked straight through to
     the page behind. Ports the header mobile-menu pattern (BV-17): `inert` on the
     rest of the page removes it from the tab order AND the a11y tree, focus moves
     in on open and back to the trigger on close, and the Tab handler wraps at the
     ends as a fallback for browsers without inert. */
  var CD_FOCUS_SEL = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var cdLastFocused = null;
  function cdTopAncestor(el) { while (el && el.parentElement && el.parentElement !== document.body) el = el.parentElement; return el; }
  function cdSetBackgroundInert(on) {
    /* Keep the drawer, its overlay, and the loading status region live — the last
       is an aria-live announcer that sits OUTSIDE the drawer and must still speak. */
    var loadingEl_ = document.getElementById('cart-drawer-loading');
    var keep = [cdTopAncestor(drawer), cdTopAncestor(overlay)];
    if (loadingEl_) keep.push(cdTopAncestor(loadingEl_));
    [].forEach.call(document.body.children, function (el) {
      if (keep.indexOf(el) !== -1) return;
      if (on) el.setAttribute('inert', ''); else el.removeAttribute('inert');
    });
  }
  function cdFocusables() {
    return [].filter.call(drawer.querySelectorAll(CD_FOCUS_SEL), function (el) {
      return el.getClientRects().length > 0 && !el.closest('[inert]');
    });
  }
  function cdTrapFocus() {
    cdLastFocused = document.activeElement;
    cdSetBackgroundInert(true);
    var f = cdFocusables();
    var target = closeBtn || f[0] || drawer;
    try { target.focus({ preventScroll: true }); } catch (e) { target.focus(); }
  }
  function cdReleaseFocus() {
    cdSetBackgroundInert(false);
    if (cdLastFocused && cdLastFocused.focus) {
      try { cdLastFocused.focus({ preventScroll: true }); } catch (e) { cdLastFocused.focus(); }
    }
    cdLastFocused = null;
  }

  var itemsEl = document.getElementById('cart-drawer-items');
  var loadingEl = document.getElementById('cart-drawer-loading');
  var busyEl = document.getElementById('cart-drawer-busy');
  var footerEl = document.getElementById('cart-drawer-footer');
  var subtotalEl = document.getElementById('cart-drawer-subtotal');
  var shippingValueEl = document.getElementById('cart-drawer-shipping-value');

  /* Line keys whose quantity is capped at available stock. /cart.js carries no
     inventory data, so this is populated when /cart/change.js clamps a requested
     quantity (see changeQty); it survives re-renders so the message/disabled
     state persists while the drawer is open. */
  var atMaxKeys = {};

  /* Locale-aware root: '' on the primary locale, '/fr' etc. on secondary ones.
     Section Rendering API fetches MUST carry it or Shopify serves the section in
     the shop's DEFAULT locale and the injected markup comes back untranslated. */
  var LOCALE_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');

  var FREE_THRESHOLD_CENTS = CFG.freeThresholdCents;
  /* Whether FREE_THRESHOLD_CENTS is denominated in the currency the shopper sees.
     The ROW metafield entry is USD, so on a THB/JPY/EUR storefront the subtraction
     below would compare unlike units and print nonsense ("99 ฿ away" against a
     real ~3,320 ฿ threshold). When false we state the threshold instead of a
     computed distance. See snippets/free-shipping-threshold. */
  var FREE_THRESHOLD_COMPARABLE = CFG.freeThresholdComparable;
  var FREE_THRESHOLD_TEXT = CFG.freeThresholdText;
  var SHIPPING_FREE = CFG.shippingFree;
  var SHIPPING_AWAY_BEFORE = CFG.shippingAwayBefore;
  /* Reuses the existing "Free shipping on order over {amount}" string; the token
     is swapped for a placeholder so JS can inject the threshold text. */
  var SHIPPING_OVER_TEXT = CFG.shippingOverText;
  var SHIPPING_AWAY_AFTER = CFG.shippingAwayAfter;

  var moneyFormat = drawer.dataset.moneyFormat || ('$' + '{' + '{amount}}');
  var moneyCode = drawer.dataset.moneyCode || '';

  /* Pencil for the per-line Quick Edit control (Figma edit-03). Inline rather
     than a svg-sprites symbol: it only exists inside this bundled, cached file. */
  var ICON_EDIT = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 20h9"/><path d="M16.5 3.5a2.121 2.121 0 1 1 3 3L7 19l-4 1 1-4L16.5 3.5z"/></svg>';

  /* Delegates to the shared formatter (snippets/money-format), which derives the
     separators from a Liquid-rendered sample and therefore matches the
     server-rendered prices in every currency — including the Eurozone formats
     that made the old local implementation print the placeholder
     amount_with_comma_separator literally as a line price.
     (Braces omitted in this comment on purpose: Liquid renders inside JS
     comments too, so writing the placeholder verbatim makes it an undefined
     object.)

     The local path is kept ONLY as a degradation route if money-format failed to
     deploy; it is knowingly wrong for the separator variants, which is still
     better than throwing inside the drawer's render loop. */
  function formatMoney(cents) {
    if (window.BonvaleMoney) return window.BonvaleMoney.format(cents);
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var noDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals) + moneyCode;
  }

  function openDrawer() {
    drawer.removeAttribute('inert');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    cdTrapFocus();
    /* Lazy-load the Recently Viewed carousel on first open (see below). */
    if (typeof drawer.__cdrvLoad === 'function') drawer.__cdrvLoad();
    if (window.BonvaleAnalytics && typeof window.BonvaleAnalytics.trackGa4 === 'function') {
      window.BonvaleAnalytics.trackGa4('view_cart_drawer', {
        currency: (lastCart && lastCart.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '',
        value: lastCart ? lastCart.total_price / 100 : 0
      });
    }
  }

  function renderLoadingState() {
    var skeletonItem =
      '<div class="cart-drawer__item cart-drawer__item--skeleton" aria-hidden="true">' +
        '<div class="cart-drawer__item-image cart-drawer__skeleton-shimmer"></div>' +
        '<div class="cart-drawer__item-content">' +
          '<div>' +
            '<div class="cart-drawer__skeleton-line cart-drawer__skeleton-line--lg cart-drawer__skeleton-shimmer"></div>' +
            '<div class="cart-drawer__skeleton-line cart-drawer__skeleton-shimmer"></div>' +
          '</div>' +
          '<div class="cart-drawer__skeleton-qty cart-drawer__skeleton-shimmer"></div>' +
        '</div>' +
        '<div class="cart-drawer__skeleton-line cart-drawer__skeleton-line--price cart-drawer__skeleton-shimmer"></div>' +
      '</div>';
    itemsEl.innerHTML = skeletonItem + skeletonItem;
  }

  /* Open the drawer instantly with a skeleton; caller still needs to fetch real data. */
  function openDrawerWithSkeleton() {
    goToBag();
    renderLoadingState();
    openDrawer();
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    setTimeout(function () {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.setAttribute('inert', '');
      overlay.setAttribute('aria-hidden', 'true');
      goToBag();
    }, 350);
    cdReleaseFocus();
    document.body.style.overflow = '';
    /* The side panel can now open OVER the cart page (desktop quick add /
       quick edit), whose server-rendered lines don't see the drawer's edits.
       __refreshCartPage exists only on /cart (see sections/cart.liquid) —
       everywhere else this is a no-op. */
    if (window.__refreshCartPage) window.__refreshCartPage();
  }

  /* Resize a Shopify CDN image URL via query parameters rather than the legacy
     `_240x320_crop_center` filename suffix. The suffix form cannot carry
     `quality`, which is a query parameter and the theme's main image-weight lever
     (see snippets/image-srcset) — and mixing the two on a URL that already has
     `?v=` is fragile. Non-CDN or already-parameterised URLs pass through. */
  function cdnResize(url, width, height) {
    if (!url) return '';
    if (url.indexOf('/cdn/shop/') === -1 && url.indexOf('cdn.shopify.com') === -1) return url;
    if (url.indexOf('width=') !== -1) return url;
    var q = url.indexOf('?') === -1 ? '?' : '&';
    var out = url + q + 'width=' + width;
    if (height) out += '&height=' + height + '&crop=center';
    return out + '&quality=70';
  }

  function renderItem(item) {
    /* /cart.js item.url has no locale prefix, unlike Liquid's line_item.url —
       prepend routes.root so the PDP link keeps the shopper's locale. */
    var productUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root.replace(/\/$/, '') : '') + item.url;

    /* Drawer thumb renders at 120×160 CSS px — 240×320 covers a 2× screen. */
    var imgSrc = cdnResize(item.image, 240, 320);
    var imgHtml = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + item.product_title.replace(/"/g, '&quot;') + '" loading="lazy" width="120" height="160">'
      : '';
    if (imgHtml) imgHtml = '<a href="' + productUrl + '">' + imgHtml + '</a>';

    // Dedupe options by name (combined listings surface Color twice).
    var variantParts = [];
    if (item.options_with_values && item.options_with_values.length) {
      var seenNames = {};
      item.options_with_values.forEach(function (opt) {
        var key = (opt.name || '').toLowerCase();
        if (!seenNames[key]) {
          seenNames[key] = true;
          variantParts.push(opt.value);
        }
      });
    } else if (item.variant_title && item.variant_title !== 'Default Title') {
      variantParts = item.variant_title.split(' / ');
    }
    var variantText = variantParts.join(' | ');

    var hasSale = item.original_line_price !== item.final_line_price;
    var priceHtml = hasSale
      ? '<span class="cart-drawer__item-price-final">' + formatMoney(item.final_line_price) + '</span>'
        + '<span class="cart-drawer__item-price-compare">' + formatMoney(item.original_line_price) + '</span>'
      : '<span class="cart-drawer__item-price-final">' + formatMoney(item.final_line_price) + '</span>';

    var atMax = !!atMaxKeys[item.key];

    /* Quick Edit (Figma 15817:98225): pencil beside the variant line opens the
       side panel preloaded with this line's options. Only lines with real
       options get one — a Default Title line has nothing to edit. */
    var editHtml = variantText
      ? '<button type="button" class="cart-drawer__item-edit" data-edit-line aria-label="' + CFG.editItem + '">' + ICON_EDIT + '</button>'
      : '';

    var el = document.createElement('div');
    el.className = 'cart-drawer__item';
    el.dataset.key = item.key;
    el.__item = item;
    el.innerHTML =
      '<div class="cart-drawer__item-image">' + imgHtml + '</div>' +
      '<div class="cart-drawer__item-content">' +
        '<div>' +
          '<p class="cart-drawer__item-name"><a href="' + productUrl + '">' + item.product_title + '</a></p>' +
          (variantText ? '<p class="cart-drawer__item-variant"><span>' + variantText + '</span>' + editHtml + '</p>' : '') +
          '<div class="cart-drawer__item-qty">' +
            '<button type="button" class="cart-drawer__item-qty-btn" data-minus aria-label="' + CFG.decrease + '">' +
              window.__iconMinus +
            '</button>' +
            '<input type="number" class="cart-drawer__item-qty-input" value="' + item.quantity + '" min="0" data-qty-input>' +
            '<button type="button" class="cart-drawer__item-qty-btn" data-plus aria-label="' + CFG.increase + '"' + (atMax ? ' disabled' : '') + '>' +
              window.__iconPlus +
            '</button>' +
          '</div>' +
          '<p class="cart-drawer__item-qty-msg" data-qty-max-msg aria-live="polite"' + (atMax ? '' : ' hidden') + '>' + CFG.maxStockReached + '</p>' +
        '</div>' +
        '<div class="cart-drawer__item-actions">' +
          '<button type="button" class="cart-drawer__item-action" data-move-wishlist' +
            ' data-product-id="' + item.product_id + '"' +
            ' data-variant-id="' + item.variant_id + '"' +
            /* Swym needs an ABSOLUTE du — a relative path is rejected outright with
               `schema.core/error` (verified on prod 2026-08-06), which is why this
               button's wishlist add had never once succeeded. */
            ' data-product-url="' + window.location.origin + productUrl + '"' +
            ' data-product-title="' + item.product_title.replace(/"/g, '&quot;') + '"' +
            ' data-product-price="' + item.price + '"' +
            ' data-product-image="' + (item.image || '') + '"' +
          '>' + CFG.moveToWishlist + '</button>' +
          '<button type="button" class="cart-drawer__item-action" data-remove>' + CFG.remove + '</button>' +
        '</div>' +
      '</div>' +
      '<div class="cart-drawer__item-price">' + priceHtml + '</div>';
    return el;
  }

  /* QA #12 / BUG-BV-140: single source of truth for every visible and
     accessible header cart count. */
  window.__setCartCount = function (count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
    document.querySelectorAll('[data-cart-link]').forEach(function (el) {
      var label = el.getAttribute('data-cart-label') || '';
      el.setAttribute('aria-label', label + ' (' + count + ')');
    });
  };

  /* Lines whose "move to wishlist" is still waiting on Swym, and the last cart
     the SERVER gave us. Together they let the drawer paint the bag as it will be
     the moment the add lands, without removing anything yet — see the
     move-to-wishlist handler in bindItemEvents. */
  var movingKeys = {};
  var movingCount = 0;
  var lastCart = null;

  /* A copy of `cart` with `keys` taken out and the two totals renderCart reads
     brought in line. Optimistic only: every server response replaces it, so this
     never has to agree with Shopify on cart-level discounts. */
  function cartWithout(cart, keys) {
    var view = {};
    Object.keys(cart).forEach(function (k) { view[k] = cart[k]; });
    var droppedOriginal = 0;
    var droppedFinal = 0;
    view.items = cart.items.filter(function (i) {
      if (!keys[i.key]) return true;
      droppedOriginal += i.original_line_price;
      droppedFinal += i.final_line_price;
      return false;
    });
    view.original_total_price = Math.max(0, (cart.original_total_price || 0) - droppedOriginal);
    view.items_subtotal_price = Math.max(0, (cart.items_subtotal_price || 0) - droppedFinal);
    return view;
  }

  function renderCart(cart) {
    /* Never paint the bag from a body we can't confirm is a cart. The empty-state
       branch below is indistinguishable, on screen, from "the shopper's bag was
       wiped" — so an error/challenge payload reaching here reads as data loss.
       Callers validate via asCart(); this is the backstop. */
    if (!cart || !Array.isArray(cart.items)) return;
    lastCart = cart;
    /* Applied on EVERY paint, not just the optimistic one: an unrelated quantity
       edit landing mid-move would otherwise bring a line the shopper has already
       moved straight back onto the screen. */
    var optimistic = movingCount > 0;
    if (optimistic) cart = cartWithout(cart, movingKeys);
    itemsEl.innerHTML = '';
    var count = cart.items.reduce(function(sum, i) { return sum + i.quantity; }, 0);
    /* Sync header cart count badge(s) from the same cart object as the line items. */
    window.__setCartCount(count);
    if (cart.items.length === 0) {
      itemsEl.innerHTML = '<div class="cart-drawer__empty"><p>' + CFG.emptyTitle + '</p></div>';
      if (footerEl) footerEl.style.display = 'none';
      return;
    }
    cart.items.forEach(function (item) {
      itemsEl.appendChild(renderItem(item));
    });
    if (footerEl) footerEl.style.display = '';
    var allGiftCards = cart.items.every(function (item) { return !item.requires_shipping; });
    var shippingRowEl = document.getElementById('cart-drawer-shipping-row');
    if (shippingRowEl) shippingRowEl.style.display = allGiftCards ? 'none' : '';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.original_total_price);
    if (shippingValueEl) {
      /* Threshold in the SHOPPER'S currency. window.BonvaleFreeShipping converts
         the ROW USD figure using shop_cents (daily worker cron) × the live
         Shopify.currency.rate; localCents is null only when that conversion is
         unavailable. Falling back to the raw metafield cents is only valid when
         it is already the shopper's currency — otherwise we would subtract USD
         from THB. See snippets/free-shipping-data. */
      var fsData = window.BonvaleFreeShipping;
      var thresholdCents = (fsData && fsData.localCents != null)
        ? fsData.localCents
        : (FREE_THRESHOLD_COMPARABLE ? FREE_THRESHOLD_CENTS : null);
      var remaining = thresholdCents == null ? null : thresholdCents - cart.items_subtotal_price;
      if (remaining === null) {
        /* No trustworthy local figure: state the threshold, never a fabricated distance. */
        shippingValueEl.className = 'cart-drawer__shipping-value';
        shippingValueEl.textContent = SHIPPING_OVER_TEXT.replace(
          '__AMOUNT__', (fsData && fsData.text) || FREE_THRESHOLD_TEXT);
      } else if (remaining <= 0) {
        shippingValueEl.className = 'cart-drawer__shipping-value cart-drawer__shipping-value--free';
        shippingValueEl.textContent = SHIPPING_FREE;
      } else {
        shippingValueEl.className = 'cart-drawer__shipping-value';
        shippingValueEl.innerHTML = SHIPPING_AWAY_BEFORE +
          '<span class="cart-drawer__shipping-amount">' + formatMoney(remaining) + '</span>' +
          SHIPPING_AWAY_AFTER;
      }
    }
    /* Sync Klaviyo cart attributes (subtotal + free-shipping progress) after any
       drawer mutation, so they're current when checkout is started from the drawer.
       Only from a SERVER cart: an optimistic view would publish a subtotal the
       shop does not hold yet, and the move it anticipates can still fail.
       See snippets/cart-klaviyo-attrs.liquid. */
    if (!optimistic && window.bvSyncCartAttrs) window.bvSyncCartAttrs(cart);
    bindItemEvents();
  }

  /* A cart response is only trustworthy when the request SUCCEEDED and the body
     actually has the shape of a cart. These endpoints can answer with a non-cart
     JSON body (Shopify error payloads, rate-limit / bot-challenge responses), and
     the old code fed whatever `.json()` produced straight into renderCart — where
     a missing `items` array fell through to the empty-state branch and told the
     shopper their whole bag was gone, seconds after they removed ONE line. The
     cart page never had this failure mode because it re-reads from the server
     (location.reload) after every mutation instead of rendering the response. */
  function asCart(res) {
    if (!res.ok) throw new Error('cart request failed: ' + res.status);
    return res.json().then(function (body) {
      if (!body || !Array.isArray(body.items)) throw new Error('not a cart response');
      return body;
    });
  }

  /* QA #12: rapid add/remove fires overlapping /cart.js reads; without a guard a
     slow earlier response can land after a newer one and repaint the drawer +
     badge with a stale count. Tag each read and drop any that a later read has
     already superseded. */
  var cartFetchSeq = 0;
  function fetchAndRender(callback, isRetry) {
    var seq = ++cartFetchSeq;
    fetch(LOCALE_ROOT + '/cart.js')
      .then(asCart)
      .then(function (cart) {
        if (seq !== cartFetchSeq) return;
        renderCart(cart);
        if (callback) callback();
      })
      .catch(function () {
        if (seq !== cartFetchSeq) return;
        /* One retry absorbs a transient blip. If the second read is also unusable
           we can neither leave the skeleton up forever nor claim the bag is empty,
           so reload and let the server render the cart it actually holds. */
        if (!isRetry) {
          setTimeout(function () { fetchAndRender(callback, true); }, 600);
          return;
        }
        if (callback) callback();
        window.location.reload();
      });
  }

  function setBusy(busy) {
    if (busyEl) {
      busyEl.classList.toggle('is-visible', !!busy);
      busyEl.setAttribute('aria-hidden', busy ? 'false' : 'true');
    }
  }

  /* BUG-BV-28: the READ path above was sequenced but this WRITE path was not — it
     painted whatever /cart/change.js answered, whenever it answered. Hammer +/-/
     Remove and the responses come back out of order, so an older one repaints the
     drawer over a newer one: the quantity jumps back, or a line the shopper
     already removed returns.

     The fix is to put writes on the SAME counter as reads, not a counter of their
     own — a change and a re-read are both "the drawer's idea of the cart", and
     only the newest of either may paint. Superseded responses are dropped; the
     newest one clears the busy overlay, so nothing is left spinning. */
  /* QA BUG-BV-28 (second half): dropping stale RESPONSES keeps the UI honest but does
     nothing about the writes themselves. Measured on the staging theme, two overlapping
     edits (→5 then →2) reached Shopify in the reverse order: the sequence guard correctly
     painted 2, but the server had settled on 5 — the drawer and the real cart disagreed,
     and checkout would have used 5. So writes are also SERIALISED: only one
     /cart/change.js may be in flight, so the order Shopify applies is the order the
     shopper performed. The chain must survive a rejection (`.then(run, run)`) or one
     failed edit would silently swallow every later one. */
  var cartWriteChain = Promise.resolve();

  function trackCartGa4(name, data) {
    if (window.BonvaleAnalytics && window.BonvaleAnalytics.trackGa4) {
      window.BonvaleAnalytics.trackGa4(name, data || {});
    }
  }

  function changeQty(key, quantity) {
    setBusy(true);
    var seq = ++cartFetchSeq;
    var previous = lastCart && lastCart.items.filter(function (i) { return i.key === key; })[0];
    var previousQty = previous ? previous.quantity : null;
    var run = function () { return sendQty(key, quantity, seq, previousQty); };
    cartWriteChain = cartWriteChain.then(run, run);
    return cartWriteChain;
  }

  function sendQty(key, quantity, seq, previousQty) {
    return fetch(LOCALE_ROOT + '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
    .then(asCart)
    .then(function (cart) {
      if (seq !== cartFetchSeq) return { ok: true, stale: true, cart: cart };
      /* change.js clamps to available stock and still returns 200, so a returned
         quantity below what we asked for means we hit the cap. */
      var returned = cart.items.filter(function (i) { return i.key === key; })[0];
      if (returned && quantity > 0 && returned.quantity < quantity) {
        atMaxKeys[key] = true;
      } else {
        delete atMaxKeys[key];
      }
      renderCart(cart);
      setBusy(false);
      if (quantity > 0 && previousQty !== null && returned && returned.quantity !== previousQty) {
        trackCartGa4('cart_quantity_change', {
          cart_surface: 'drawer',
          previous_quantity: previousQty,
          quantity: returned.quantity,
          item_id: String(returned.product_id || ''),
          item_variant_id: String(returned.variant_id || '')
        });
      }
      return { ok: true, cart: cart };
    })
    .catch(function () {
      if (seq !== cartFetchSeq) return { ok: false, stale: true };
      fetchAndRender(function(){ setBusy(false); });
      return { ok: false };
    });
  }

  /* Pending quantity edits, keyed by cart line. See the note on the stepper below. */
  var QTY_COALESCE_MS = 400;
  var pendingQty = {};

  function scheduleQty(key, quantity) {
    if (pendingQty[key]) clearTimeout(pendingQty[key].timer);
    pendingQty[key] = {
      quantity: quantity,
      timer: setTimeout(function () {
        delete pendingQty[key];
        changeQty(key, quantity);
      }, QTY_COALESCE_MS)
    };
  }

  /* Drop a coalesced edit without sending it. Removing a line MUST do this first:
     the edit is debounced by QTY_COALESCE_MS, so "+ then Remove" inside that window
     queued the removal and then let the stale timer fire changeQty(key, <old qty>)
     straight after it — the line the shopper just deleted came back. Immediate
     writes could not hit this before the edits were coalesced; sections/cart.liquid
     guards the same way on its own remove path. */
  function cancelPendingQty(key) {
    if (!pendingQty[key]) return;
    clearTimeout(pendingQty[key].timer);
    delete pendingQty[key];
  }

  /* Send every coalesced edit NOW. Anything that leaves the drawer — above all
     checkout — must call this first, or the last clicks would never reach the cart. */
  function flushPendingQty() {
    var jobs = Object.keys(pendingQty).map(function (key) {
      var p = pendingQty[key];
      clearTimeout(p.timer);
      delete pendingQty[key];
      return changeQty(key, p.quantity);
    });
    return jobs.length ? Promise.all(jobs) : null;
  }

  /* Checkout is a plain link, so a coalesced edit still in its window would be
     abandoned mid-navigation. Hold the click just long enough to land it. */
  document.addEventListener('click', function (e) {
    var link = e.target.closest && e.target.closest('.cart-drawer__checkout');
    if (!link) return;
    var flushing = flushPendingQty();
    if (!flushing) return;
    e.preventDefault();
    var href = link.getAttribute('href');
    flushing.then(function () { window.location.href = href; })
            .catch(function () { window.location.href = href; });
  }, true);

  function bindItemEvents() {
    itemsEl.querySelectorAll('.cart-drawer__item').forEach(function (itemEl) {
      var key = itemEl.dataset.key;
      var input = itemEl.querySelector('[data-qty-input]');
      var minus = itemEl.querySelector('[data-minus]');
      var plus = itemEl.querySelector('[data-plus]');
      var remove = itemEl.querySelector('[data-remove]');
      var moveWishlist = itemEl.querySelector('[data-move-wishlist]');
      var editLine = itemEl.querySelector('[data-edit-line]');

      /* Quick Edit: open the side panel preloaded with this line's product and
         options; confirming swaps the line to the newly selected variant. */
      if (editLine) editLine.addEventListener('click', function () {
        var item = itemEl.__item;
        if (!item || !item.handle) return;
        openDetail(item.handle, {
          preselect: item.options_with_values || [],
          edit: { key: item.key, quantity: item.quantity, variantId: item.variant_id }
        });
      });

      /* QA BUG-BV-04: the stepper used to fire one /cart/change round trip per click and
         cover the drawer while each one flew, so tapping "+" three times meant three
         full waits. The typed number is already local and instant — it is the request
         that lags. Coalesce a burst of clicks into a single change for the FINAL
         quantity. Money is still rendered from the server response, never computed
         here, so discounts and thresholds cannot drift. */
      if (minus) minus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) { input.value = val - 1; scheduleQty(key, val - 1); }
      });
      if (plus) plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 0;
        input.value = val + 1; scheduleQty(key, val + 1);
      });
      if (input) input.addEventListener('change', function () {
        var val = parseInt(input.value, 10);
        /* Coalesced like the +/- steppers: typing over the field can fire several change
           events in quick succession, and collapsing them at the source is cheaper than
           serialising the requests they would otherwise produce. */
        if (!isNaN(val) && val >= 0) scheduleQty(key, val);
      });
      if (remove) remove.addEventListener('click', function () {
        cancelPendingQty(key);
        changeQty(key, 0);
      });
      if (moveWishlist) moveWishlist.addEventListener('click', function () {
        /* A MOVE: the line may only go once the wishlist add has actually landed.
           Swym fails often enough to matter (see sections/cart.liquid), and
           removing regardless deleted the shopper's item with nothing saved.

           What changed is the WAIT, not the order. Wishlist.toggle() budgets 12s
           (5s per call plus two retries) and this used to hold the busy overlay
           over the drawer for all of it. Now the bag repaints WITHOUT the line
           straight away — row, count badge, subtotal and free-shipping bar all
           move together, so nothing on screen contradicts anything else — the add
           runs in the background, and the line is removed for real only once it
           succeeds. If it fails the line comes back and we say so. */
        if (!window.Wishlist) return;
        if (movingKeys[key]) return;

        if (window.Wishlist.isWishlisted(moveWishlist.dataset.productId)) {
          cancelPendingQty(key);
          changeQty(key, 0);   /* already saved, safe to drop the line */
          return;
        }

        function release() {
          if (!movingKeys[key]) return;
          delete movingKeys[key];
          movingCount--;
        }

        movingKeys[key] = true;
        movingCount++;
        /* toggle() reads its product data off the element, so it has to be called
           before the repaint below replaces every row in the list. */
        var adding = Promise.resolve(window.Wishlist.toggle(moveWishlist));
        if (lastCart) renderCart(lastCart);

        adding.then(function (result) {
          if (result && result.ok) {
            cancelPendingQty(key);
            /* Hold the line hidden until the server confirms it is gone, so a
               repaint in between cannot flash it back. */
            changeQty(key, 0).then(function (changeResult) {
              if (changeResult && changeResult.ok && changeResult.cart &&
                  !changeResult.cart.items.some(function (i) { return i.key === key; })) {
                trackCartGa4('move_to_wishlist', {
                  cart_surface: 'drawer',
                  item_id: moveWishlist.dataset.productId || '',
                  item_variant_id: moveWishlist.dataset.variantId || ''
                });
              }
              release();
            }, release).then(function () {
              /* That write can still fail (Shopify throttles cart bursts), and
                 the filter that was hiding the line is now released — so a line
                 that survived has to be repainted, not left invisible with the
                 subtotal short by its price. */
              var survived = lastCart && lastCart.items.some(function (i) { return i.key === key; });
              if (survived) renderCart(lastCart);
            });
            return;
          }
          /* Keep it in the bag — losing it is worse than not moving it. Silent to
             the shopper for the same reason as the cart page (see sections/cart.liquid):
             renderCart has just put the line back, so there is nothing to explain and
             nothing they could do about a Swym-side failure anyway. */
          release();
          if (lastCart) renderCart(lastCart);
          if (window.console && console.warn) {
            console.warn('[cart-drawer] move to wishlist failed; item kept in bag');
          }
        });
      });
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (!drawer.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    /* BUG-BV-85: wrap Tab at the ends so focus can't reach the (inert) page even
       on browsers without inert support. */
    if (e.key === 'Tab') {
      var f = cdFocusables();
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      else if (!drawer.contains(document.activeElement)) { e.preventDefault(); first.focus(); }
    }
  });

  /* After adding to cart: desktop opens the drawer, mobile navigates to /cart page */
  function showCartAfterAdd() {
    if (window.innerWidth <= 768) {
      window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
      return;
    }
    openDrawerWithSkeleton();
    fetchAndRender();
  }

  /* Intercept add-to-bag form submit on all devices */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.hasAttribute('data-product-form')) return;

    e.preventDefault();

    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) { btn.disabled = true; btn.textContent = '...'; }

    var isDesktop = window.innerWidth > 768;
    if (isDesktop) {
      openDrawerWithSkeleton();
    } else if (loadingEl) {
      loadingEl.setAttribute('aria-hidden', 'false');
      loadingEl.classList.add('is-visible');
    }

    var formData = new FormData(form);
    fetch(LOCALE_ROOT + '/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
    /* BUG-BV-29: /cart/add.js rejects a sold-out variant with HTTP 422 and a
       READABLE reason in the body ("The product 'Classic Crew Tee - Navy / L' is
       already sold out."). The old code went straight to r.json(), which parses
       an error body perfectly happily, so a REJECTED add walked into the success
       branch: on desktop the drawer opened without the line, on mobile the
       shopper was sent to an unchanged /cart — no message either way, while
       Shopify had handed us the exact sentence to show. Check the status, and
       surface what the server said. */
    .then(function (r) {
      if (r.ok) return r.json();
      return r.text().then(function (body) {
        var msg = '';
        /* 422 → JSON with `description`. 429 / gateway errors → an HTML page,
           which is exactly the case that used to throw and trigger the resubmit
           below, so parse defensively and fall back to the generic string. */
        try {
          var parsed = JSON.parse(body);
          msg = parsed.description || parsed.message || '';
          /* QA BUG-BV-66: on FIELD-level validation failures Shopify's `description`
             is an object, e.g. {"name":["is too long (maximum is 255 characters)"]}.
             Stringifying that into Error() painted a literal "[object Object]" toast.
             Flatten it to the sentences inside; anything unreadable falls back to
             the generic string below. */
          if (msg && typeof msg === 'object') {
            try {
              msg = Object.keys(msg).map(function (k) {
                var v = msg[k];
                return (Array.isArray(v) ? v : [v]).map(function (s) {
                  return typeof s === 'string' ? (k + ' ' + s) : '';
                }).join('; ');
              }).filter(Boolean).join('; ');
            } catch (e2) { msg = ''; }
          }
          if (typeof msg !== 'string') msg = '';
        } catch (e) { /* not JSON — leave msg empty */ }
        var err = new Error(msg || CFG.addFailed);
        err.readable = true;
        throw err;
      });
    })
    .then(function () {
      if (isDesktop) {
        fetchAndRender();
      } else {
        window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart';
      }
    })
    /* BUG-BV-30: this catch used to be `form.submit()` — a NATIVE re-post of the
       same add. On a 429 or an HTML error page r.json() threw, so the theme
       silently fired a SECOND submission of an add that may well have succeeded
       the first time, and showed no error either way. Never re-submit: undo the
       optimistic UI and tell the shopper what happened. */
    .catch(function (err) {
      if (isDesktop) {
        closeDrawer();
      } else if (loadingEl) {
        loadingEl.classList.remove('is-visible');
        loadingEl.setAttribute('aria-hidden', 'true');
      }
      /* Only a message we actually got from Shopify is fit to show; a thrown
         network error would read as "Failed to fetch". */
      var msg = (err && err.readable && err.message) ? err.message : CFG.addFailed;
      if (window.__showQuickAddToast) window.__showQuickAddToast(msg, true);
    })
    .finally(function () {
      if (btn) {
        btn.disabled = false;
        btn.textContent = btn.dataset.addText || 'Add To Bag';
      }
    });
  }, true);

  /* Expose open/refresh for other scripts (e.g., quick-add-modal "Add to Bag" flow) */
  window.__openCartDrawer = showCartAfterAdd;

  /* ============================================================
     Recently Viewed carousel (localStorage → per-handle fetch)
     ============================================================ */
  (function () {
    var section = drawer.querySelector('[data-cdrv]');
    if (!section) return;
    var viewport = section.querySelector('[data-cdrv-viewport]');
    var track = section.querySelector('[data-cdrv-track]');
    var prev = section.querySelector('[data-cdrv-prev]');
    var next = section.querySelector('[data-cdrv-next]');
    if (!viewport || !track) return;

    var STORAGE_KEY = 'bonvale_recently_viewed';
    var PER_PAGE = 3;
    var totalPages = 0;
    var currentPage = 1;

    function normalize(raw) {
      if (typeof raw === 'string') return { handle: raw };
      if (raw && typeof raw === 'object' && raw.handle) return { handle: raw.handle };
      return null;
    }

    var entries = [];
    try {
      entries = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]').map(normalize).filter(Boolean);
    } catch (e) {}
    if (entries.length === 0) return;
    var handles = entries.map(function (e) { return e.handle; }).slice(0, 9);

    function updateArrows() {
      if (prev) prev.disabled = currentPage <= 1;
      if (next) next.disabled = currentPage >= totalPages;
    }
    function scrollToPage(page) {
      if (page < 1 || page > totalPages) return;
      viewport.scrollTo({ left: (page - 1) * viewport.clientWidth, behavior: 'smooth' });
    }
    function buildPages(cards) {
      track.innerHTML = '';
      totalPages = Math.ceil(cards.length / PER_PAGE);
      for (var p = 1; p <= totalPages; p++) {
        var pageEl = document.createElement('div');
        pageEl.className = 'cart-drawer__rv-page';
        cards.slice((p - 1) * PER_PAGE, p * PER_PAGE).forEach(function (c) { pageEl.appendChild(c); });
        track.appendChild(pageEl);
      }
      currentPage = 1;
      viewport.scrollLeft = 0;
      if (window.Wishlist) window.Wishlist.updateAll();
      updateArrows();
    }

    /* Fetch cards lazily on first drawer open (not page load) and cap
       concurrency — firing one request per handle at load tripped
       Shopify's 429 rate limit alongside the other page-load fetches. */
    var CONCURRENCY = 3;
    var loaded = false;
    function loadCards() {
      if (loaded) return;
      loaded = true;
      var fetched = 0;
      var nextIndex = 0;
      var cardSlots = new Array(handles.length);
      function fetchOne() {
        if (nextIndex >= handles.length) return;
        var index = nextIndex++;
        fetch(LOCALE_ROOT + '/products/' + handles[index] + '?section_id=recently-viewed-card-cart')
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            var card = tmp.querySelector('.product-card');
            if (card) cardSlots[index] = card;
          })
          .catch(function () {})
          .finally(function () {
            fetched++;
            if (fetched === handles.length) {
              var cards = cardSlots.filter(Boolean);
              if (cards.length === 0) return;
              section.style.display = '';
              buildPages(cards);
            } else {
              fetchOne();
            }
          });
      }
      for (var i = 0; i < CONCURRENCY && i < handles.length; i++) fetchOne();
    }
    drawer.__cdrvLoad = loadCards;

    viewport.addEventListener('scroll', function () {
      requestAnimationFrame(function () {
        var w = viewport.clientWidth;
        if (w === 0) return;
        var page = Math.round(viewport.scrollLeft / w) + 1;
        if (page !== currentPage) { currentPage = page; updateArrows(); }
      });
    });
    if (prev) prev.addEventListener('click', function () { scrollToPage(currentPage - 1); });
    if (next) next.addEventListener('click', function () { scrollToPage(currentPage + 1); });
    window.addEventListener('resize', function () {
      viewport.scrollLeft = (currentPage - 1) * viewport.clientWidth;
    });
  })();

  /* ============================================================
     Screen 2: Recommended Product (in-drawer mini-PDP)
     ============================================================ */
  var backBtn = document.getElementById('cart-drawer-back');
  var detailCloseBtn = document.getElementById('cart-drawer-detail-close');
  var imagesEl = document.getElementById('cart-drawer-detail-images');
  var navEl = document.getElementById('cart-drawer-detail-nav');
  var navPrev = document.querySelector('[data-detail-prev]');
  var navNext = document.querySelector('[data-detail-next]');
  var nameEl = document.getElementById('cart-drawer-detail-name');
  var priceEl = document.getElementById('cart-drawer-detail-price');
  var optionsEl = document.getElementById('cart-drawer-detail-options');
  var oosEl = document.getElementById('cart-drawer-detail-oos');
  var addBtn = document.getElementById('cart-drawer-detail-add');
  var notifyBtn = document.getElementById('cart-drawer-detail-notify');
  var linkEl = document.getElementById('cart-drawer-detail-link');
  var wishlistBtn = document.getElementById('cart-drawer-detail-wishlist');

  var dVariants = [];
  var dOptionNames = [];
  var dSelected = {};
  var dProductUrl = '';
  var dSgOverlay = null;
  var NOTIFY_LABEL = notifyBtn ? notifyBtn.textContent.trim() : '';

  /* Okendo loyalty preview — "Order and receive N Points with Bonvale
     Rewards" under the CTA (Figma 15817:110837). Same public endpoint the
     PDP's Okendo widget calls, keyed by product id; cached, and hidden
     whenever the figure can't be resolved. */
  var rewardsEl = document.getElementById('cart-drawer-detail-rewards');
  var rewardsCache = {};
  var dRewardsProductId = null;
  function loadRewards(productId) {
    if (!rewardsEl) return;
    rewardsEl.style.display = 'none';
    dRewardsProductId = productId || null;
    if (!productId || !CFG.rewardsLineHtml) return;
    var storeId = window.okendoSubscriberId && window.okendoSubscriberId();
    if (!storeId) return;
    var country = drawer.dataset.country || '';
    if (!rewardsCache[productId]) {
      rewardsCache[productId] = fetch(
        'https://api.okendo.io/v1/stores/' + storeId + '/loyalty/product_earning_reward_preview?productId=' + productId + (country ? '&countryCode=' + country : '')
      )
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    rewardsCache[productId].then(function (j) {
      if (dRewardsProductId !== productId) return; /* panel moved on */
      var amount = j && j.maxRewardToEarn && j.maxRewardToEarn.amount;
      if (!amount) return;
      rewardsEl.innerHTML = CFG.rewardsLineHtml.replace('__PTS__', amount);
      rewardsEl.style.display = '';
    });
  }
  /* Quick Edit state: {key, quantity, variantId} of the cart line being edited,
     or null when the panel is a plain Quick Add. */
  var dEdit = null;
  /* Detail loads are async and the shopper fires several in a row (Style /
     Colour switches). Only the LATEST one may paint — a slower earlier response
     landing last used to overwrite the panel with the wrong product. */
  var dLoadToken = 0;
  /* Per-handle cache of the two responses a detail render needs. Switching back
     and forth between siblings is the normal way to use the panel, and every
     switch used to cost two storefront requests — Shopify throttles that:
     measured on staging 2026-09-04, ~30 quick switches got HTTP 429 on both the
     `?section_id=` render and the `.js` endpoint, and the only failure path was
     goToBag(), which showed the bag's EXISTING line and read as "it added
     something I never picked" (Lawrence 2026-09-04). Cached entries expire so
     availability cannot go stale for a whole session. */
  var dDetailCache = {};
  var DETAIL_CACHE_TTL = 5 * 60 * 1000;
  var dLastGoodHandle = '';

  function fetchDetailResource(url, attempt) {
    attempt = attempt || 1;
    return fetch(url).then(function (r) {
      if (r.status === 429 && attempt < 3) {
        var ra = parseInt(r.headers.get('Retry-After'), 10);
        var wait = isNaN(ra) ? 1500 * attempt : Math.min(ra * 1000, 3000);
        return new Promise(function (res) { setTimeout(res, wait); }).then(function () {
          return fetchDetailResource(url, attempt + 1);
        });
      }
      if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + url);
      return r;
    }, function (err) {
      if (attempt < 3) {
        return new Promise(function (res) { setTimeout(res, 1500 * attempt); }).then(function () {
          return fetchDetailResource(url, attempt + 1);
        });
      }
      throw err;
    });
  }

  /* Never show the shopper an error here (Lawrence 2026-09-04). After the
     retries are spent, quietly return to the product that was on screen before
     the failed switch — it renders from cache, no request — or, if nothing was
     ever loaded in this panel, take them to the product page, which always
     works. */
  function recoverDetailLoad(token, handle, opts) {
    if (token !== dLoadToken) return;
    var last = dLastGoodHandle && dDetailCache[dLastGoodHandle];
    if (last && last.handle !== handle) {
      openDetail(dLastGoodHandle, opts);
      return;
    }
    window.location.href = LOCALE_ROOT + '/products/' + handle;
  }

  function goToBag() {
    drawer.classList.remove('is-detail');
    dEdit = null;
  }
  function goToDetail() {
    drawer.classList.add('is-detail');
    var body = drawer.querySelector('.cart-drawer__detail-body');
    if (body) body.scrollTop = 0;
  }

  function closeDSgOverlay() {
    if (!dSgOverlay) return;
    dSgOverlay.classList.remove('sg-overlay--open');
    dSgOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = 'hidden'; /* drawer is still open */
    setTimeout(function () { if (dSgOverlay) dSgOverlay.style.display = 'none'; }, 400);
  }
  function openDSgOverlay() {
    if (!dSgOverlay) return;
    dSgOverlay.style.display = '';
    dSgOverlay.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () { dSgOverlay.classList.add('sg-overlay--open'); });
  }
  function bindDSgOverlay(o) {
    o.querySelectorAll('[data-sg-close]').forEach(function (btn) { btn.addEventListener('click', closeDSgOverlay); });
    o.addEventListener('click', function (e) { if (e.target === o) closeDSgOverlay(); });
    var tabs = o.querySelectorAll('[data-sg-tab]');
    var panels = o.querySelectorAll('[data-sg-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = this.dataset.sgTab;
        tabs.forEach(function (t) { t.classList.remove('sg-modal__tab--active'); });
        this.classList.add('sg-modal__tab--active');
        panels.forEach(function (p) { p.style.display = p.dataset.sgPanel === target ? '' : 'none'; });
      });
    });
    var unitBtns = o.querySelectorAll('[data-sg-unit]');
    var unitTables = o.querySelectorAll('[data-sg-table]');
    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = this.dataset.sgUnit;
        unitBtns.forEach(function (b) { b.classList.remove('sg-modal__unit--active'); });
        this.classList.add('sg-modal__unit--active');
        unitTables.forEach(function (t) { t.style.display = t.dataset.sgTable === unit ? '' : 'none'; });
      });
    });
  }
  function removeDSgOverlay() {
    if (dSgOverlay && dSgOverlay.parentNode) { dSgOverlay.parentNode.removeChild(dSgOverlay); }
    dSgOverlay = null;
  }

  /* Size Guide + combined-listing switches inside the detail screen. A
     combined option value (e.g. the other Fit) is rendered by
     quick-add-options as an <a> to the SIBLING product — without this it
     navigates the whole page away mid-quick-add. Reload the panel on the
     sibling instead, carrying any Quick Edit context through. */
  optionsEl.addEventListener('click', function (e) {
    var sw = e.target.closest('a[data-qa-switch-handle]');
    if (sw) {
      e.preventDefault();
      e.stopPropagation();
      var keepEdit = dEdit;
      openDetail(sw.dataset.qaSwitchHandle, keepEdit ? { edit: keepEdit } : undefined);
      return;
    }
    var btn = e.target.closest('[data-sg-open]');
    if (btn) {
      e.preventDefault();
      e.stopPropagation();
      openDSgOverlay();
    }
  });

  function findDVariant() {
    return dVariants.find(function (v) {
      return dOptionNames.every(function (_, i) { return v.options[i] === dSelected[i]; });
    });
  }

  /* Add To Bag tapped with a required option (a real Size, data-option-required)
     still unchosen: same feedback as the PDP and the quick-add modal — the Size
     caption becomes the red "Please select a size" (data-error, rendered by
     quick-add-options) and the chips get the red border, via the shared
     .product-info__sizes--error state. Cleared as soon as a chip is picked.
     Before this the click fell through `if (!match) return` and did nothing
     (Lawrence, in-drawer quick add for the socks 3-pack, 2026-09-08). */
  function dMissingRequired() {
    var out = [];
    optionsEl.querySelectorAll('[data-option-required="true"]').forEach(function (container) {
      var idx = parseInt(container.dataset.optionIndex);
      if (dSelected[idx] == null || dSelected[idx] === '') out.push(container);
    });
    return out;
  }
  function showDRequiredErrors(containers) {
    containers.forEach(function (container) {
      container.classList.add('product-info__sizes--error');
      var valEl = container.querySelector('[data-size-value]');
      if (valEl && valEl.dataset.error) valEl.textContent = valEl.dataset.error;
    });
    if (containers[0]) containers[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function updateDetailState() {
    var match = findDVariant();
    if (!match) return;

    var priceSpan = priceEl.querySelector('[data-pg-price]');
    var compareSpan = priceEl.querySelector('[data-pg-compare]');
    if (priceSpan) priceSpan.textContent = formatMoney(match.price);
    if (compareSpan) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareSpan.textContent = formatMoney(match.compare_at_price);
        compareSpan.style.display = '';
      } else {
        compareSpan.style.display = 'none';
      }
    }

    optionsEl.querySelectorAll('[data-option-value]').forEach(function (btn) {
      var idx = parseInt(btn.dataset.optionIndex);
      var isActive = dSelected[idx] === btn.dataset.optionValue;
      if (btn.classList.contains('product-info__color-swatch')) {
        btn.classList.toggle('product-info__color-swatch--active', isActive);
      }
      if (btn.classList.contains('product-info__size-btn')) {
        btn.classList.toggle('product-info__size-btn--active', isActive);
      }
    });

    var colorContainer = optionsEl.querySelector('[data-option-type="color"]');
    if (colorContainer) {
      var colorIdx = parseInt(colorContainer.dataset.optionIndex);
      var activeBtn = colorContainer.querySelector('.product-info__color-swatch--active');
      var activeGroup = activeBtn ? activeBtn.dataset.colorGroup : '';
      colorContainer.querySelectorAll('.product-info__color-group').forEach(function (grp) {
        var valEl = grp.querySelector('[data-color-value]');
        if (grp.dataset.colorGroup === activeGroup) {
          if (valEl) valEl.textContent = dSelected[colorIdx] || '';
        } else {
          if (valEl) valEl.remove();
        }
      });
      if (!colorContainer.querySelector('[data-color-group]')) {
        var colorValueEl = colorContainer.querySelector('[data-color-value]');
        if (colorValueEl) colorValueEl.textContent = dSelected[colorIdx] || '';
      }
    }

    optionsEl.querySelectorAll('[data-option-type="size"]').forEach(function (container) {
      var optIdx = parseInt(container.dataset.optionIndex);
      var valueEl = container.querySelector('[data-size-value]');
      if (!valueEl) return;
      if (dSelected[optIdx]) {
        valueEl.textContent = dSelected[optIdx];
      } else if (!container.classList.contains('product-info__sizes--error')) {
        valueEl.textContent = '';
      }
    });

    /* Sold-out selection: red "Out of stock" beside the Size label (Figma
       15866:149863) — on the LAST size-type group (a pant renders Fit and
       Size through the same picker markup; only the true size row carries
       the status). */
    var sizeGroups = optionsEl.querySelectorAll('[data-option-type="size"]');
    var lastSizeGroup = sizeGroups[sizeGroups.length - 1];
    if (lastSizeGroup) {
      var sizeValueEl = lastSizeGroup.querySelector('[data-size-value]');
      if (sizeValueEl) {
        if (!match.available) {
          sizeValueEl.textContent = CFG.outOfStock;
          sizeValueEl.classList.add('product-info__option-value--oos');
        } else {
          sizeValueEl.classList.remove('product-info__option-value--oos');
        }
      }
    }

    if (match.available) {
      addBtn.style.display = '';
      notifyBtn.style.display = 'none';
      oosEl.style.display = 'none';
      addBtn.textContent = dEdit ? CFG.update : CFG.addToBag;
    } else {
      addBtn.style.display = 'none';
      notifyBtn.style.display = '';
      oosEl.style.display = '';
    }
  }

  function openDetail(handle, opts) {
    dEdit = (opts && opts.edit) || null;
    /* Skeletons */
    imagesEl.innerHTML =
      '<div class="cart-drawer__detail-skeleton cart-drawer__detail-skeleton--image"></div>' +
      '<div class="cart-drawer__detail-skeleton cart-drawer__detail-skeleton--image"></div>';
    if (navEl) navEl.style.display = 'none';
    nameEl.innerHTML = '<span class="cart-drawer__detail-skeleton cart-drawer__detail-skeleton--text" style="width:70%"></span>';
    priceEl.innerHTML = '<span class="cart-drawer__detail-skeleton cart-drawer__detail-skeleton--text" style="width:30%"></span>';
    optionsEl.innerHTML =
      '<span class="cart-drawer__detail-skeleton cart-drawer__detail-skeleton--text" style="width:40%;margin-bottom:12px"></span>' +
      '<span class="cart-drawer__detail-skeleton cart-drawer__detail-skeleton--row"></span>';
    oosEl.style.display = 'none';
    addBtn.style.display = '';
    /* Label follows the MODE, so set it here rather than only in
       updateDetailState() (Dux 2026-08-11). That function bails at `if (!match)
       return` whenever no variant resolves — which is every quick ADD of a
       product whose size starts unselected — so the button kept whatever text
       the previous quick EDIT left on it and read "Update" on a fresh add. */
    addBtn.textContent = dEdit ? CFG.update : CFG.addToBag;
    notifyBtn.style.display = 'none';
    notifyBtn.disabled = false;
    notifyBtn.classList.remove('is-subscribed');
    if (NOTIFY_LABEL) notifyBtn.textContent = NOTIFY_LABEL;
    loadRewards(null);
    dVariants = [];
    dOptionNames = [];
    dSelected = {};
    removeDSgOverlay();

    goToDetail();

    var token = ++dLoadToken;
    var cached = dDetailCache[handle];
    if (cached && Date.now() - cached.at < DETAIL_CACHE_TTL) {
      renderDetail(token, handle, opts, cached.html, cached.product);
      return;
    }

    var sectionFetch = fetchDetailResource(LOCALE_ROOT + '/products/' + handle + '?section_id=quick-add-options').then(function (r) { return r.text(); });
    var productFetch = fetchDetailResource(LOCALE_ROOT + '/products/' + handle + '.js').then(function (r) { return r.json(); });

    Promise.all([sectionFetch, productFetch]).then(function (results) {
      /* A newer switch superseded this load — its own response paints. */
      if (token !== dLoadToken) return;
      var html = results[0];
      var product = results[1];
      if (html.indexOf('data-qa-product-json') === -1) throw new Error('quick-add-options: no product root for ' + handle);
      dDetailCache[handle] = { handle: handle, html: html, product: product, at: Date.now() };
      renderDetail(token, handle, opts, html, product);
    }).catch(function (err) {
      console.error('Quick add panel load error:', err);
      recoverDetailLoad(token, handle, opts);
    });
  }

  function renderDetail(token, handle, opts, html, product) {
    if (token !== dLoadToken) return;
    var preselect = (opts && opts.preselect) || null;
    try {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var root = tmp.querySelector('[data-qa-product-json]');
      if (!root) throw new Error('quick-add-options: no product root for ' + handle);

      dProductUrl = root.dataset.productUrl;
      nameEl.textContent = root.dataset.productTitle;
      linkEl.href = dProductUrl;
      loadRewards(root.dataset.productId || null);

      if (wishlistBtn) {
        wishlistBtn.dataset.productId = root.dataset.productId || '';
        wishlistBtn.dataset.variantId = root.dataset.productVariantId || '';
        wishlistBtn.dataset.productUrl = dProductUrl;
        wishlistBtn.dataset.productTitle = root.dataset.productTitle;
        wishlistBtn.dataset.productPrice = root.dataset.productPrice || '';
        wishlistBtn.dataset.productImage = root.dataset.productImage || '';
        if (window.Wishlist) window.Wishlist.updateAll();
      }

      var variantsJson = tmp.querySelector('[data-qa-variants]');
      var optionsJson = tmp.querySelector('[data-qa-options-json]');
      dVariants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
      dOptionNames = optionsJson ? JSON.parse(optionsJson.textContent) : [];

      var priceHtml = tmp.querySelector('.qa-options__prices');
      if (priceHtml) {
        var pSpan = priceHtml.querySelector('.qa-options__price');
        var cSpan = priceHtml.querySelector('.qa-options__compare');
        if (pSpan) pSpan.setAttribute('data-pg-price', '');
        if (cSpan) cSpan.setAttribute('data-pg-compare', '');
        priceEl.innerHTML = '';
        priceEl.appendChild(priceHtml);
      }

      optionsEl.innerHTML = '';
      /* .product-info__hidden-option carries a suppressed combined-listing duplicate
         Color's selected value — without it findDVariant() never resolves. */
      tmp.querySelectorAll('.product-info__colors, .product-info__sizes, .product-info__hidden-option').forEach(function (p) {
        optionsEl.appendChild(p);
      });

      dSelected = {};
      optionsEl.querySelectorAll('.product-info__color-swatch--active, .product-info__size-btn--active').forEach(function (btn) {
        dSelected[parseInt(btn.dataset.optionIndex)] = btn.dataset.optionValue;
      });

      /* Quick Edit: preload the edited line's choices over the defaults. Names
         come from /cart.js options_with_values and match product.options — both
         are the storefront-locale option names. */
      if (preselect) {
        preselect.forEach(function (opt) {
          var idx = dOptionNames.findIndex(function (n) {
            return (n || '').toLowerCase() === (opt.name || '').toLowerCase();
          });
          if (idx >= 0) dSelected[idx] = opt.value;
        });
      }

      optionsEl.querySelectorAll('[data-option-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          dSelected[parseInt(this.dataset.optionIndex)] = this.dataset.optionValue;
          var errContainer = this.closest('.product-info__sizes--error');
          if (errContainer) errContainer.classList.remove('product-info__sizes--error');
          updateDetailState();
        });
      });

      updateDetailState();

      var srcs = (product.images || []);
      var fallback = root.dataset.productImage || '';
      if (srcs.length === 0 && fallback) srcs = [fallback];
      imagesEl.innerHTML = '';
      srcs.forEach(function (src) {
        var img = document.createElement('img');
        /* Was `src.replace(/\.([^.]+)$/, '_800x.$1')`, which appended the legacy
           size suffix AFTER the query string on these URLs (they already carry
           `?v=…&width=…`). Query parameters are the supported form and are the
           only way to pin `quality`. */
        img.src = cdnResize(src, 800);
        img.alt = product.title;
        imagesEl.appendChild(img);
      });
      imagesEl.scrollLeft = 0;
      if (navEl) navEl.style.display = srcs.length > 1 ? '' : 'none';

      var sgFromFetch = tmp.querySelector('.sg-overlay');
      if (sgFromFetch) {
        sgFromFetch.setAttribute('data-qa-sg-injected', '');
        sgFromFetch.style.display = 'none';
        document.body.appendChild(sgFromFetch);
        dSgOverlay = sgFromFetch;
        bindDSgOverlay(dSgOverlay);
      }
      dLastGoodHandle = handle;
    } catch (err) {
      console.error('Quick add panel render error:', err);
      delete dDetailCache[handle];
      recoverDetailLoad(token, handle, opts);
    }
  }

  /* Add to bag from the detail screen → refresh the bag and slide back.
     In Quick Edit mode the same button swaps the edited line instead: add the
     newly selected variant at the line's quantity FIRST, then remove the old
     line — ordered so a failed add can never delete the shopper's item. */
  addBtn.addEventListener('click', function () {
    var missing = dMissingRequired();
    if (missing.length) { showDRequiredErrors(missing); return; }
    var match = findDVariant();
    if (!match || !match.available) return;

    if (dEdit) {
      var edit = dEdit;
      if (match.id === edit.variantId) { goToBag(); return; }
      addBtn.classList.add('is-loading');
      setBusy(true);
      fetch(LOCALE_ROOT + '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: match.id, quantity: edit.quantity }] })
      })
      .then(function (res) { if (!res.ok) throw new Error(); return res.json(); })
      .then(function () {
        /* Route the removal through the serialised write chain so it can't
           race a coalesced +/- edit; changeQty repaints from the response. */
        cancelPendingQty(edit.key);
        return changeQty(edit.key, 0);
      })
      .then(function () {
        setBusy(false);
        goToBag();
      })
      .catch(function () {
        setBusy(false);
        fetchAndRender();
        if (window.__showQuickAddToast) window.__showQuickAddToast(CFG.addFailed, true);
      })
      .finally(function () { addBtn.classList.remove('is-loading'); });
      return;
    }

    addBtn.classList.add('is-loading');
    setBusy(true);
    fetch(LOCALE_ROOT + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: match.id, quantity: 1 }] })
    })
    .then(function (res) { if (!res.ok) throw new Error(); return res.json(); })
    .then(function () {
      fetchAndRender(function () {
        setBusy(false);
        goToBag();
      });
    })
    .catch(function () {
      setBusy(false);
      if (window.__showQuickAddToast) window.__showQuickAddToast(CFG.addFailed, true);
    })
    .finally(function () { addBtn.classList.remove('is-loading'); });
  });

  /* Notify me — Klaviyo back-in-stock without leaving the panel (Figma
     15866:148118 / 147764): logged-in shoppers subscribe directly and the
     button flips to the waitlist confirmation; guests get the bis-modal.
     Falls back to the PDP with the variant preselected if the modal is
     unavailable for any reason. */
  notifyBtn.addEventListener('click', function () {
    if (notifyBtn.classList.contains('is-subscribed')) return;
    var match = findDVariant() || dVariants[0];
    if (!match) return;
    function confirmInline() {
      notifyBtn.classList.add('is-subscribed');
      /* innerHTML, not textContent: `| t` HTML-escapes (the apostrophe in
         "You've" arrives as &#39;) — textContent would paint it literally. */
      notifyBtn.innerHTML = '✓ ' + CFG.waitlistAdded;
    }
    if (window.__bisCustomerEmail && window.__bisSubscribe) {
      notifyBtn.classList.add('is-loading');
      window.__bisSubscribe(match.id, window.__bisCustomerEmail)
        .then(confirmInline)
        .catch(function () {
          if (window.__showQuickAddToast) window.__showQuickAddToast(CFG.addFailed, true);
        })
        .finally(function () { notifyBtn.classList.remove('is-loading'); });
      return;
    }
    if (window.__openBisModal) {
      window.__openBisModal(match.id, confirmInline);
      return;
    }
    var url = linkEl.href;
    url += (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + match.id;
    window.location.href = url;
  });

  if (backBtn) backBtn.addEventListener('click', function () { goToBag(); removeDSgOverlay(); });
  if (detailCloseBtn) detailCloseBtn.addEventListener('click', function () { removeDSgOverlay(); closeDrawer(); });

  /* Gallery arrows — scroll one image (width + gap) per click */
  function detailScrollAmount() {
    var firstImg = imagesEl.querySelector('img');
    return firstImg ? firstImg.offsetWidth + 8 : imagesEl.clientWidth;
  }
  if (navPrev) navPrev.addEventListener('click', function () {
    imagesEl.scrollBy({ left: -detailScrollAmount(), behavior: 'smooth' });
  });
  if (navNext) navNext.addEventListener('click', function () {
    imagesEl.scrollBy({ left: detailScrollAmount(), behavior: 'smooth' });
  });

  /* Quick-add routing (Dux 2026-08-11): on desktop EVERY quick add opens the
     side panel — the drawer slides in already showing the detail screen (Figma
     15817:110514), and the bag is fetched behind it for the back arrow. The
     centred qa-modal is no longer part of the desktop flow; it remains the
     mobile bottom sheet (Figma 15574:130150), reached via the "+" that touch
     devices keep.

     Exposed as its OWN global rather than by wrapping window.__openQuickAdd:
     compiled_assets/snippet-scripts.js concatenates snippet `javascript`
     blocks ALPHABETICALLY, so quick-add-modal (q…) runs after cart-drawer (c…)
     and re-assigns __openQuickAdd — a wrap here is silently overwritten
     (verified on staging 2026-08-11: both assignments present in the bundle,
     modal's at the later offset wins). The [data-quick-add] delegation in
     theme.liquid picks the panel or the modal at CLICK time instead. */
  window.__openQuickAddPanel = function (handle, opts) {
    if (!drawer.classList.contains('is-open')) {
      /* Flip to the detail screen BEFORE opening so the bag never flashes,
         and fetch the bag behind it for the back arrow. */
      goToDetail();
      openDrawer();
      fetchAndRender();
    }
    openDetail(handle, opts);
  };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["collection-guide-strip"] && !Shopify.designMode) return;
  try {
    (function () {
  document.querySelectorAll('[data-collection-guides]').forEach(function (strip) {
    var track = strip.querySelector('[data-guides-track]');
    var prev = strip.querySelector('[data-guides-prev]');
    var next = strip.querySelector('[data-guides-next]');
    if (!track || !prev || !next) return;

    var index = 0;
    var items = track.children.length;
    // 6 cards per view — each card is 1/6 of the row (see stylesheet).
    var maxIndex = Math.max(items - 6, 0);

    function slide() {
      var card = track.children[0];
      if (!card) return;
      var gap = parseFloat(getComputedStyle(track).gap) || 8;
      var step = card.getBoundingClientRect().width + gap;
      track.style.transform = 'translateX(' + (-index * step) + 'px)';
      prev.style.display = index <= 0 ? 'none' : '';
      next.style.display = index >= maxIndex ? 'none' : '';
    }

    next.addEventListener('click', function () {
      if (index < maxIndex) { index++; slide(); }
    });
    prev.addEventListener('click', function () {
      if (index > 0) { index--; slide(); }
    });

    slide();
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cookie-consent"] && !Shopify.designMode) return;
  try {
    (function () {
    var rootEl = document.getElementById('cookie-consent');
    if (!rootEl) return;

    var ACTED_KEY = 'bonvale:cookie:acted';
    var privacy = null;

    function hasUserActed() {
      try { return !!localStorage.getItem(ACTED_KEY); } catch (e) { return false; }
    }
    function markActed() {
      try { localStorage.setItem(ACTED_KEY, '1'); } catch (e) {}
    }

    function showView(name) {
      var views = rootEl.querySelectorAll('[data-view]');
      for (var i = 0; i < views.length; i++) {
        views[i].hidden = views[i].getAttribute('data-view') !== name;
      }
    }

    function showBanner() {
      rootEl.hidden = false;
      showView('banner');
    }

    function showManage() {
      rootEl.hidden = false;
      showView('manage');
      // Pre-fill toggles from current consent
      var current = {};
      try {
        if (privacy && typeof privacy.currentVisitorConsent === 'function') {
          current = privacy.currentVisitorConsent() || {};
        }
      } catch (e) {}
      var toggles = rootEl.querySelectorAll('[data-toggle]');
      for (var i = 0; i < toggles.length; i++) {
        var name = toggles[i].name;
        // Shopify returns 'yes' / 'no' / '' — treat anything truthy except '' / 'no' as on
        var v = current[name];
        toggles[i].checked = v === true || v === 'yes';
      }
    }

    function hideAll() {
      rootEl.hidden = true;
    }

    function setConsent(state) {
      markActed();
      if (!privacy || typeof privacy.setTrackingConsent !== 'function') {
        // SDK missing — fail closed (nothing tracked) and dismiss UI
        hideAll();
        return;
      }
      privacy.setTrackingConsent({
        analytics: !!state.analytics,
        marketing: !!state.marketing,
        preferences: !!state.preferences,
        sale_of_data: false
      }, hideAll);
    }

    function readToggles() {
      var toggles = rootEl.querySelectorAll('[data-toggle]');
      var state = {};
      for (var i = 0; i < toggles.length; i++) {
        state[toggles[i].name] = !!toggles[i].checked;
      }
      return state;
    }

    rootEl.addEventListener('click', function (e) {
      var actionEl = e.target.closest('[data-action]');
      if (actionEl) {
        var action = actionEl.getAttribute('data-action');
        if (action === 'manage') {
          showManage();
        } else if (action === 'accept') {
          setConsent({ analytics: true, marketing: true, preferences: true });
        } else if (action === 'reject') {
          setConsent({ analytics: false, marketing: false, preferences: false });
        } else if (action === 'save') {
          setConsent(readToggles());
        } else if (action === 'read-more') {
          var description = actionEl.closest('.cookie-consent__description');
          if (description) {
            description.classList.add('cookie-consent__description--expanded');
            var more = description.querySelector('[data-description-more]');
            if (more) more.removeAttribute('hidden');
          }
        } else if (action === 'card-toggle') {
          var card = actionEl.closest('[data-card]');
          if (card) {
            var expanded = card.getAttribute('data-expanded') === 'true';
            card.setAttribute('data-expanded', expanded ? 'false' : 'true');
            actionEl.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          }
        }
        return;
      }
      if (e.target.closest('[data-cookie-dismiss]')) {
        // Close X — hides the UI for this page view but preserves "no consent" state
        // so the banner re-appears on the next page until the user makes a choice.
        hideAll();
      }
    });

    // External re-open trigger (footer link, etc.)
    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-cookie-preferences]');
      if (!trigger) return;
      e.preventDefault();
      showManage();
    });

    function autoShowAllowed() {
      return rootEl.getAttribute('data-auto-show') === 'true';
    }

    function init() {
      privacy = window.Shopify && window.Shopify.customerPrivacy;
      // Liquid `data-auto-show` decides WHO gets the banner on load. JS just
      // decides whether the visitor has already responded (and thus shouldn't
      // be re-prompted). The footer "Cookie Management" link works in any
      // region regardless of `data-auto-show`.
      if (autoShowAllowed() && !hasUserActed()) {
        showBanner();
      }
    }

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function () {
        init();
      });
    } else {
      // Non-Shopify environment / SDK missing — show banner only where gated; buttons mark acted locally
      if (autoShowAllowed() && !hasUserActed()) showBanner();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-chip-row"] && !Shopify.designMode) return;
  try {
    /* Chips navigate via full page reload, so the scroll container resets to the
   start on every load. We persist the row's horizontal scrollLeft to
   sessionStorage before navigating away and restore it on the next load, so the
   chip strip stays exactly where the shopper left it across a filter click.
   Fallback (no saved position, e.g. landing on a filtered URL directly): center
   the active chip so the current filter is visible.
   Only the container's scrollLeft is touched; page vertical scroll is untouched. */
(function () {
  /* Key by the "All" chip's href (= the base collection URL), which stays
     constant across filter clicks within a collection but differs between
     collections — so positions don't leak across pages. */
  function keyFor(scroll) {
    var allChip = scroll.querySelector('.collection__chip');
    return 'bv-chip-scroll:' + (allChip ? allChip.getAttribute('href') : location.pathname);
  }
  function save(scroll) {
    try { sessionStorage.setItem(keyFor(scroll), String(scroll.scrollLeft)); } catch (e) {}
  }
  function centerActive(scroll) {
    var active = scroll.querySelector('.collection__chip--active');
    if (!active) return;
    /* Compute the active chip's position within the scrollable content from
       rects, so it's correct regardless of which element is the offsetParent. */
    var sRect = scroll.getBoundingClientRect();
    var aRect = active.getBoundingClientRect();
    var activeLeft = (aRect.left - sRect.left) + scroll.scrollLeft;
    var offset = activeLeft - (scroll.clientWidth - aRect.width) / 2;
    scroll.scrollLeft = Math.max(0, offset);
  }
  function activeVisible(scroll) {
    var active = scroll.querySelector('.collection__chip--active');
    if (!active) return true;
    var sRect = scroll.getBoundingClientRect();
    var aRect = active.getBoundingClientRect();
    return aRect.left >= sRect.left && aRect.right <= sRect.right;
  }
  function init() {
    document.querySelectorAll('.collection__chip-scroll').forEach(function (scroll) {
      var saved = null;
      try {
        var raw = sessionStorage.getItem(keyFor(scroll));
        if (raw !== null) saved = parseInt(raw, 10) || 0;
      } catch (e) {}

      /* Apply the saved scrollLeft, or center the active chip when there's none. */
      function applyPosition() {
        if (saved !== null) {
          scroll.scrollLeft = saved;
          /* A saved position from earlier browsing can leave the now-active chip
             off-screen — e.g. landing directly on a filtered URL via an external
             material link (/collections/all/flowblend). Center it if so. */
          if (!activeVisible(scroll)) centerActive(scroll);
        } else {
          centerActive(scroll);
        }
      }

      /* Restore once now, then again after layout/fonts settle. On mobile the row's
         full scrollWidth isn't computed at script-run time, so an early scrollLeft
         gets clamped to 0; re-applying on rAF + window load makes it stick. We stop
         re-applying as soon as the shopper actually touches/scrolls the row, so we
         never fight a deliberate scroll. */
      var userInteracted = false;
      ['touchstart', 'wheel', 'pointerdown', 'keydown'].forEach(function (ev) {
        scroll.addEventListener(ev, function () { userInteracted = true; }, { passive: true });
      });
      function reapply() { if (!userInteracted) applyPosition(); }

      applyPosition();
      requestAnimationFrame(reapply);
      window.addEventListener('load', reapply);

      /* Keep the stored position current as the shopper scrolls (rAF-throttled),
         and capture it right before a chip click navigates away. */
      var pending = false;
      scroll.addEventListener('scroll', function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          save(scroll);
        });
      });
      scroll.querySelectorAll('.collection__chip').forEach(function (chip) {
        chip.addEventListener('click', function () { save(scroll); });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["filter-sidebar"] && !Shopify.designMode) return;
  try {
    (function () {
  /* Mobile-only: keep the .filter-active-tags chip bar in sync with checkbox state
     before the user hits Apply. Desktop already auto-submits on change, so its chip
     bar is always URL-driven — skip this layer there. */
  if (!window.matchMedia('(max-width: 768px)').matches) return;

  var form = document.querySelector('[data-filter-form]');
  if (!form) return;

  function getCheckboxLabel(input) {
    var label = input.closest('label');
    if (!label) return input.value;
    var span = label.querySelector('.filter-value__label, .filter-swatch-item__label, .filter-size-tag__label');
    return span ? span.textContent.trim() : input.value;
  }

  function ensureContainer() {
    var container = form.querySelector('.filter-active-tags');
    if (container) return container;
    container = document.createElement('div');
    container.className = 'filter-active-tags';
    var firstGroup = form.querySelector('[data-filter-group]');
    if (firstGroup && firstGroup.parentNode) {
      firstGroup.parentNode.insertBefore(container, firstGroup);
    }
    return container;
  }

  function findPillFor(input) {
    var container = form.querySelector('.filter-active-tags');
    if (!container) return null;
    var pills = container.querySelectorAll('[data-pill-name]');
    for (var i = 0; i < pills.length; i++) {
      if (pills[i].getAttribute('data-pill-name') === input.name &&
          pills[i].getAttribute('data-pill-value') === input.value) {
        return pills[i];
      }
    }
    return null;
  }

  function buildPill(input) {
    var pill = document.createElement('button');
    pill.type = 'button';
    pill.className = 'filter-active-tag';
    pill.setAttribute('data-pill-name', input.name);
    pill.setAttribute('data-pill-value', input.value);

    var labelSpan = document.createElement('span');
    labelSpan.className = 'filter-active-tag__label';
    labelSpan.textContent = getCheckboxLabel(input);
    pill.appendChild(labelSpan);

    pill.insertAdjacentHTML(
      'beforeend',
      '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true"><path d="M18 6L6 18M6 6l12 12"/></svg>'
    );
    return pill;
  }

  function refreshContainerVisibility() {
    var container = form.querySelector('.filter-active-tags');
    if (!container) return;
    if (container.children.length === 0) {
      container.style.display = 'none';
    } else {
      container.style.display = '';
    }
  }

  /* Intercept clicks on checkbox-derived chips so they toggle the box instead of
     navigating to url_to_remove — the URL only updates after Apply on mobile.
     Price-range chips don't carry data-pill-name, so they still navigate. */
  form.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-pill-name]');
    if (!pill || !form.contains(pill)) return;
    e.preventDefault();
    var name = pill.getAttribute('data-pill-name');
    var value = pill.getAttribute('data-pill-value');
    var inputs = form.querySelectorAll('input[type="checkbox"]');
    var match = null;
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].name === name && inputs[i].value === value) { match = inputs[i]; break; }
    }
    if (match) {
      match.checked = false;
      match.dispatchEvent(new Event('change', { bubbles: true }));
    } else {
      pill.remove();
      refreshContainerVisibility();
    }
  });

  form.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'checkbox') return;
    var existing = findPillFor(input);
    if (input.checked) {
      if (!existing) {
        var container = ensureContainer();
        container.appendChild(buildPill(input));
      }
    } else if (existing) {
      existing.remove();
    }
    refreshContainerVisibility();
  });
})();

(function () {
  /* "Show X more" toggle: works on both mobile and desktop. Click reveals all
     items in the filter group by adding the --show-all class. Hidden items are
     auto-revealed via CSS :has() if any of them is already an active filter. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-filter-show-more]');
    if (!btn) return;
    var group = btn.closest('[data-filter-group]');
    if (group) group.classList.add('filter-group--show-all');
  });
})();

(function () {
  /* A group's open state is SERVER-rendered from `filter_active` (see the
     filter-group markup above), so it is really "does this group have an active
     value" rather than "did the shopper open this". Untick a group's last value
     and the re-render — full reload on v1, Section Rendering swap on v2/v3 —
     comes back with filter_active false and the group collapses under the
     shopper mid-selection (BUG-BV-09, reproduced on prod 2026-08-06 on both
     /collections/tees (v1) and /collections/all (v2)).

     Remember what the shopper actually opened and re-apply it after every
     render. Stored per pathname so it survives the reload/swap but does not
     leak to another collection.

     Desktop only: on mobile the sidebar is a modal that deliberately opens one
     tapped group at a time ([data-mobile-filter-group]), and restoring would
     fight that. Recording still runs everywhere — it is inert until desktop. */
  function isDesktop() { return window.matchMedia('(min-width: 769px)').matches; }
  function storeKey() { return 'bv:filter-groups:' + location.pathname; }

  function readState() {
    try { return JSON.parse(sessionStorage.getItem(storeKey())) || {}; }
    catch (e) { return {}; }
  }
  function writeState(state) {
    try { sessionStorage.setItem(storeKey(), JSON.stringify(state)); } catch (e) { /* private mode */ }
  }
  function groupName(group) {
    var el = group.querySelector('.filter-group__name');
    return el ? el.textContent.trim() : null;
  }
  function isOpen(group) {
    var body = group.querySelector('[data-filter-body]');
    return !!body && body.style.display !== 'none';
  }
  function record(group) {
    var name = groupName(group);
    if (!name) return;
    var state = readState();
    state[name] = isOpen(group) ? 1 : 0;
    writeState(state);
  }
  function apply() {
    if (!isDesktop()) return;
    var state = readState();
    document.querySelectorAll('[data-filter-group]').forEach(function (group) {
      var name = groupName(group);
      /* No recorded preference → leave the server's choice alone. */
      if (!name || !Object.prototype.hasOwnProperty.call(state, name)) return;
      var body = group.querySelector('[data-filter-body]');
      if (!body) return;
      var open = state[name] === 1;
      body.style.display = open ? '' : 'none';
      group.classList.toggle('filter-group--open', open);
    });
  }

  /* The accordion's own handler runs on this same click, so read the resulting
     state on the next tick rather than inverting it here. */
  document.addEventListener('click', function (e) {
    var acc = e.target.closest('[data-filter-accordion]');
    if (!acc) return;
    var group = acc.closest('[data-filter-group]');
    if (group) setTimeout(function () { record(group); }, 0);
  });

  /* Ticking a value means the shopper is working inside that group, and a
     checkbox can only be clicked while the group is open — so recording the
     current state pins it open across the re-render that follows. This is the
     line that fixes the reported "untick the last one and it collapses". */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.type !== 'checkbox') return;
    var group = input.closest && input.closest('[data-filter-group]');
    if (group) record(group);
  });

  /* v2/v3 replace [data-collection] wholesale, and v1 (once its filters became
     AJAX) does the same, so there is no single post-render hook to call —
     watch for swapped-in groups instead. */
  var queued = false;
  function scheduleApply() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; apply(); });
  }
  if ('MutationObserver' in window && document.body) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var added = mutations[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var node = added[j];
          if (node.nodeType !== 1) continue;
          if (node.matches('[data-filter-group]') || node.querySelector('[data-filter-group]')) {
            scheduleApply();
            return;
          }
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  apply();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ga4-pixel"] && !Shopify.designMode) return;
  try {
    (function () {
    var GA4_CONFIG = {
      test: { measurement_id: 'G-XXXXXXXXXX', api_secret: 'XXXXXXXXXXXXXXXXXXXX' },
      prod: { measurement_id: 'G-JM90QX1X3Q', api_secret: 'QgK67kaITUaA-f8h81X9ZA' },
    };
    var host = (window.Shopify && window.Shopify.shop) || (location && location.host) || '';
    var cfg = host.indexOf('bonaval-test') !== -1 ? GA4_CONFIG.test : GA4_CONFIG.prod;
    if (!cfg.measurement_id || cfg.measurement_id.indexOf('G-X') === 0) return;
    if (!window.BonvaleAnalytics || !window.PerformanceObserver) return;

    var TARGET_TID = cfg.measurement_id;
    var cid = null;
    var sid = null;
    var queue = [];
    var QUEUE_MAX = 20;

    // QA BUG-BV-75: is analytics processing allowed for this visitor right now?
    // Source of truth is the theme's own cookie banner, not Shopify's
    // analyticsProcessingAllowed() (which reflects the merchant's GDPR
    // data-restriction toggle — currently off — and so returns true pre-consent).
    function analyticsAllowed() {
      try {
        var banner = document.getElementById('cookie-consent');
        var bannerApplies = !!banner && banner.getAttribute('data-auto-show') === 'true';
        var acted = false;
        try { acted = !!localStorage.getItem('bonvale:cookie:acted'); } catch (e) {}
        // Consent required here but no choice made yet -> hold everything.
        if (bannerApplies && !acted) return false;
        // A choice was made (or none is required): honour an explicit analytics=no.
        var cp = window.Shopify && window.Shopify.customerPrivacy;
        if (cp && typeof cp.currentVisitorConsent === 'function') {
          var a = cp.currentVisitorConsent().analytics;
          if (a === 'no' || a === false) return false;
        }
        return true;
      } catch (e) { return true; }
    }

    function send(events) {
      if (!cid || !events.length || !analyticsAllowed()) return;
      var url = 'https://www.google-analytics.com/mp/collect?measurement_id=' +
                encodeURIComponent(cfg.measurement_id) +
                '&api_secret=' + encodeURIComponent(cfg.api_secret);
      try {
        fetch(url, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          body: JSON.stringify({ client_id: cid, events: events }),
          keepalive: true,
          mode: 'no-cors',
        });
      } catch (e) { /* fire-and-forget */ }
    }

    function toEvent(name, data) {
      data = data || {};
      // Without session_id + engagement_time_msec, MP events reach BigQuery
      // but not standard/realtime reports.
      var params = { engagement_time_msec: 1 };
      if (sid) params.session_id = sid;
      for (var k in data) {
        if (!Object.prototype.hasOwnProperty.call(data, k)) continue;
        var v = data[k];
        // GA4 caps event param string values at 100 chars.
        if (typeof v === 'string' && v.length > 100) v = v.slice(0, 100);
        params[k] = v;
      }
      return { name: name, params: params };
    }

    // Drain queued events once we have a cid AND consent. Checked BEFORE
    // splicing so a not-yet-allowed flush leaves the queue intact for later.
    function flushQueue() {
      if (!cid || !analyticsAllowed()) return;
      var pending = queue.splice(0);
      var events = [];
      for (var j = 0; j < pending.length; j++) {
        events.push(toEvent(pending[j][0], pending[j][1]));
      }
      // MP allows max 25 events per request.
      while (events.length) send(events.splice(0, 25));
    }

    window.BonvaleAnalytics.subscribe(function (name, data) {
      if (cid && analyticsAllowed()) {
        send([toEvent(name, data)]);
      } else if (queue.length < QUEUE_MAX) {
        queue.push([name, data]);
      }
    });

    // Events which belong only to GA4 (for example select_item and the
    // confirmed Shopify-account login) must not leak to Meta/TikTok adapters.
    if (typeof window.BonvaleAnalytics.subscribeGa4 === 'function') {
      window.BonvaleAnalytics.subscribeGa4(function (name, data) {
        if (cid && analyticsAllowed()) {
          send([toEvent(name, data)]);
        } else if (queue.length < QUEUE_MAX) {
          queue.push([name, data]);
        }
      });
    }

    // A pending marker is written only when the shopper enters Shopify's
    // native sign-in route. Liquid confirms authentication on the return page;
    // together those two facts are a reliable successful-login signal. This is
    // deliberately separate from bv_identify, whose warehouse bridge is owned
    // by the app extension and remains unchanged.
    try {
      if (window.__sectionTracking && window.__sectionTracking.customerLoggedIn &&
          sessionStorage.getItem('bv-ga4-login-pending') === '1') {
        window.BonvaleAnalytics.trackGa4('login', { method: 'shopify_customer_account' });
        sessionStorage.removeItem('bv-ga4-login-pending');
      }
    } catch (_) { /* storage blocked; do not guess */ }

    // The visitor granted/changed consent (the banner calls setTrackingConsent,
    // which fires this): flush anything held while consent was pending.
    document.addEventListener('visitorConsentCollected', flushQueue);

    function tryExtractIds(entryName) {
      // Match both /g/collect (typical) and /j/collect (rare alternative).
      if (entryName.indexOf('google-analytics.com/g/collect') === -1 &&
          entryName.indexOf('google-analytics.com/j/collect') === -1) {
        return false;
      }
      try {
        var url = new URL(entryName);
        // The channel can fire multiple tids per page (e.g. AW-… for Ads).
        if (url.searchParams.get('tid') !== TARGET_TID) return false;
        var c = url.searchParams.get('cid');
        if (!c) return false;
        cid = c;
        sid = url.searchParams.get('sid');
        return true;
      } catch (_) { return false; }
    }

    try {
      var obs = new PerformanceObserver(function (list) {
        if (cid) { obs.disconnect(); return; }
        var entries = list.getEntries();
        for (var i = 0; i < entries.length; i++) {
          if (tryExtractIds(entries[i].name || '')) {
            obs.disconnect();
            // cid is set now; send held events only if consent already allows it
            // (otherwise they stay queued for the visitorConsentCollected flush).
            flushQueue();
            return;
          }
        }
      });
      // buffered:true replays resource entries from before the observer was
      // attached — the channel's first /g/collect can fire very early.
      obs.observe({ type: 'resource', buffered: true });
    } catch (e) { /* PerformanceObserver unavailable; skip */ }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gc-card-display"] && !Shopify.designMode) return;
  try {
    (function () {
    document.addEventListener('click', function (e) {
      var back = e.target.closest('[data-gc-back]');
      if (back) {
        if (window.history.length > 1) { window.history.back(); }
        else { window.location.href = back.getAttribute('data-home') || '/'; }
        return;
      }

      var btn = e.target.closest('[data-copy-target]');
      if (!btn) return;

      var targetId = btn.getAttribute('data-copy-target');
      var source = document.getElementById(targetId);
      if (!source) return;

      var text = source.textContent.trim();
      var feedback = document.getElementById('gc-copy-feedback');
      var copiedText = btn.getAttribute('data-copied-text') || 'Copied!';

      navigator.clipboard.writeText(text).then(function () {
        if (feedback) {
          feedback.textContent = copiedText;
          setTimeout(function () { feedback.textContent = ''; }, 2000);
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gift-card-gift-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  var overlay = document.querySelector('[data-gc-overlay]');
  if (!overlay || overlay.dataset.gcInit) return;
  overlay.dataset.gcInit = '1';

  var modal = overlay.querySelector('[data-gc-modal]');
  var submitBtn = overlay.querySelector('[data-gc-submit]');
  var sendFlag = overlay.querySelector('[data-gc-send-flag]');
  var recipientBlock = overlay.querySelector('[data-gc-recipient]');
  var messageBlock = overlay.querySelector('[data-gc-message-field]');
  var emailInput = overlay.querySelector('[data-gc-email]');
  var messageInput = overlay.querySelector('[data-gc-message]');
  var dateWrap = overlay.querySelector('[data-gc-date-wrap]');
  var dateInput = overlay.querySelector('[data-gc-date]');
  var dateText = overlay.querySelector('[data-gc-date-text]');
  var dateDisplay = overlay.querySelector('.gift-modal__date-display');
  var whenField = overlay.querySelector('[data-gc-when-field]');
  var hintSomeone = overlay.querySelector('[data-gc-hint-someone]');
  var hintMe = overlay.querySelector('[data-gc-hint-me]');
  var cardMessage = overlay.querySelector('[data-gc-card-message]');
  var returnFocus = null;
  var focusSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

  var whoMode = 'someone';
  var whenMode = 'now';
  var cardPlaceholder = cardMessage ? cardMessage.textContent : '';

  // Restrict the date picker to today … today + 90 days. Shopify's native gift
  // card recipient flow rejects a "Send on" further out than 90 days ("Send on
  // must be within 90 days from now"), which would 422 the add-to-cart.
  function isoDate(d) {
    return d.getFullYear() + '-' +
      String(d.getMonth() + 1).padStart(2, '0') + '-' +
      String(d.getDate()).padStart(2, '0');
  }
  function emailValid() {
    if (!emailInput) return false;
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailInput.value.trim());
  }

  function validate() {
    var ok = true;
    if (whoMode === 'someone') ok = ok && emailValid();
    if (whenMode === 'date') ok = ok && !!(dateInput && dateInput.value);
    if (submitBtn) submitBtn.disabled = !ok;
  }

  function updateCardMessage() {
    if (!cardMessage) return;
    if (whoMode === 'me') {
      cardMessage.style.display = 'none';
      return;
    }
    cardMessage.style.display = '';
    var v = messageInput ? messageInput.value.trim() : '';
    cardMessage.textContent = v || cardPlaceholder;
  }

  // Who is it for?
  overlay.querySelectorAll('[data-gc-who-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      whoMode = btn.dataset.who;
      overlay.querySelectorAll('[data-gc-who-btn]').forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('gift-modal__toggle-btn--active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var someone = whoMode === 'someone';
      if (recipientBlock) recipientBlock.style.display = someone ? '' : 'none';
      if (messageBlock) messageBlock.style.display = someone ? '' : 'none';
      // Don't submit recipient props (or the send flag) when buying for self.
      overlay.querySelectorAll('[data-gc-prop]').forEach(function (el) {
        if (el === dateInput) return; // date governed by the when toggle
        el.disabled = !someone;
      });
      if (sendFlag) sendFlag.disabled = !someone;
      if (hintSomeone) hintSomeone.hidden = !someone;
      if (hintMe) hintMe.hidden = someone;
      // "For me" sends immediately — hide the delivery-date chooser and force "now".
      if (whenField) whenField.style.display = someone ? '' : 'none';
      if (!someone) resetWhenToNow();
      updateCardMessage();
      validate();
    });
  });

  function resetWhenToNow() {
    whenMode = 'now';
    overlay.querySelectorAll('[data-gc-when-btn]').forEach(function (b) {
      var active = b.dataset.when === 'now';
      b.classList.toggle('gift-modal__toggle-btn--active', active);
      b.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
    if (dateWrap) dateWrap.style.display = 'none';
    if (dateInput) { dateInput.disabled = true; dateInput.value = ''; }
    closeCal();
    updateDateText();
  }

  // Delivery date
  overlay.querySelectorAll('[data-gc-when-btn]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      whenMode = btn.dataset.when;
      overlay.querySelectorAll('[data-gc-when-btn]').forEach(function (b) {
        var active = b === btn;
        b.classList.toggle('gift-modal__toggle-btn--active', active);
        b.setAttribute('aria-pressed', active ? 'true' : 'false');
      });
      var pick = whenMode === 'date';
      if (dateWrap) dateWrap.style.display = pick ? '' : 'none';
      if (dateInput) {
        dateInput.disabled = !pick;
        if (!pick) dateInput.value = '';
      }
      if (pick) openCal(); else closeCal();
      updateDateText();
      validate();
    });
  });

  // Reflect the native date value into the styled display as DD/MM/YYYY.
  function updateDateText() {
    if (!dateText) return;
    var v = dateInput ? dateInput.value : '';
    if (v) {
      var parts = v.split('-'); // YYYY-MM-DD
      dateText.textContent = parts[2] + '/' + parts[1] + '/' + parts[0];
      dateText.classList.add('gift-modal__date-text--filled');
      if (dateDisplay) dateDisplay.classList.add('gift-modal__date-display--filled');
    } else {
      dateText.textContent = dateText.dataset.placeholder;
      dateText.classList.remove('gift-modal__date-text--filled');
      if (dateDisplay) dateDisplay.classList.remove('gift-modal__date-display--filled');
    }
  }

  if (emailInput) emailInput.addEventListener('input', validate);
  if (messageInput) messageInput.addEventListener('input', updateCardMessage);

  // ---- Custom calendar (replaces the browser-native date picker) ----
  var calEl = overlay.querySelector('[data-gc-cal]');
  var calToggle = overlay.querySelector('[data-gc-cal-toggle]');
  var calLang = document.documentElement.lang || 'en';
  var MONTHS = [], WEEKDAYS = [];
  try {
    var monthFmt = new Intl.DateTimeFormat(calLang, { month: 'long' });
    for (var mi = 0; mi < 12; mi++) MONTHS.push(monthFmt.format(new Date(2021, mi, 1)));
    var dayFmt = new Intl.DateTimeFormat(calLang, { weekday: 'short' });
    /* 2021-02-01 was a Monday — the grid is Monday-first. */
    for (var di = 1; di <= 7; di++) WEEKDAYS.push(dayFmt.format(new Date(2021, 1, di)));
  } catch (e) {
    MONTHS = ['January', 'February', 'March', 'April', 'May', 'June', 'July',
      'August', 'September', 'October', 'November', 'December'];
    WEEKDAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
  }
  var calLabels = calEl ? calEl.dataset : {};

  // Selectable window: today … today + 90 days (Shopify rejects "Send on" further out).
  var minDate = new Date();
  minDate = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate());
  var maxDate = new Date(minDate.getFullYear(), minDate.getMonth(), minDate.getDate() + 90);
  var viewYear = minDate.getFullYear();
  var viewMonth = minDate.getMonth();

  function sameDay(a, b) {
    return a && b && a.getFullYear() === b.getFullYear() &&
      a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
  }
  function inRange(d) { return d >= minDate && d <= maxDate; }
  function monthIndex(y, m) { return y * 12 + m; }
  function selectedDate() {
    if (!dateInput || !dateInput.value) return null;
    var p = dateInput.value.split('-');
    return new Date(+p[0], +p[1] - 1, +p[2]);
  }
  function arrowSvg(left) {
    var d = left ? 'M12.5 15l-5-5 5-5' : 'M7.5 5l5 5-5 5';
    return '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" ' +
      'stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="' + d + '"/></svg>';
  }

  function renderCal() {
    if (!calEl) return;
    var sel = selectedDate();
    var firstOfView = new Date(viewYear, viewMonth, 1);
    var lead = (firstOfView.getDay() + 6) % 7; // Monday-first offset
    var cur = new Date(viewYear, viewMonth, 1 - lead);

    var prevDisabled = monthIndex(viewYear, viewMonth) <= monthIndex(minDate.getFullYear(), minDate.getMonth());
    var nextDisabled = monthIndex(viewYear, viewMonth) >= monthIndex(maxDate.getFullYear(), maxDate.getMonth());

    var html = '';
    html += '<div class="gc-cal__header">';
    html += '<button type="button" class="gc-cal__nav" data-gc-prev aria-label="' + (calLabels.labelPrevMonth || 'Previous month') + '"' + (prevDisabled ? ' disabled' : '') + '>' + arrowSvg(true) + '</button>';
    html += '<p class="gc-cal__title">' + MONTHS[viewMonth] + ' ' + viewYear + '</p>';
    html += '<button type="button" class="gc-cal__nav" data-gc-next aria-label="' + (calLabels.labelNextMonth || 'Next month') + '"' + (nextDisabled ? ' disabled' : '') + '>' + arrowSvg(false) + '</button>';
    html += '</div>';

    html += '<div class="gc-cal__weekdays">';
    for (var w = 0; w < 7; w++) html += '<span class="gc-cal__weekday">' + WEEKDAYS[w] + '</span>';
    html += '</div>';

    html += '<div class="gc-cal__grid">';
    for (var r = 0; r < 6; r++) {
      html += '<div class="gc-cal__row">';
      for (var c = 0; c < 7; c++) {
        var inMonth = cur.getMonth() === viewMonth;
        var selectable = inMonth && inRange(cur);
        var cls = 'gc-cal__day';
        if (!inMonth) cls += ' gc-cal__day--muted';
        if (selectable && sameDay(cur, minDate)) cls += ' gc-cal__day--today';
        if (sel && sameDay(cur, sel)) cls += ' gc-cal__day--selected';
        var attrs = 'class="' + cls + '"';
        attrs += selectable ? ' data-gc-pick="' + isoDate(cur) + '"' : ' disabled';
        html += '<button type="button" ' + attrs + '>' + cur.getDate() + '</button>';
        cur.setDate(cur.getDate() + 1);
      }
      html += '</div>';
    }
    html += '</div>';

    html += '<div class="gc-cal__footer">';
    html += '<button type="button" class="gc-cal__action gc-cal__action--today" data-gc-cal-today>' + (calLabels.labelToday || 'Today') + '</button>';
    html += '<button type="button" class="gc-cal__action gc-cal__action--clear" data-gc-cal-clear>' + (calLabels.labelClear || 'Clear') + '</button>';
    html += '</div>';

    calEl.innerHTML = html;
  }

  function openCal() {
    if (!calEl) return;
    var sel = selectedDate();
    if (sel) { viewYear = sel.getFullYear(); viewMonth = sel.getMonth(); }
    renderCal();
    calEl.hidden = false;
    if (calToggle) calToggle.setAttribute('aria-expanded', 'true');
  }
  function closeCal() {
    if (!calEl) return;
    calEl.hidden = true;
    if (calToggle) calToggle.setAttribute('aria-expanded', 'false');
  }

  if (calToggle) {
    /* QA BUG-BV-65: guard calEl here too — when the calendar container is missing
       these handlers used to throw (reading .hidden of null) and Add To Bag stayed
       disabled with no feedback. openCal/closeCal already no-op without calEl. */
    calToggle.addEventListener('click', function () {
      if (!calEl || calEl.hidden) openCal(); else closeCal();
    });
    calToggle.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (!calEl || calEl.hidden) openCal(); else closeCal();
      }
    });
  }

  if (calEl) {
    calEl.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-gc-pick]');
      if (pick) {
        if (dateInput) dateInput.value = pick.getAttribute('data-gc-pick');
        updateDateText();
        validate();
        closeCal();
        return;
      }
      if (e.target.closest('[data-gc-prev]')) {
        viewMonth--; if (viewMonth < 0) { viewMonth = 11; viewYear--; }
        renderCal(); return;
      }
      if (e.target.closest('[data-gc-next]')) {
        viewMonth++; if (viewMonth > 11) { viewMonth = 0; viewYear++; }
        renderCal(); return;
      }
      if (e.target.closest('[data-gc-cal-today]')) {
        if (dateInput) dateInput.value = isoDate(minDate);
        viewYear = minDate.getFullYear(); viewMonth = minDate.getMonth();
        updateDateText(); validate(); closeCal(); return;
      }
      if (e.target.closest('[data-gc-cal-clear]')) {
        if (dateInput) dateInput.value = '';
        updateDateText(); validate(); renderCal(); return;
      }
    });
  }

  // Close the calendar when clicking anywhere outside the date field.
  document.addEventListener('click', function (e) {
    if (calEl && !calEl.hidden && !e.target.closest('[data-gc-date-wrap]')) closeCal();
  });

  // Open / close
  function open() {
    returnFocus = document.activeElement;
    overlay.style.display = '';
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () { overlay.classList.add('gift-modal-overlay--open'); });
    var target = overlay.querySelector('[data-gc-close]') || modal;
    if (target) requestAnimationFrame(function () { target.focus(); });
    validate();
  }
  function close() {
    overlay.classList.remove('gift-modal-overlay--open');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (returnFocus && returnFocus.focus) returnFocus.focus();
    returnFocus = null;
    var done = false;
    function hide() {
      if (done) return;
      done = true;
      overlay.style.display = 'none';
      modal.removeEventListener('transitionend', hide);
    }
    modal.addEventListener('transitionend', hide);
    setTimeout(hide, 400);
  }

  window.addEventListener('gift-card:open', open);
  overlay.querySelectorAll('[data-gc-close]').forEach(function (btn) {
    btn.addEventListener('click', close);
  });
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.style.display !== 'none') close();
    if (e.key !== 'Tab' || overlay.style.display === 'none') return;
    var items = [].filter.call(modal.querySelectorAll(focusSelector), function (el) {
      return el.getClientRects().length && !el.hidden;
    });
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  // Close once the add-to-cart submit fires (cart drawer takes over).
  if (submitBtn) {
    submitBtn.addEventListener('click', function () {
      if (submitBtn.disabled) return;
      setTimeout(close, 50);
    });
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gorgias-chat-lazy"] && !Shopify.designMode) return;
  try {
    (function () {
    var btn = document.querySelector('[data-gorgias-lazy]');
    if (!btn) return;

    var src = btn.getAttribute('data-loader-src');
    if (!src) return;

    var injected = false;
    var wantOpen = false;
    var yielded = false;
    var chatOpenTracked = false;

    function trackChatOpen() {
      if (chatOpenTracked) return;
      chatOpenTracked = true;
      if (window.BonvaleAnalytics && window.BonvaleAnalytics.trackGa4) {
        window.BonvaleAnalytics.trackGa4('chat_widget_opened', { provider: 'gorgias' });
      }
    }

    // Once the bundle has warmed, shoppers click Gorgias's own cross-origin
    // iframe launcher, whose click cannot bubble into the theme. Observe only
    // Gorgias's host iframe/window becoming visible so that path is covered too.
    var chatVisibilityTimer = null;
    function checkChatVisibility() {
      clearTimeout(chatVisibilityTimer);
      chatVisibilityTimer = setTimeout(function () {
        var win = document.getElementById('chat-window');
        if (win && win.getBoundingClientRect().height > 100) trackChatOpen();
      }, 100);
    }
    var chatHostObserver = new MutationObserver(function () {
      var win = document.getElementById('chat-window');
      if (!win) return;
      chatHostObserver.disconnect();
      checkChatVisibility();
      if ('ResizeObserver' in window) {
        new ResizeObserver(checkChatVisibility).observe(win);
      }
    });
    chatHostObserver.observe(document.body, { childList: true, subtree: true });

    function standDown() {
      btn.hidden = true;
      btn.classList.remove('gorgias-lazy--loading');
    }

    // Gorgias is being loaded by someone else — stop every trigger we armed,
    // or the desktop 8s timer would still fire and append a second loader.
    function yieldToForeignChat() {
      yielded = true;
      standDown();
    }

    // Someone other than us is loading Gorgias — i.e. the app embed is still
    // enabled. Its loader hard-bails with a console warning when it sees a
    // second chat, and two launchers on screen is worse than none, so we yield.
    function foreignChatPresent() {
      if (injected) return false;
      return !!window.GorgiasChat || !!document.getElementById('gorgias-chat-bundle');
    }

    if (foreignChatPresent()) {
      yieldToForeignChat();
      return;
    }

    // Not enough to check once: this bundle (`snippet-scripts.js`) is a deferred
    // script that sits EARLIER in document order than the app embed's own
    // deferred loader, so with the embed on we get here before Gorgias runs and
    // the check above passes. Keep watching for it briefly.
    var watch = setInterval(function () {
      if (foreignChatPresent()) {
        clearInterval(watch);
        yieldToForeignChat();
      }
    }, 250);
    setTimeout(function () {
      clearInterval(watch);
    }, 10000);

    // Resolve when the bundle has finished booting. GorgiasChat is a Proxy that
    // throws on any property other than init/resolve/constructor, so `init` is
    // the only safe thing to touch before it is ready.
    function whenReady(cb) {
      var tries = 0;
      (function poll() {
        if (window.GorgiasChat && typeof window.GorgiasChat.init === 'function') {
          try {
            window.GorgiasChat.init().then(cb);
            return;
          } catch (e) {
            /* fall through and retry */
          }
        }
        if (++tries > 100) return; // ~20s, then give up quietly
        setTimeout(poll, 200);
      })();
    }

    function inject(openWhenReady) {
      // Record the intent BEFORE the injected guard. On desktop the capture-phase
      // `pointerdown` listener below fires before `click`, so a tap on our own
      // launcher would otherwise inject with openWhenReady=false and then be
      // swallowed by the guard — loading the chat but never opening it.
      if (yielded) return;
      if (openWhenReady) {
        wantOpen = true;
        btn.classList.add('gorgias-lazy--loading');
      }
      if (injected) return;
      injected = true;
      clearInterval(watch);

      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onerror = function () {
        // Network/adblock failure: let a later trigger try again rather than
        // stranding the shopper with a launcher that does nothing.
        injected = false;
        wantOpen = false;
        btn.classList.remove('gorgias-lazy--loading');
      };
      document.body.appendChild(s);

      whenReady(function () {
        if (wantOpen) {
          try {
            window.GorgiasChat.open();
          } catch (e) {
            /* chat is loaded; the shopper can click the real launcher */
          }
        }
        waitForUi(wantOpen, standDown);
      });
    }

    // `init()` resolving only means the bundle booted — Gorgias's own launcher
    // (or the chat window, when we asked it to open) lands a beat later.
    // Measured on prod: init resolved at 4.1s but the window painted at 5.2s,
    // so hiding on init alone left a second with nothing on screen.
    function waitForUi(openWhenReady, cb) {
      var tries = 0;
      (function poll() {
        var win = document.getElementById('chat-window');
        var ready = openWhenReady
          ? !!win && win.getBoundingClientRect().height > 100
          : !!document.getElementById('chat-button');
        if (ready) {
          if (openWhenReady) trackChatOpen();
          return cb();
        }
        if (++tries > 60) return cb(); // ~18s fail-safe; never strand the placeholder
        setTimeout(poll, 300);
      })();
    }

    btn.addEventListener('click', function () {
      inject(true);
    });

    // Warm the bundle once it can no longer affect the page-load metrics, so a
    // later tap opens instantly. Tap-only was too aggressive: measured on prod
    // 2026-08-14 on a throttled Android, a cold tap took 5.2s to paint the chat
    // window, which reads as a dead button.
    //   desktop — first interaction, or load+8s. Proactive campaigns are
    //             desktop-only and the earliest fires at 30s, so nothing is missed.
    //   mobile  — load+15s dwell. Bounced sessions (most of the traffic) are
    //             gone well before that and still pay nothing; anyone who stays
    //             long enough to want chat finds it already warm.
    // Coarse pointer => treat as mobile regardless of width, so a tablet does
    // not eat the bundle early for campaigns that are gated on desktop anyway.
    var isDesktop =
      window.matchMedia('(min-width: 769px)').matches &&
      window.matchMedia('(pointer: fine)').matches;

    function warm() {
      if ('requestIdleCallback' in window) {
        requestIdleCallback(function () {
          inject(false);
        }, { timeout: 3000 });
      } else {
        inject(false);
      }
    }

    // Everything is armed from `load`, never from script execution: an early
    // scroll must not pull the bundle into the initial page load, which is the
    // whole point of this snippet.
    function armWarmers() {
      var timer = setTimeout(warm, isDesktop ? 8000 : 15000);
      if (!isDesktop) return;
      ['pointerdown', 'keydown', 'wheel', 'scroll'].forEach(function (ev) {
        window.addEventListener(
          ev,
          function () {
            clearTimeout(timer);
            warm();
          },
          { once: true, passive: true, capture: true }
        );
      });
    }

    if (document.readyState === 'complete') armWarmers();
    else window.addEventListener('load', armWarmers, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kol-attribution"] && !Shopify.designMode) return;
  try {
    (function () {
    /* Locale-aware root: '' on the primary locale, '/fr' etc. on secondary ones.
       Cart AJAX must carry it or Shopify answers in the shop's DEFAULT locale. */
    var LOCALE_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');

    var STORAGE_KEY = '_bv_kol_ref'; // localStorage: JSON { code, ts }
    var CART_ATTR_CODE = '__bv_kol_ref'; // PRIVATE cart attr (double `_`): hidden from Liquid/Ajax & checkout, lands on order. See doc.
    var CART_ATTR_AT = '__bv_kol_ref_at'; // PRIVATE cart attr: touch time (epoch ms)
    var TTL_MS = 60 * 24 * 60 * 60 * 1000; // 60 days — safe upper bound; platform enforces real window
    var MAX_LEN = 64;
    var lastWriteAt = 0; // throttle background re-writes (epoch ms)

    function readRefFromUrl() {
      try {
        var v = new URL(window.location.href).searchParams.get('ref');
        if (!v) return null;
        v = v.trim();
        if (!v) return null;
        return v.slice(0, MAX_LEN);
      } catch (e) {
        return null;
      }
    }

    function getStored() {
      try {
        var raw = localStorage.getItem(STORAGE_KEY);
        if (!raw) return null;
        var obj = JSON.parse(raw);
        if (!obj || !obj.code || !obj.ts) return null;
        if (Date.now() - obj.ts > TTL_MS) {
          localStorage.removeItem(STORAGE_KEY);
          return null;
        }
        return obj;
      } catch (e) {
        return null;
      }
    }

    function setStored(code, ts) {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ code: code, ts: ts }));
      } catch (e) {}
    }

    // Re-assert the touch onto cart attributes. NOT write-once: another app can
    // wipe the attribute mid-session, so we must be able to re-add it (see doc).
    // `force` bypasses the throttle for the decisive checkout-intent write.
    function writeToCart(code, ts, force) {
      var now = Date.now();
      if (!force && now - lastWriteAt < 1500) return; // throttle background writes
      lastWriteAt = now;

      var attrs = {};
      attrs[CART_ATTR_CODE] = code;
      attrs[CART_ATTR_AT] = String(ts);

      // keepalive lets the POST finish even as the page navigates to checkout.
      fetch(LOCALE_ROOT + '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        keepalive: true,
      }).catch(function () { /* silent — not load-bearing */ });
    }

    function reassert(force) {
      var s = getStored();
      if (s) writeToCart(s.code, s.ts, force);
    }

    // 1. Capture (last-touch): a fresh ?ref overwrites and refreshes the timestamp.
    var urlRef = readRefFromUrl();
    if (urlRef) setStored(urlRef, Date.now());

    // 2. Propagate on load (re-asserts if a prior page/app cleared the attribute).
    reassert(false);

    // 3. Re-assert at checkout intent — the decisive moment. Writing it again
    //    (keepalive) right before the checkout snapshot is what makes it land on
    //    the order. Covers the cart form submit + any checkout link/button.
    document.addEventListener('click', function (e) {
      var t = e.target;
      var el = t && t.closest ? t.closest('a, button, input[type="submit"]') : null;
      if (!el) return;
      var isCheckout = el.name === 'checkout';
      if (!isCheckout) {
        var href = (el.getAttribute && el.getAttribute('href')) || '';
        if (href.indexOf('/checkout') !== -1) isCheckout = true;
      }
      if (isCheckout) reassert(true);
    }, true);

    document.addEventListener('submit', function (e) {
      var form = e.target;
      var action = (form && form.getAttribute && form.getAttribute('action')) || '';
      if (action.indexOf('/cart') !== -1 || action.indexOf('/checkout') !== -1) reassert(true);
    }, true);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["meta-attribution-bridge"] && !Shopify.designMode) return;
  try {
    (function () {
    var WROTE_KEY = '_bv_fbpfbc_written';
    if (window.sessionStorage && sessionStorage.getItem(WROTE_KEY)) return;

    /* Locale-aware root: '' on the primary locale, '/fr' etc. on secondary ones.
       Cart AJAX must carry it or Shopify answers in the shop's DEFAULT locale. */
    var LOCALE_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');

    function readCookies() {
      var out = {};
      var raw = document.cookie || '';
      var parts = raw.split(';');
      for (var i = 0; i < parts.length; i++) {
        var p = parts[i];
        var eq = p.indexOf('=');
        if (eq < 0) continue;
        var k = p.slice(0, eq).trim();
        var v = p.slice(eq + 1).trim();
        if (k) out[k] = v;
      }
      return out;
    }

    function writeToCart(fbp, fbc) {
      var attrs = {};
      if (fbp) attrs['_fbp'] = fbp;
      if (fbc) attrs['_fbc'] = fbc;
      if (!attrs._fbp && !attrs._fbc) return;

      fetch(LOCALE_ROOT + '/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attrs }),
        keepalive: true,
      })
        .then(function () {
          try { sessionStorage.setItem(WROTE_KEY, '1'); } catch (e) {}
        })
        .catch(function () { /* silent — not load-bearing */ });
    }

    function attempt() {
      var c = readCookies();
      if (c._fbp || c._fbc) {
        writeToCart(c._fbp, c._fbc);
        return true;
      }
      return false;
    }

    if (!attempt()) {
      // fbevents.js may not have set the cookie yet on a cold visit.
      setTimeout(attempt, 2000);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-lightbox"] && !Shopify.designMode) return;
  try {
    (function () {
  var MOBILE = '(max-width: 768px)';

  function init() {
    var box = document.querySelector('[data-pg-lightbox]');
    var gallery = document.querySelector('[data-product-gallery]');
    if (!box || !gallery || box.dataset.pgBound) return;
    box.dataset.pgBound = '1';

    var track = box.querySelector('[data-pg-track]');
    var dots = box.querySelector('[data-pg-dots]');
    var status = box.querySelector('[data-pg-status]');
    var closeBtn = box.querySelector('[data-pg-close]');
    var mq = window.matchMedia(MOBILE);
    var lastFocus = null;
    var current = 0;

    function positionLabel(i, n) {
      return (box.dataset.labelPosition || '')
        .replace('__i__', String(i + 1))
        .replace('__n__', String(n));
    }

    // A video item is not something to pinch-zoom, and its own click-to-load
    // player owns the tap (product-gallery-video). Everything the lightbox does
    // — slides, dots, "Image n of m", the tap target — counts stills only.
    function zoomable() {
      return [].slice.call(gallery.querySelectorAll('.product-gallery__item')).filter(function (item) {
        return !item.querySelector('[data-gallery-video]');
      });
    }

    // Mark the gallery items as tappable, but only on mobile and only now that
    // the handler exists. Re-run after a client-side gallery rebuild.
    function markItems() {
      var on = mq.matches;
      zoomable().forEach(function (item) {
        if (on) {
          item.setAttribute('role', 'button');
          item.setAttribute('tabindex', '0');
          item.setAttribute('aria-label', box.dataset.labelZoom || '');
        } else {
          item.removeAttribute('role');
          item.removeAttribute('tabindex');
          item.removeAttribute('aria-label');
        }
      });
    }

    function build() {
      var imgs = zoomable().map(function (item) {
        return item.querySelector('.product-gallery__image');
      }).filter(Boolean);
      resetZoom();
      track.innerHTML = '';
      dots.innerHTML = '';
      imgs.forEach(function (img, i) {
        var slide = document.createElement('div');
        slide.className = 'pg-lightbox__slide';
        // Already-decoded gallery candidate as an instant underlay.
        if (img.currentSrc) slide.style.backgroundImage = 'url("' + img.currentSrc + '")';

        var big = document.createElement('img');
        big.className = 'pg-lightbox__img';
        // Reuse the gallery's q70 ladder; only the slot changes (92vw → 100vw).
        if (img.srcset) big.srcset = img.srcset;
        big.sizes = '100vw';
        big.src = img.currentSrc || img.src;
        big.loading = 'lazy';
        big.decoding = 'async';
        big.alt = img.alt || '';
        slide.appendChild(big);
        track.appendChild(slide);

        var dot = document.createElement('span');
        dot.className = 'pg-lightbox__dot';
        dots.appendChild(dot);
      });
      return imgs.length;
    }

    function paintDots(i) {
      var all = dots.children;
      for (var k = 0; k < all.length; k++) {
        all[k].classList.toggle('pg-lightbox__dot--active', k === i);
      }
      if (status) status.textContent = positionLabel(i, all.length);
    }

    function open(index) {
      if (!mq.matches) return;
      var n = build();
      if (!n) return;
      current = Math.min(Math.max(index, 0), n - 1);
      lastFocus = document.activeElement;
      box.hidden = false;
      document.body.style.overflow = 'hidden';
      // Jump (not smooth-scroll) to the tapped slide before the fade-in, so the
      // overlay never appears mid-travel.
      var prev = track.style.scrollBehavior;
      track.style.scrollBehavior = 'auto';
      track.scrollLeft = current * track.clientWidth;
      track.style.scrollBehavior = prev;
      paintDots(current);
      requestAnimationFrame(function () { box.classList.add('pg-lightbox--open'); });
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      if (box.hidden) return;
      resetZoom();
      box.classList.remove('pg-lightbox--open');
      document.body.style.overflow = '';
      var done = function () {
        box.hidden = true;
        // Drop the large images so a reopen re-clones the CURRENT gallery
        // (Pack/Quantity swaps change it). Cached URLs mean no refetch.
        track.innerHTML = '';
        dots.innerHTML = '';
      };
      setTimeout(done, 200);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }

    // --- open: tap or keyboard on a gallery item ---
    // The mobile gallery is a scroll-snap carousel, so a swipe must not count as
    // a tap. Track pointer travel and bail past a small threshold.
    var downX = 0, downY = 0, moved = false;
    gallery.addEventListener('pointerdown', function (e) {
      downX = e.clientX; downY = e.clientY; moved = false;
    }, { passive: true });
    gallery.addEventListener('pointermove', function (e) {
      if (Math.abs(e.clientX - downX) > 10 || Math.abs(e.clientY - downY) > 10) moved = true;
    }, { passive: true });

    gallery.addEventListener('click', function (e) {
      if (!mq.matches || moved) return;
      var item = e.target.closest('.product-gallery__item');
      if (!item) return;
      // A tap on a video plays it inline in the carousel — the lightbox has
      // nothing to add to it, and swallowing the tap would break playback.
      var i = zoomable().indexOf(item);
      if (i < 0) return;
      open(i);
    });

    gallery.addEventListener('keydown', function (e) {
      if (!mq.matches) return;
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var item = e.target.closest('.product-gallery__item');
      if (!item) return;
      var i = zoomable().indexOf(item);
      if (i < 0) return;
      e.preventDefault();
      open(i);
    });

    // --- close ---
    if (closeBtn) closeBtn.addEventListener('click', close);
    // Scrim tap only: a tap on the image itself must not close.
    box.addEventListener('click', function (e) {
      if (e.target === track || e.target.classList.contains('pg-lightbox__slide')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'Escape') {
        // Zoomed out first, closed second — Escape should undo one step at a time.
        if (z.scale > 1.01) { setZoom(1); return; }
        close();
        return;
      }
      if (e.key === 'Tab') { e.preventDefault(); if (closeBtn) closeBtn.focus(); }
      if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
        e.preventDefault();
        // While zoomed the track is scroll-locked; changing slide would strand the
        // zoom state, so ignore it until the user zooms back out.
        if (z.scale > 1.01) return;
        var n = dots.children.length;
        var next = Math.min(Math.max(current + (e.key === 'ArrowRight' ? 1 : -1), 0), n - 1);
        track.scrollTo({ left: next * track.clientWidth, behavior: 'smooth' });
      }
    });

    // ───────────────────── pinch / double-tap zoom ─────────────────────
    // Custom rather than native: browser pinch scales the VISUAL VIEWPORT, which
    // leaves a position:fixed scrim and close button behind. See the touch-action
    // note in the stylesheet.
    var MAX_SCALE = 3;
    var HI_W = 1792;              // the source images are 1792px wide — beyond
    var HI_H = 2389;              // this the CDN cannot add detail (1792×4/3)
    var HI_Q = 75;
    var z = { slide: null, img: null, scale: 1, tx: 0, ty: 0 };
    var pinch = null;             // { dist, scale, tx, ty, fx, fy }
    var pan = null;               // { x, y, tx, ty }

    function apply() {
      if (!z.img) return;
      z.img.style.transform = 'translate(' + z.tx + 'px,' + z.ty + 'px) scale(' + z.scale + ')';
    }

    function clampPan() {
      if (!z.img) return;
      var w = z.img.offsetWidth, h = z.img.offsetHeight;
      var ox = Math.max(0, (w * z.scale - track.clientWidth) / 2);
      var oy = Math.max(0, (h * z.scale - track.clientHeight) / 2);
      z.tx = Math.min(ox, Math.max(-ox, z.tx));
      z.ty = Math.min(oy, Math.max(-oy, z.ty));
    }

    // Swap in the native-resolution file once the user actually zooms. Preloaded
    // first so the visible image never blanks; srcset must be cleared or it wins
    // over src. ~135 KB (JPEG) / ~75 KB (WebP), on an explicit gesture only.
    function upgrade(img) {
      if (!img || img.dataset.pgHi) return;
      var base = img.currentSrc || img.src;
      if (!base || !/\/cdn\/shop\//.test(base)) return;
      img.dataset.pgHi = '1';
      var url = base
        .replace(/([?&])width=\d+/, '$1width=' + HI_W)
        .replace(/([?&])height=\d+/, '$1height=' + HI_H)
        .replace(/([?&])quality=\d+/, '$1quality=' + HI_Q);
      if (url === base) return;
      var pre = new Image();
      pre.onload = function () { img.srcset = ''; img.removeAttribute('sizes'); img.src = url; };
      pre.src = url;
    }

    function setZoom(scale, slide, img) {
      var was = z.scale;
      z.scale = Math.min(MAX_SCALE, Math.max(1, scale));
      if (slide) { z.slide = slide; z.img = img; }
      if (z.scale <= 1.01) {
        z.scale = 1; z.tx = 0; z.ty = 0;
        if (z.slide) z.slide.classList.remove('pg-lightbox__slide--zoomed');
        track.classList.remove('pg-lightbox__track--locked');
      } else {
        if (z.slide) z.slide.classList.add('pg-lightbox__slide--zoomed');
        track.classList.add('pg-lightbox__track--locked');
        if (was <= 1.01) upgrade(z.img);
      }
      clampPan();
      apply();
    }

    function resetZoom() {
      if (z.img) { z.img.style.transform = ''; }
      if (z.slide) z.slide.classList.remove('pg-lightbox__slide--zoomed');
      track.classList.remove('pg-lightbox__track--locked');
      z = { slide: null, img: null, scale: 1, tx: 0, ty: 0 };
      pinch = null; pan = null;
    }

    function imgOf(target) {
      var img = target && target.closest ? target.closest('.pg-lightbox__img') : null;
      return img ? { img: img, slide: img.parentElement } : null;
    }
    function mid(t) { return { x: (t[0].clientX + t[1].clientX) / 2, y: (t[0].clientY + t[1].clientY) / 2 }; }
    function dist(t) { return Math.hypot(t[0].clientX - t[1].clientX, t[0].clientY - t[1].clientY) || 1; }

    // TOUCH events, not pointer events. With `touch-action: pan-x` the browser can
    // claim a one-finger gesture and fire pointercancel before the second finger
    // lands, which loses the pinch. touchstart reports `touches.length` on the
    // first frame, and a non-passive touchmove can preventDefault the browser's
    // own scroll mid-gesture — so the pinch is never dropped.
    track.addEventListener('touchstart', function (e) {
      var s = imgOf(e.target);
      if (!s) return;
      if (e.touches.length === 2) {
        var r = track.getBoundingClientRect();
        var m = mid(e.touches);
        pinch = {
          dist: dist(e.touches), scale: z.scale, tx: z.tx, ty: z.ty,
          fx: m.x - (r.left + r.width / 2),
          fy: m.y - (r.top + r.height / 2),
        };
        pan = null;
        z.slide = s.slide; z.img = s.img;
        // Take the gesture from the browser now, before it starts a pan-x scroll.
        s.slide.classList.add('pg-lightbox__slide--zoomed');
        track.classList.add('pg-lightbox__track--locked');
      } else if (e.touches.length === 1 && z.scale > 1.01) {
        pan = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: z.tx, ty: z.ty };
      }
    }, { passive: false });

    track.addEventListener('touchmove', function (e) {
      if (pinch && e.touches.length >= 2) {
        var next = Math.min(MAX_SCALE, Math.max(1, pinch.scale * (dist(e.touches) / pinch.dist)));
        // Keep the point under the fingers fixed:
        //   u = (f - t0) / s0   →   t1 = f - s1 * u
        z.tx = pinch.fx - next * ((pinch.fx - pinch.tx) / pinch.scale);
        z.ty = pinch.fy - next * ((pinch.fy - pinch.ty) / pinch.scale);
        var was = z.scale;
        z.scale = next;
        if (was <= 1.01 && next > 1.01) upgrade(z.img);
        clampPan();
        apply();
        e.preventDefault();
        return;
      }
      if (pan && z.scale > 1.01 && e.touches.length === 1) {
        z.tx = pan.tx + (e.touches[0].clientX - pan.x);
        z.ty = pan.ty + (e.touches[0].clientY - pan.y);
        clampPan();
        apply();
        e.preventDefault();
      }
    }, { passive: false });

    function endTouch(e) {
      if (e.touches.length < 2) pinch = null;
      if (e.touches.length === 0) {
        pan = null;
        // Snapped back to fit → hand scrolling back to the track.
        if (z.scale <= 1.01) setZoom(1);
      } else if (e.touches.length === 1 && z.scale > 1.01) {
        // Second finger lifted mid-pinch — continue as a pan from here.
        pan = { x: e.touches[0].clientX, y: e.touches[0].clientY, tx: z.tx, ty: z.ty };
      }
    }
    track.addEventListener('touchend', endTouch);
    track.addEventListener('touchcancel', endTouch);

    // Double-tap toggles 1 ↔ 2, centred on the tap. Standard photo-viewer
    // affordance and the only zoom a one-handed user can reach.
    var lastTap = 0, lastTapX = 0, lastTapY = 0;
    track.addEventListener('click', function (e) {
      var s = imgOf(e.target);
      if (!s) return;
      var now = e.timeStamp;
      var near = Math.abs(e.clientX - lastTapX) < 30 && Math.abs(e.clientY - lastTapY) < 30;
      if (now - lastTap < 300 && near) {
        lastTap = 0;
        if (z.scale > 1.01) { setZoom(1, s.slide, s.img); return; }
        var r = track.getBoundingClientRect();
        var fx = e.clientX - (r.left + r.width / 2);
        var fy = e.clientY - (r.top + r.height / 2);
        z.tx = fx - 2 * fx; z.ty = fy - 2 * fy;   // t1 = f - s1*f  (from s0=1, t0=0)
        setZoom(2, s.slide, s.img);
        return;
      }
      lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY;
    });

    // --- swipe → active dot ---
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = track.clientWidth;
        if (!w) return;
        var i = Math.round(track.scrollLeft / w);
        if (i !== current) { current = i; resetZoom(); paintDots(i); }
      });
    }, { passive: true });

    // --- viewport crossing to desktop: the feature does not exist there ---
    var onChange = function () { markItems(); if (!mq.matches) close(); };
    if (mq.addEventListener) mq.addEventListener('change', onChange);
    else if (mq.addListener) mq.addListener(onChange);

    markItems();
    // The gallery is replaced wholesale by the Pack change and Quantity swap, so
    // re-mark items whenever its children change. Delegated listeners survive
    // (they are on the container), only the ARIA attributes need reapplying.
    new MutationObserver(markItems).observe(gallery, { childList: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-gallery-video"] && !Shopify.designMode) return;
  try {
    (function () {
  var PLAYING = 'product-gallery__video--playing';

  // Only one video at a time. A Shopify-hosted <video> is paused in place (its
  // controls stay, so the shopper can resume); an external <iframe> has no
  // cross-origin pause, so the only way to stop its audio is to remove it —
  // the poster underneath comes back and the play button returns with it.
  function stopOthers(keep) {
    document.querySelectorAll('.' + PLAYING).forEach(function (box) {
      if (box === keep) return;
      var video = box.querySelector('video');
      if (video) { video.pause(); return; }
      var frame = box.querySelector('iframe');
      if (frame) frame.remove();
      box.classList.remove(PLAYING);
    });
  }

  function play(box) {
    var player = box.querySelector('video, iframe');
    stopOthers(box);

    if (!player) {
      var tpl = box.querySelector('[data-gallery-player]');
      if (!tpl) return;
      // Cloned synchronously inside the click handler: the user gesture is still
      // active, so play() may start unmuted and autoplay=1 is honoured.
      box.appendChild(tpl.content.cloneNode(true));
      player = box.querySelector('video, iframe');
      if (!player) return;
    }

    box.classList.add(PLAYING);
    if (player.tagName === 'VIDEO') {
      var started = player.play();
      // A rejected play() is a policy decision, not an error to surface — the
      // native controls are visible either way.
      if (started && started.catch) started.catch(function () {});
    }
  }

  // Delegated on the document: the gallery is rebuilt client-side by the bundle
  // Pack change and the in-page Quantity swap, so a listener bound to the items
  // themselves would not survive.
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var box = e.target.closest('[data-gallery-video]');
    if (!box) return;
    // Once the player is in, its own controls own the click.
    if (e.target.closest('video, iframe')) return;
    if (box.classList.contains(PLAYING)) return;
    e.preventDefault();
    play(box);
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-review-highlights"] && !Shopify.designMode) return;
  try {
    /* Show "Read more" only when the body actually overflows the 3-line clamp,
     then expand inline on click. Also smooth-scrolls the CTA's anchor target. */
  function initReviewReadMore() {
    var bodies = document.querySelectorAll('.review-highlights [data-review-body]');
    for (var i = 0; i < bodies.length; i++) {
      var body = bodies[i];
      if (body.classList.contains('review-highlights__card-body--expanded')) continue;
      var btn = body.parentNode.querySelector('[data-review-read-more]');
      if (!btn) continue;
      btn.hidden = body.scrollHeight <= body.clientHeight + 1;
    }
  }

  if (document.readyState !== 'loading') {
    initReviewReadMore();
  } else {
    document.addEventListener('DOMContentLoaded', initReviewReadMore);
  }
  window.addEventListener('resize', initReviewReadMore);

  document.addEventListener('click', function (e) {
    var readMore = e.target.closest('[data-review-read-more]');
    if (readMore) {
      var card = readMore.closest('.review-highlights__card');
      var body = card && card.querySelector('[data-review-body]');
      if (body) body.classList.add('review-highlights__card-body--expanded');
      readMore.hidden = true;
      return;
    }

    var cta = e.target.closest('[data-review-highlights-cta]');
    if (!cta) return;
    var href = cta.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quick-add-modal"] && !Shopify.designMode) return;
  try {
    (function() {
  var modal = document.getElementById('quick-add-modal');
  if (!modal) return;

  var imgEl = modal.querySelector('[data-qa-img]');
  var titleEl = modal.querySelector('[data-qa-title]');
  var optionsEl = modal.querySelector('[data-qa-options]');
  var oosEl = modal.querySelector('[data-qa-oos]');
  var addBtn = modal.querySelector('[data-qa-add]');
  var notifyBtn = modal.querySelector('[data-qa-notify]');
  var linkEl = modal.querySelector('[data-qa-link]');
  var prevBtn = modal.querySelector('[data-qa-prev]');
  var nextBtn = modal.querySelector('[data-qa-next]');
  var navGroup = modal.querySelector('[data-qa-nav]');
  var tagsSlot = modal.querySelector('[data-qa-tags-slot]');
  var wishlistSlot = modal.querySelector('[data-qa-wishlist-slot]');
  var stripEl = modal.querySelector('[data-qa-strip]');
  var ratingSlot = modal.querySelector('[data-qa-rating-slot]');
  var sgOverlay = null; // per-product overlay injected into document.body

  /* Below this width the modal is the bottom SHEET (Figma 15574:130150): a
     scrolling image strip, a star rating, no wishlist and no gallery arrows.
     Must agree with the @media breakpoint in this snippet's stylesheet. */
  var sheetMq = window.matchMedia('(max-width: 768px)');
  function isSheet() { return sheetMq.matches; }

  // Locale-aware root: '' on the primary locale, '/fr' etc. on secondary ones.
  // Section Rendering API fetches MUST carry it — a bare '/products/…' request is
  // served in the shop's DEFAULT locale, so the injected options block (option
  // names, "Choose a size", Size Guide, badges) comes back untranslated.
  var LOCALE_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');

  function closeSgOverlay() {
    if (!sgOverlay) return;
    sgOverlay.classList.remove('sg-overlay--open');
    sgOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function() { if (sgOverlay) sgOverlay.style.display = 'none'; }, 400);
  }

  function openSgOverlay() {
    if (!sgOverlay) return;
    sgOverlay.style.display = '';
    sgOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    /* rAF so the class lands on a frame AFTER display is cleared — the overlay
       transitions in, and a same-frame class change would skip the transition. */
    requestAnimationFrame(function() {
      sgOverlay.classList.add('sg-overlay--open');
    });
  }

  function bindSgOverlay(overlay) {
    overlay.querySelectorAll('[data-sg-close]').forEach(function(btn) {
      btn.addEventListener('click', closeSgOverlay);
    });
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeSgOverlay();
    });
    var tabs = overlay.querySelectorAll('[data-sg-tab]');
    var panels = overlay.querySelectorAll('[data-sg-panel]');
    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        var target = this.dataset.sgTab;
        tabs.forEach(function(t) { t.classList.remove('sg-modal__tab--active'); });
        this.classList.add('sg-modal__tab--active');
        panels.forEach(function(p) { p.style.display = p.dataset.sgPanel === target ? '' : 'none'; });
      });
    });
    var unitBtns = overlay.querySelectorAll('[data-sg-unit]');
    var unitTables = overlay.querySelectorAll('[data-sg-table]');
    unitBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var unit = this.dataset.sgUnit;
        unitBtns.forEach(function(b) { b.classList.remove('sg-modal__unit--active'); });
        this.classList.add('sg-modal__unit--active');
        unitTables.forEach(function(t) { t.style.display = t.dataset.sgTable === unit ? '' : 'none'; });
      });
    });
  }

  // Delegate the Size Guide button click inside the quick-add modal
  modal.addEventListener('click', function(e) {
    var openBtn = e.target.closest('[data-sg-open]');
    if (openBtn && modal.contains(openBtn)) {
      e.preventDefault();
      e.stopPropagation();
      openSgOverlay();
    }
  });

  // Combined-listing switch: clicking an option value that points to another
  // product (e.g. Fit → Classic) re-loads that product into the same modal
  // instead of navigating to its PDP. Modifier-click / middle-click still
  // follow the <a href> for normal new-tab behavior.
  modal.addEventListener('click', function(e) {
    if (e.defaultPrevented) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button === 1) return;
    var switchEl = e.target.closest('[data-qa-switch-handle]');
    if (!switchEl || !modal.contains(switchEl)) return;
    var handle = switchEl.getAttribute('data-qa-switch-handle');
    if (!handle) return;
    e.preventDefault();
    e.stopPropagation();
    window.__openQuickAdd(handle);
  });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && sgOverlay && sgOverlay.classList.contains('sg-overlay--open')) {
      closeSgOverlay();
    }
  });

  var variants = [];
  var optionNames = [];
  var selectedOptions = {};
  var productUrl = '';
  var images = [];
  var imageIndex = 0;
  var imageAlt = '';
  var tagsHtml = '';       // badge markup, re-used by the sheet's first strip cell
  var ratingToken = 0;     // guards a slow rating response from painting the wrong product
  /* Same three guards as cart-drawer's detail screen (see the note there,
     2026-09-04): only the latest open may paint, sibling switches render from a
     short-lived cache instead of re-fetching, and a load that still fails after
     retries never shows the shopper an error — it falls back to the product
     that was on screen, or to the product page. */
  var loadToken = 0;
  var sectionCache = {};
  var SECTION_CACHE_TTL = 5 * 60 * 1000;
  var lastGoodHandle = '';

  function fetchSection(url, attempt) {
    attempt = attempt || 1;
    return fetch(url).then(function(r) {
      if (r.status === 429 && attempt < 3) {
        var ra = parseInt(r.headers.get('Retry-After'), 10);
        var wait = isNaN(ra) ? 1500 * attempt : Math.min(ra * 1000, 3000);
        return new Promise(function(res) { setTimeout(res, wait); }).then(function() {
          return fetchSection(url, attempt + 1);
        });
      }
      if (!r.ok) throw new Error('HTTP ' + r.status + ' ' + url);
      return r;
    }, function(err) {
      if (attempt < 3) {
        return new Promise(function(res) { setTimeout(res, 1500 * attempt); }).then(function() {
          return fetchSection(url, attempt + 1);
        });
      }
      throw err;
    });
  }

  function recoverLoad(token, handle) {
    if (token !== loadToken) return;
    if (lastGoodHandle && lastGoodHandle !== handle && sectionCache[lastGoodHandle]) {
      window.__openQuickAdd(lastGoodHandle);
      return;
    }
    modal.classList.remove('qa-modal--loading');
    closeModal();
    window.location.href = LOCALE_ROOT + '/products/' + handle;
  }

  function normalizeImageSrc(src) {
    if (!src) return '';
    return src.split('?')[0].replace(/_\d+x\d*\.(jpg|jpeg|png|webp|gif)/i, '.$1');
  }

  function escapeAttr(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/"/g, '&quot;')
      .replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function showImageAt(idx) {
    if (!images.length) return;
    imageIndex = (idx + images.length) % images.length;
    imgEl.src = images[imageIndex];
  }

  /* Paints ONE breakpoint's gallery and blanks the other's. Both are in the DOM
     (CSS picks which is visible), but a `display: none` <img> with a src is still
     fetched — so leaving both populated would cost a phone the 500px desktop crop
     and a desktop the entire gallery. */
  function renderPhotos() {
    if (isSheet()) {
      imgEl.removeAttribute('src');
      if (!stripEl) return;
      var cells = '';
      for (var i = 0; i < images.length; i++) {
        cells += '<div class="qa-modal__strip-cell">' +
          '<img class="qa-modal__strip-img" src="' + escapeAttr(images[i]) + '"' +
          ' alt="' + escapeAttr(imageAlt) + '" width="172" height="229"' +
          ' loading="' + (i === 0 ? 'eager' : 'lazy') + '">' +
          (i === 0 ? '<div class="qa-modal__strip-tags">' + tagsHtml + '</div>' : '') +
          '</div>';
      }
      stripEl.innerHTML = cells;
      stripEl.scrollLeft = 0;
    } else {
      if (stripEl) stripEl.innerHTML = '';
      if (images.length) showImageAt(imageIndex);
    }
    syncNavVisibility();
  }

  /* Move the gallery to a specific image: the desktop column swaps its src, the
     sheet scrolls that cell into view (its 12px inset is preserved). */
  function focusImage(idx) {
    if (idx < 0 || idx >= images.length) return;
    imageIndex = idx;
    if (isSheet()) {
      var cell = stripEl && stripEl.children[idx];
      if (cell) stripEl.scrollTo({ left: Math.max(0, cell.offsetLeft - 12), behavior: 'smooth' });
    } else {
      imgEl.src = images[idx];
    }
  }

  function syncNavVisibility() {
    if (navGroup) navGroup.style.display = images.length > 1 ? '' : 'none';
  }

  /* Rotating the phone (or resizing a narrow desktop window) crosses the
     breakpoint, so the now-visible gallery has to be built. */
  function onSheetMqChange() { if (modal.open) renderPhotos(); }
  if (sheetMq.addEventListener) sheetMq.addEventListener('change', onSheetMqChange);
  else if (sheetMq.addListener) sheetMq.addListener(onSheetMqChange);

  function starSvg(filled) {
    return '<svg width="14" height="14" viewBox="0 0 14 14" fill="' +
      (filled ? 'currentColor' : '#dddbdc') + '" aria-hidden="true">' +
      '<path d="M7 0.56l1.79 4.14 4.46.36c.54.04.66.38.24.74L10.1 8.62l1.08 4.56c.13.54-.15.74-.63.44L7 11.22l-3.55 2.4c-.48.3-.76.1-.63-.44l1.08-4.56L.51 5.8c-.42-.36-.3-.7.24-.74l4.46-.36L7 0.56z"/></svg>';
  }

  /* Star rating for the sheet. Shares window.__okendoAggP with
     snippets/okendo-star-rating, so a PDP that already fetched this product's
     aggregate is not asked again. The review count is plain text, not the PDP's
     anchor — there is no reviews section inside the sheet to scroll to. */
  function renderRating(productId) {
    if (!ratingSlot) return;
    ratingSlot.innerHTML = '';
    var token = ++ratingToken;
    if (!productId || !isSheet()) return;
    var storeId = window.okendoSubscriberId && window.okendoSubscriberId();
    if (!storeId) return;

    window.__okendoAggP = window.__okendoAggP || {};
    if (!window.__okendoAggP[productId]) {
      window.__okendoAggP[productId] = fetch('https://api.okendo.io/v1/stores/' + storeId +
        '/products/' + productId + '/review_aggregate')
        .then(function(r) { return r.json(); })
        .then(function(d) {
          var agg = d && d.reviewAggregate;
          return agg && agg.reviewCount ? agg : null;
        })
        .catch(function() { return null; });
    }

    window.__okendoAggP[productId].then(function(agg) {
      // A different product (or breakpoint) took over while this was in flight.
      if (token !== ratingToken || !agg || !isSheet()) return;
      var cfg = window.__quickAddCfg || {};
      var avg = agg.reviewRatingValuesTotal / agg.reviewCount;
      var rounded = Math.round(avg);
      var stars = '';
      for (var i = 1; i <= 5; i++) stars += starSvg(i <= rounded);
      var phrase = (agg.reviewCount === 1 ? cfg.reviewCountOne : cfg.reviewCountOther) || '%%N%%';
      ratingSlot.innerHTML = '<div class="okendo-star-rating">' +
        '<div class="okendo-star-rating__stars">' + stars + '</div>' +
        '<span class="okendo-star-rating__count">' +
          '<span class="okendo-star-rating__avg">' + avg.toFixed(1) + '</span>' +
          '<span class="okendo-star-rating__reviews">(' +
            escapeAttr(phrase.replace('%%N%%', agg.reviewCount)) + ')</span>' +
        '</span>' +
      '</div>';
    });
  }

  if (prevBtn) prevBtn.addEventListener('click', function() { showImageAt(imageIndex - 1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { showImageAt(imageIndex + 1); });

  // Close handlers
  modal.querySelectorAll('[data-qa-close]').forEach(function(el) {
    el.addEventListener('click', function() { closeModal(); });
  });
  modal.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeModal();
  });

  function closeModal() {
    modal.close();
    /* BUG-BV-51: clear the busy flag on close as well. Closing mid-fetch (backdrop tap
       or Escape) otherwise leaves the class set, and the NEXT open would flash the
       previous product's finished content before the placeholder went back up. */
    modal.classList.remove('qa-modal--loading');
    document.documentElement.style.overflow = '';
    if (sgOverlay && sgOverlay.parentNode) { sgOverlay.parentNode.removeChild(sgOverlay); }
    sgOverlay = null;
  }

  var moneyFormat = modal.dataset.moneyFormat || ('$' + '{' + '{amount}}');

  /* Delegates to the shared formatter (snippets/money-format): it derives the
     separators from a Liquid-rendered sample, so it matches the server-rendered
     prices in every currency and carries the ambiguous-currency ISO suffix.

     The local path is a degradation route only, and it is knowingly broken for the
     separator variants: it substitutes only the plain amount placeholder, so in a
     Eurozone context Shopify's format string came through literally
     (the placeholder name is omitted from this comment on purpose — Liquid renders
     inside JS comments too and would treat it as an undefined object). */
  function formatMoney(cents) {
    if (window.BonvaleMoney) return window.BonvaleMoney.format(cents);
    var amount = (cents / 100).toFixed(2);
    var parts = amount.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var noDecimals = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return moneyFormat
      .replace(/\{\{\s*amount\s*\}\}/g, withDecimals)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, noDecimals);
  }

  function findVariant() {
    return variants.find(function(v) {
      return optionNames.every(function(_, i) {
        return v.options[i] === selectedOptions[i];
      });
    });
  }

  // QA #1: every required option (real Size — data-option-required) must be chosen
  // before Add-to-bag is enabled, matching the PDP. Combined-listing options aren't
  // flagged required (they're pre-selected), so they don't block the button.
  function requiredOptionsChosen() {
    var reqs = optionsEl.querySelectorAll('[data-option-required="true"]');
    for (var i = 0; i < reqs.length; i++) {
      var idx = parseInt(reqs[i].dataset.optionIndex);
      if (selectedOptions[idx] == null || selectedOptions[idx] === '') return false;
    }
    return true;
  }

  // Single place that decides the CTA state so init + every option change agree.
  function updateAddState() {
    // Not all required options chosen yet → Add stays visible AND clickable so
    // the tap can answer with the validation state (showRequiredOptionErrors),
    // no OOS/notify noise.
    if (!requiredOptionsChosen()) {
      addBtn.disabled = false;
      addBtn.style.display = '';
      notifyBtn.style.display = 'none';
      oosEl.style.display = 'none';
      return;
    }
    addBtn.disabled = false;
    var match = findVariant();
    if (match && match.available) {
      addBtn.style.display = '';
      notifyBtn.style.display = 'none';
      oosEl.style.display = 'none';
    } else if (match) {
      addBtn.style.display = 'none';
      notifyBtn.style.display = '';
      oosEl.style.display = '';
    } else {
      // Chosen combination doesn't resolve to a variant — keep Add hidden.
      addBtn.style.display = 'none';
      notifyBtn.style.display = 'none';
      oosEl.style.display = 'none';
    }
  }

  // Global open function — uses Section Rendering API for server-rendered options
  window.__openQuickAdd = function(handle) {
    modal.showModal();
    /* BUG-BV-51 (H5): everything below arrives in one fetch, so mark the sheet busy
       until it lands. The placeholder keeps the panel at its final size, and removing
       this class is the single commit that reveals the finished content. */
    modal.classList.add('qa-modal--loading');
    document.documentElement.style.overflow = 'hidden';
    optionsEl.innerHTML = '';
    titleEl.textContent = '';
    imgEl.removeAttribute('src');
    imgEl.alt = '';
    if (tagsSlot) tagsSlot.innerHTML = '';
    if (wishlistSlot) wishlistSlot.innerHTML = '';
    if (stripEl) stripEl.innerHTML = '';
    if (ratingSlot) ratingSlot.innerHTML = '';
    ratingToken++;
    if (sgOverlay && sgOverlay.parentNode) { sgOverlay.parentNode.removeChild(sgOverlay); }
    sgOverlay = null;
    images = [];
    imageIndex = 0;
    imageAlt = '';
    tagsHtml = '';
    syncNavVisibility();
    oosEl.style.display = 'none';
    addBtn.style.display = '';
    notifyBtn.style.display = 'none';

    var token = ++loadToken;
    var cached = sectionCache[handle];
    if (cached && Date.now() - cached.at < SECTION_CACHE_TTL) {
      renderProduct(token, handle, cached.html);
      return;
    }

    // Fetch section-rendered HTML (includes Liquid-rendered swatches, groups, metaobject colors)
    fetchSection(LOCALE_ROOT + '/products/' + handle + '?section_id=quick-add-options')
      .then(function(r) { return r.text(); })
      .then(function(html) {
        if (token !== loadToken) return;
        if (html.indexOf('data-qa-product-json') === -1) throw new Error('quick-add-options: no product root for ' + handle);
        sectionCache[handle] = { html: html, at: Date.now() };
        renderProduct(token, handle, html);
      })
      .catch(function(err) {
        console.error('Quick add error:', err);
        recoverLoad(token, handle);
      });
  };

  function renderProduct(token, handle, html) {
    if (token !== loadToken) return;
    try {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        var root = tmp.querySelector('[data-qa-product-json]');
        if (!root) throw new Error('quick-add-options: no product root for ' + handle);

        // Extract product data
        productUrl = root.dataset.productUrl;
        titleEl.textContent = root.dataset.productTitle;
        linkEl.href = productUrl;
        imgEl.alt = root.dataset.productTitle;
        imageAlt = root.dataset.productTitle;

        // Server-rendered tags. Read BEFORE the gallery is painted: on mobile the
        // badges live inside the strip's first cell, so renderPhotos() needs them.
        var tagsBlock = tmp.querySelector('.qa-options__tags');
        tagsHtml = tagsBlock ? tagsBlock.innerHTML : '';
        if (tagsSlot) tagsSlot.innerHTML = tagsHtml;   // desktop: top-left of the photo

        // Parse image gallery — fall back to featured image if array missing/empty
        var imagesJson = tmp.querySelector('[data-qa-images]');
        try { images = imagesJson ? JSON.parse(imagesJson.textContent) : []; } catch (_) { images = []; }
        if (!images.length && root.dataset.productImage) images = [root.dataset.productImage];
        imageIndex = 0;
        renderPhotos();

        // Star rating (mobile sheet only) — see renderRating.
        var ratingNode = tmp.querySelector('[data-qa-rating-product-id]');
        renderRating(ratingNode ? ratingNode.getAttribute('data-qa-rating-product-id') : '');

        // Inject server-rendered wishlist button (top-right)
        var wishlistBlock = tmp.querySelector('.qa-options__wishlist');
        if (wishlistSlot && wishlistBlock) {
          wishlistSlot.innerHTML = wishlistBlock.innerHTML;
          if (window.Wishlist) window.Wishlist.updateAll();
        }

        // Extract per-product size-guide overlay (if the product has one) and append to body.
        // Uses a marker attribute so we can clean it up on next open.
        var sgFromFetch = tmp.querySelector('.sg-overlay');
        if (sgFromFetch) {
          sgFromFetch.setAttribute('data-qa-sg-injected', '');
          sgFromFetch.style.display = 'none';
          modal.appendChild(sgFromFetch);
          sgOverlay = sgFromFetch;
          bindSgOverlay(sgOverlay);
        }

        // Parse variants and options from embedded JSON
        var variantsJson = tmp.querySelector('[data-qa-variants]');
        var optionsJson = tmp.querySelector('[data-qa-options-json]');
        variants = variantsJson ? JSON.parse(variantsJson.textContent) : [];
        optionNames = optionsJson ? JSON.parse(optionsJson.textContent) : [];

        // Extract server-rendered price
        var priceHtml = tmp.querySelector('.qa-options__prices');

        // Extract server-rendered option pickers (swatches, size buttons — with correct colors & groups).
        // .product-info__hidden-option carries a suppressed combined-listing duplicate Color's selected
        // value so findVariant() and the availability query still receive its option value id.
        var optionPickers = tmp.querySelectorAll('.product-info__colors, .product-info__sizes, .product-info__hidden-option');

        // Insert price into modal
        var modalPriceSlot = modal.querySelector('[data-qa-price-slot]');
        if (modalPriceSlot && priceHtml) {
          modalPriceSlot.innerHTML = '';
          modalPriceSlot.appendChild(priceHtml);
        }

        // Insert option pickers into modal
        optionsEl.innerHTML = '';
        optionPickers.forEach(function(picker) {
          optionsEl.appendChild(picker);
        });

        // Init selected options from active buttons
        selectedOptions = {};
        optionsEl.querySelectorAll('.product-info__color-swatch--active, .product-info__size-btn--active').forEach(function(btn) {
          selectedOptions[parseInt(btn.dataset.optionIndex)] = btn.dataset.optionValue;
        });

        // Bind option click handlers
        optionsEl.querySelectorAll('[data-option-value]').forEach(function(btn) {
          btn.addEventListener('click', function() {
            selectedOptions[parseInt(this.dataset.optionIndex)] = this.dataset.optionValue;
            var errContainer = this.closest('.product-info__sizes--error');
            if (errContainer) errContainer.classList.remove('product-info__sizes--error');
            updateState();
          });
        });

        // Set initial CTA state (required size not chosen yet → Add stays clickable
        // and validates on click, exactly like the PDP).
        updateAddState();

        /* BUG-BV-51 (H5): LAST statement of the success path on purpose — title, price,
           gallery strip, option pickers and the CTA state are all in place by now, so
           the shopper goes straight from placeholder to finished sheet with no
           intermediate paint. Anything added after this point must go ABOVE it. */
        modal.classList.remove('qa-modal--loading');
        lastGoodHandle = handle;
    } catch (err) {
      console.error('Quick add render error:', err);
      delete sectionCache[handle];
      recoverLoad(token, handle);
    }
  }

  // Paint what the shopper has picked so far. Reads `selectedOptions` only — never a
  // resolved variant — so it is safe to call with an incomplete or unresolvable
  // selection. See the note in updateState().
  function reflectSelection() {
    // Update active states
    optionsEl.querySelectorAll('[data-option-value]').forEach(function(btn) {
      var idx = parseInt(btn.dataset.optionIndex);
      var val = btn.dataset.optionValue;
      var isActive = selectedOptions[idx] === val;
      if (btn.classList.contains('product-info__color-swatch')) {
        btn.classList.toggle('product-info__color-swatch--active', isActive);
      }
      if (btn.classList.contains('product-info__size-btn')) {
        btn.classList.toggle('product-info__size-btn--active', isActive);
      }
    });

    // Update color value display (grouped)
    var colorContainer = optionsEl.querySelector('[data-option-type="color"]');
    if (colorContainer) {
      var colorIdx = parseInt(colorContainer.dataset.optionIndex);
      var colorGroups = colorContainer.querySelectorAll('[data-color-group]');
      if (colorGroups.length > 0) {
        var selectedColor = selectedOptions[colorIdx] || '';
        var activeBtn = colorContainer.querySelector('.product-info__color-swatch--active');
        var activeGroup = activeBtn ? activeBtn.dataset.colorGroup : '';
        colorContainer.querySelectorAll('.product-info__color-group').forEach(function(grp) {
          var grpName = grp.dataset.colorGroup;
          var valEl = grp.querySelector('[data-color-value]');
          if (grpName === activeGroup) {
            if (valEl) {
              valEl.textContent = selectedColor;
            } else {
              var label = grp.querySelector('.product-info__option-label');
              if (label) {
                valEl = document.createElement('span');
                valEl.className = 'product-info__option-value';
                valEl.setAttribute('data-color-value', grpName);
                valEl.textContent = selectedColor;
                label.appendChild(valEl);
              }
            }
          } else {
            if (valEl) valEl.remove();
          }
        });
      } else {
        var colorValueEl = colorContainer.querySelector('[data-color-value]');
        if (colorValueEl) colorValueEl.textContent = selectedOptions[parseInt(colorContainer.dataset.optionIndex)] || '';
      }
    }

    // Update non-color option value display. With nothing chosen yet, fall back to the
    // "Choose a size" placeholder the section rendered rather than blanking the caption.
    optionsEl.querySelectorAll('[data-option-type="size"]').forEach(function(container) {
      var optIdx = parseInt(container.dataset.optionIndex);
      var valueEl = container.querySelector('[data-size-value]');
      if (!valueEl) return;
      var sel = selectedOptions[optIdx];
      if (sel) {
        valueEl.textContent = sel;
      } else if (!container.classList.contains('product-info__sizes--error')) {
        valueEl.textContent = valueEl.dataset.placeholder || '';
      }
    });
  }

  // Add To Bag tapped with a required option unchosen: same feedback as the PDP
  // (sections/product.liquid) — the Size caption turns into the red "Please
  // select a size" and the size chips get the red border, via the shared
  // .product-info__sizes--error state. Cleared the moment a chip is picked.
  // Before this the button was simply disabled, so the tap did nothing at all
  // (Lawrence, bonvale.de quick add for the socks 3-pack, 2026-09-08).
  function showRequiredOptionErrors() {
    var first = null;
    optionsEl.querySelectorAll('[data-option-required="true"]').forEach(function(container) {
      var idx = parseInt(container.dataset.optionIndex);
      if (selectedOptions[idx] != null && selectedOptions[idx] !== '') return;
      container.classList.add('product-info__sizes--error');
      var valEl = container.querySelector('[data-size-value]');
      if (valEl && valEl.dataset.error) valEl.textContent = valEl.dataset.error;
      if (!first) first = container;
    });
    if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function updateState() {
    var match = findVariant();

    // QA BUG-BV-01: reflect the shopper's selection BEFORE the no-variant bail-out.
    // Highlighting, the colour caption and the size caption depend only on
    // `selectedOptions`, never on a resolved variant — so they must run even when the
    // combination is still incomplete (a 3-Pack opens with BOTH "Pack" and "Size"
    // unselected) or can never resolve at all (the socks 3-Pack carries two options
    // named "Color"; only index 0 gets a picker, so index 1 is never set and
    // findVariant() never matches). Leaving these behind the guard made every click
    // a no-op with zero feedback. Price/image/availability DO need the variant and
    // stay below.
    reflectSelection();

    // Add to cart / Notify me — gated on all required options being chosen (QA #1).
    // Also above the bail-out: it already has a branch for "combination doesn't resolve
    // to a variant", which could never be reached while it ran below the guard.
    updateAddState();

    if (!match) return;

    // Update price
    var priceEl = modal.querySelector('[data-qa-price]');
    var compareEl = modal.querySelector('[data-qa-compare]');
    if (priceEl) priceEl.textContent = formatMoney(match.price);
    /* When competitor data exists the compare slot holds the TRADITIONAL RETAIL
       reference, which is per-product and must not be rewritten to the variant's
       compare_at (or hidden when there isn't one) — only the savings percentage
       moves with the variant price. Falls through to the old compare_at
       behaviour for products with no compare_data metafield. */
    var pricesEl = modal.querySelector('.qa-options__prices');
    var retailCents = pricesEl ? parseInt(pricesEl.dataset.qaRetailCents, 10) : 0;
    if (retailCents > 0) {
      var pctEl = modal.querySelector('[data-qa-savings-pct]');
      if (pctEl) pctEl.textContent = Math.round((retailCents - match.price) / retailCents * 100) + '%';
    } else if (compareEl) {
      if (match.compare_at_price && match.compare_at_price > match.price) {
        compareEl.textContent = formatMoney(match.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }

    // Update image — align gallery index with variant's featured image if present
    if (match.featured_image) {
      var imgSrc = typeof match.featured_image === 'string' ? match.featured_image : match.featured_image.src;
      if (imgSrc) {
        var sized = imgSrc.replace(/\.([^.]+)$/, '_800x.$1');
        var needle = normalizeImageSrc(sized);
        var matchIdx = -1;
        for (var i = 0; i < images.length; i++) {
          if (normalizeImageSrc(images[i]) === needle) { matchIdx = i; break; }
        }
        if (matchIdx >= 0) {
          focusImage(matchIdx);
        } else if (!isSheet()) {
          /* The variant image isn't in the gallery array, so there is no strip
             cell to scroll to — the desktop column can still show it directly. */
          imgEl.src = sized;
        }
      }
    }

    // Fetch fresh availability via section rendering API
    var optionValueIds = [];
    optionsEl.querySelectorAll('[data-option-value]').forEach(function(btn) {
      var idx = parseInt(btn.dataset.optionIndex);
      if (btn.dataset.optionValueId && selectedOptions[idx] === btn.dataset.optionValue) {
        optionValueIds.push(btn.dataset.optionValueId);
      }
    });
    var sectionUrl = productUrl + '?variant=' + match.id +
      (optionValueIds.length > 0 ? '&option_values=' + optionValueIds.join(',') : '') +
      '&section_id=quick-add-options';
    fetch(sectionUrl)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var tmp = document.createElement('div');
        tmp.innerHTML = html;

        // Sync color swatch soldout states
        tmp.querySelectorAll('.product-info__color-swatch').forEach(function(freshBtn) {
          var val = freshBtn.dataset.optionValue;
          var liveBtn = optionsEl.querySelector('.product-info__color-swatch[data-option-value="' + val + '"]');
          if (liveBtn) {
            liveBtn.classList.toggle('product-info__color-swatch--soldout',
              freshBtn.classList.contains('product-info__color-swatch--soldout'));
          }
        });

        // Sync size button soldout states
        tmp.querySelectorAll('.product-info__size-btn').forEach(function(freshBtn) {
          var idx = freshBtn.dataset.optionIndex;
          var val = freshBtn.dataset.optionValue;
          var liveBtn = optionsEl.querySelector('.product-info__size-btn[data-option-index="' + idx + '"][data-option-value="' + val + '"]');
          if (liveBtn) {
            var isSoldout = freshBtn.classList.contains('product-info__size-btn--soldout');
            liveBtn.classList.toggle('product-info__size-btn--soldout', isSoldout);
            var strike = liveBtn.querySelector('.product-info__size-strikethrough');
            if (isSoldout && !strike) {
              strike = document.createElement('span');
              strike.className = 'product-info__size-strikethrough';
              strike.setAttribute('aria-hidden', 'true');
              liveBtn.appendChild(strike);
            } else if (!isSoldout && strike) {
              strike.remove();
            }
          }
        });
      })
      .catch(function() {});
  }

  // Add to cart
  addBtn.addEventListener('click', function() {
    if (addBtn.disabled) return;
    if (!requiredOptionsChosen()) { showRequiredOptionErrors(); return; }
    var match = findVariant();
    if (!match || !match.available) return;

    addBtn.classList.add('is-loading');
    fetch(LOCALE_ROOT + '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: match.id, quantity: 1 }] })
    })
    .then(function(res) {
      if (!res.ok) throw new Error('Failed');
      return res.json();
    })
    .then(function() {
      closeModal();

      /* On /cart the shopper is already looking at their bag, so sliding the
         drawer over it showed a second copy of the same list and left them one
         extra dismiss away from the page they were on. Re-render the cart page
         in place instead — the same section swap its quantity controls use — and
         leave the drawer shut. __refreshCartPage is defined by sections/cart
         only when the cart root is on the page, so its presence IS the "am I on
         the cart page" test. (Quick-adds started from INSIDE an open drawer never
         reach here: cart-drawer re-points window.__openQuickAdd at its own
         in-drawer detail screen while the drawer is open.) */
      if (window.__refreshCartPage) {
        window.__refreshCartPage();
      } else if (window.__openCartDrawer) {
        /* The drawer shows the new line itself, and updates the badge. */
        window.__openCartDrawer();
        return;
      }

      /* Cart page and drawerless pages both land here: nothing on screen
         announces the add on its own — on /cart the new line goes to the top of
         the bag, which is usually scrolled out of view above the
         recommendations — and the swap re-renders #cdp only, so the header badge
         still needs the count. */
      window.__showQuickAddToast((window.__quickAddCfg || {}).addedToCart);
      /* QA #12: reuse the single badge writer when present so the count stays
         consistent with the drawer; fall back to a direct write if the drawer
         script isn't on this page. */
      fetch(LOCALE_ROOT + '/cart.js').then(function(r) { return r.json(); }).then(function(cart) {
        if (window.__setCartCount) {
          window.__setCartCount(cart.item_count);
        } else {
          document.querySelectorAll('[data-cart-count]').forEach(function(el) {
            el.textContent = cart.item_count;
            el.style.display = cart.item_count > 0 ? '' : 'none';
          });
          document.querySelectorAll('[data-cart-link]').forEach(function(el) {
            var label = el.getAttribute('data-cart-label') || '';
            el.setAttribute('aria-label', label + ' (' + cart.item_count + ')');
          });
        }
      });
    })
    .catch(function() {
      window.__showQuickAddToast((window.__quickAddCfg || {}).addFailed, true);
    })
    .finally(function() {
      addBtn.classList.remove('is-loading');
    });
  });

  // Notify me — navigate to PDP with variant
  notifyBtn.addEventListener('click', function() {
    var match = findVariant();
    var url = linkEl.href;
    if (match) url += (url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + match.id;
    window.location.href = url;
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["region-detect"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.BonvaleRegion) return;

    // Single preference key shared by popup + switchers (fixes the legacy bug
    // where switchers wrote no silence key). The Shopify localization cookie is
    // the source of truth for what renders; this records that the visitor made
    // an explicit choice + the chosen values. `locale` carries a real value from
    // M2 onwards (it was reserved-but-null in v1.1); a null locale on an
    // existing preference means "chosen before M2 shipped, language never
    // decided" — see decideAutoLocale.
    var PREF_KEY = 'bonvale_region_pref_v1';
    // Session dismissal key (layer 2/3). Set when the popup is shown/dismissed
    // this session; a new session can prompt again.
    var SEEN_KEY = 'bonvale_region_seen_session_v1';
    // Legacy key written by the pre-M3 popup's SHOP NOW/CONFIRM. Visitors who
    // already confirmed there must NOT be re-prompted, so it counts as a
    // manual choice until they make a new one.
    var LEGACY_CONFIRMED_KEY = 'bonvale_geo_confirmed_v1';

    function readData() {
      try {
        var el = document.getElementById('bonvale-region-data');
        return el ? JSON.parse(el.textContent) : null;
      } catch (e) { return null; }
    }

    // M2 language island (`language-options`). Absent = single-language store:
    // every language helper below degrades to "English only, nothing to do",
    // which is exactly the pre-M2 behaviour.
    function readLangData() {
      try {
        var el = document.getElementById('bonvale-language-data');
        return el ? JSON.parse(el.textContent) : null;
      } catch (e) { return null; }
    }

    function getPreference() {
      try {
        var raw = localStorage.getItem(PREF_KEY);
        if (raw) return JSON.parse(raw);
        // Legacy fallback: treat a pre-M3 confirmation as a manual choice for
        // the country that is currently selected (the one they confirmed).
        if (localStorage.getItem(LEGACY_CONFIRMED_KEY)) {
          return { country: null, currency: null, locale: null, legacy: true };
        }
        return null;
      } catch (e) { return null; }
    }
    function hasPreference() { return !!getPreference(); }
    function setPreference(pref) {
      try {
        localStorage.setItem(PREF_KEY, JSON.stringify({
          country: pref.country || null,
          currency: pref.currency || null,
          locale: pref.locale || null,
          ts: Date.now()
        }));
      } catch (e) {}
    }

    function seenThisSession() {
      try { return sessionStorage.getItem(SEEN_KEY) === '1'; } catch (e) { return false; }
    }
    function markSeenThisSession() {
      try { sessionStorage.setItem(SEEN_KEY, '1'); } catch (e) {}
    }

    // Search-engine crawlers: never detect/prompt (protects SEO/hreflang).
    function isBot() {
      var ua = navigator.userAgent || '';
      return /bot|crawler|spider|crawling|slurp|bingpreview|facebookexternalhit|embedly|quora link preview|pinterest|vkshare|whatsapp|telegrambot/i.test(ua);
    }

    function currentCountry() {
      if (window.Shopify && window.Shopify.country) return String(window.Shopify.country).toUpperCase();
      var data = readData();
      return data && data.current ? data.current.country : null;
    }
    function currencyFor(iso) {
      var data = readData();
      var list = (data && data.sellable) || [];
      var match = list.filter(function (c) { return c.country === iso; })[0];
      return match ? match.currency : null;
    }

    // ── Language (M2) ────────────────────────────────────────────────────
    // The candidate ORDER for a country is NOT available from Shopify:
    // `country.available_languages` is scoped to the country's MARKET, and all
    // 45 ROW countries share one market, so it returns the same list for every
    // one of them. The per-country map therefore lives in `language-options`.
    // That same object IS the availability filter, though — see localesFor.

    function primaryLocale() {
      var d = readLangData();
      return (d && d.primary) || 'en';
    }

    function currentLocale() {
      var d = readLangData();
      if (d && d.current) return d.current;
      if (window.Shopify && window.Shopify.locale) return window.Shopify.locale;
      return primaryLocale();
    }

    // Every locale reachable from this page, as a code -> object map (endonym,
    // name, root). The island emits the UNION of the current presence's
    // languages and each country's market languages — the current presence's
    // list alone is NOT enough: on the Australia presence it is just [en], so
    // filtering through it locked the popup's language row to English for
    // every country (Canada could not offer Français — prod bug 2026-08-10).
    function availableLocales() {
      var d = readLangData();
      var out = {};
      var list = (d && d.available) || [];
      for (var i = 0; i < list.length; i++) out[list[i].code] = list[i];
      return out;
    }

    // Candidate languages for a country, default first, English last.
    // A candidate is offered only when BOTH hold:
    //   - it is in `available` (union above) — a locale listed in the map but
    //     not yet enabled by the app-side rollout must never be offered, or
    //     the shopper gets a choice that does nothing;
    //   - the TARGET country's own market carries it (`country_languages`) —
    //     what matters is where the shopper is going, not which presence this
    //     page happens to be rendered for. An island without the field (or a
    //     country missing from it) skips this gate rather than offering
    //     nothing.
    function localesFor(iso) {
      var d = readLangData();
      if (!d) return [];
      var avail = availableLocales();
      var country = String(iso || '').toUpperCase();
      var mapped = (d.countries && d.countries[country]) || [];
      var market = (d.country_languages && d.country_languages[country]) || null;
      var out = [];
      var seen = {};

      function offered(code) {
        if (!avail[code]) return false;
        if (market && market.indexOf(code) === -1) return false;
        return true;
      }

      // Mapped candidates first — position 0 IS the country's default
      // (defaultLocaleFor reads list[0]), so nothing may be inserted ahead of
      // them without silently rewriting the PRD's per-country default table.
      for (var i = 0; i < mapped.length; i++) {
        var code = mapped[i];
        if (offered(code) && !seen[code]) { seen[code] = 1; out.push(avail[code]); }
      }

      // The language the page is ACTUALLY rendered in always belongs in the
      // list for the country the page is rendered for — even when the map does
      // not associate the two. Without this, a visitor reading in French from
      // an unmapped country is offered only English, and confirming the popup
      // switches them out of the language they were reading, unasked.
      //
      // APPENDED, not prepended: being on screen makes a language available,
      // not default. Scoped to the current country on purpose — French has no
      // business appearing under Japan just because the visitor is on /fr.
      if (country && country === currentCountry()) {
        var cur = currentLocale();
        if (offered(cur) && !seen[cur]) { seen[cur] = 1; out.push(avail[cur]); }
      }
      // Always offer the primary locale as a way back (LOC-LANG-01: "can switch
      // back to English at any time"), unless it is already in the list.
      var prim = primaryLocale();
      if (offered(prim) && !seen[prim]) out.push(avail[prim]);
      return out;
    }

    // The country's default language = first available candidate, else primary.
    function defaultLocaleFor(iso) {
      var list = localesFor(iso);
      if (list.length) return list[0];
      return availableLocales()[primaryLocale()] || null;
    }

    // Build the URL for `locale`, keeping the current path/query/hash. The path
    // may already carry a locale prefix (`/fr/collections/...`), so the CURRENT
    // locale's root is stripped before the target's is applied — otherwise
    // switching fr -> de would produce `/de/fr/collections/...`.
    function localeUrl(locale) {
      var avail = availableLocales();
      var cur = avail[currentLocale()];
      var path = location.pathname || '/';

      var curRoot = (cur && cur.root) || '/';
      if (curRoot !== '/') {
        var prefix = curRoot.replace(/\/$/, '');
        if (path === prefix) path = '/';
        else if (path.indexOf(prefix + '/') === 0) path = path.slice(prefix.length);
      }

      var root = (locale && locale.root) || '/';
      var base = root === '/' ? '' : root.replace(/\/$/, '');
      return base + path + (location.search || '') + (location.hash || '');
    }

    // One locale navigation per session, max. Both language paths below go
    // through it: if a target locale ever fails to actually render in that
    // locale (a locale enabled but not published, say), the alternative is an
    // endless redirect loop against the shopper's own browser.
    var LOCALE_NAV_KEY = 'bonvale_locale_nav_session_v1';
    function localeNavAttempted() {
      try { return sessionStorage.getItem(LOCALE_NAV_KEY) === '1'; } catch (e) { return false; }
    }
    function markLocaleNavAttempted() {
      try { sessionStorage.setItem(LOCALE_NAV_KEY, '1'); } catch (e) {}
    }

    // Safety net for OUR OWN submit only (LOC-LANG-06).
    //
    // Verified 2026-07-30 on the dev storefront: POST /localization DOES accept
    // `country_code` and `locale_code` together and applies both in a single
    // navigation (NZ + de -> country=NZ, locale=de, redirectCount=1). So the
    // popup's one-form submit is the working path and this normally never fires.
    //
    // It is kept because the same test showed the endpoint applying submissions
    // PARTIALLY and silently: sending an unsellable country (DE, not in any
    // market on that store) changed the locale but left the country untouched,
    // with no error anywhere. A locale could be dropped the same way — e.g. if it
    // is unpublished between page render and submit — and the shopper would land
    // in a language they did not choose with nothing to signal it.
    //
    // Scope is deliberately narrow: it only arms when WE submit a locale change
    // (`expectLocale`), and disarms on arrival. Without that it would also bounce
    // someone who followed a shared `/fr/...` link into their own stored
    // language — a behaviour nobody asked for.
    //
    // The marker carries the COUNTRY of the submit as well as the locale, and is
    // honoured only when the arrival is that submit landing (same country).
    // sessionStorage is per origin: for a CROSS-DOMAIN switch the marker is
    // written on the origin the visitor is leaving, nothing on that origin ever
    // consumes it, and it fires on whatever brings them back — an unrelated,
    // later submit. Notion bug #4 (2026-08-03, NZ→DE→NZ→DE): the `en` armed by
    // the DE→NZ submit on .com fired on the later NZ→DE arrival at .com and
    // bounced /de to / (German preference, English page). Its mirror on .co.nz
    // — the `de` armed by NZ→DE bouncing a later English arrival to /de/ — is
    // the "opposite direction" note on the same ticket.
    var LOCALE_EXPECT_KEY = 'bonvale_locale_expect_v1';
    function expectLocale(code, country) {
      try {
        if (!code) return;
        sessionStorage.setItem(LOCALE_EXPECT_KEY, JSON.stringify({
          locale: code,
          country: country ? String(country).toUpperCase() : null
        }));
      } catch (e) {}
    }
    function takeExpectedLocale() {
      try {
        var v = sessionStorage.getItem(LOCALE_EXPECT_KEY);
        sessionStorage.removeItem(LOCALE_EXPECT_KEY);
        if (!v) return null;
        var parsed = null;
        try { parsed = JSON.parse(v); } catch (e) { parsed = null; }
        // A bare string is the pre-fix shape (a session that straddled the
        // deploy): it cannot be tied to a submit, so it is dropped rather than
        // trusted — trusting it is exactly the bug.
        if (!parsed || typeof parsed !== 'object' || !parsed.locale) return null;
        return parsed;
      } catch (e) { return null; }
    }

    function reconcileLocale() {
      if (isBot()) return { switch: false, reason: 'bot' };
      var expected = takeExpectedLocale();
      if (!expected) return { switch: false, reason: 'no-pending-submit' };
      if (expected.country && expected.country !== currentCountry()) {
        return { switch: false, reason: 'pending-submit-landed-elsewhere' };
      }
      if (localeNavAttempted()) return { switch: false, reason: 'already-navigated-this-session' };
      var cur = currentLocale();
      if (cur === expected.locale) return { switch: false, reason: 'submit-took-effect' };
      var target = availableLocales()[expected.locale];
      if (!target) return { switch: false, reason: 'expected-locale-unavailable' };
      return { switch: true, target: target, url: localeUrl(target), reason: 'submit-was-dropped' };
    }

    // M2 trigger (LOC-LANG-01). Resolves synchronously — unlike the geo popup
    // this needs no network call, because the country is already known from the
    // rendered context.
    //
    // Fires ONLY when: not a bot, no stored LANGUAGE preference, the visitor is
    // currently on the primary locale, and their country's default is something
    // else.
    //
    // Note the asymmetry with the popup: a v1.1 preference carries a country but
    // `locale: null`, because M2 did not exist when it was written. Those
    // visitors have never expressed a language choice, so they are still
    // eligible for one automatic switch — after which their preference records
    // the locale and this stops firing.
    function decideAutoLocale() {
      if (isBot()) return { switch: false, reason: 'bot' };
      if (localeNavAttempted()) return { switch: false, reason: 'already-navigated-this-session' };
      var d = readLangData();
      if (!d) return { switch: false, reason: 'no-language-data' };

      var pref = getPreference();
      if (pref && pref.locale) return { switch: false, reason: 'has-locale-preference' };

      var cur = currentLocale();
      if (cur !== primaryLocale()) return { switch: false, reason: 'not-on-primary-locale' };

      // Prefer the country recorded in the preference over the rendered one.
      // Right after a cross-domain hand-off the preference is already written
      // while the page may still be rendered for the previous country; deciding
      // the language from the rendered value would pick the wrong country's
      // default for one navigation.
      var country = (pref && pref.country) || currentCountry();
      if (!country) return { switch: false, reason: 'no-country' };

      var target = defaultLocaleFor(country);
      if (!target) return { switch: false, reason: 'no-target' };
      if (target.code === cur) return { switch: false, reason: 'already-default' };

      return { switch: true, target: target, url: localeUrl(target), reason: 'local-language' };
    }

    // Official Localization Discovery call. Returns { detected, suggestions } or
    // null on failure. `suggestions` is already filtered to ENABLED countries
    // excluding the current one, so a non-empty array is the mismatch signal.
    var _discoverPromise = null;
    function discover() {
      if (_discoverPromise) return _discoverPromise;
      if (isBot()) { _discoverPromise = Promise.resolve(null); return _discoverPromise; }
      var cur = currentCountry() || '';
      var url = '/browsing_context_suggestions.json?country[enabled]=true&country[exclude]=' + encodeURIComponent(cur);
      _discoverPromise = fetch(url, {
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin'
      })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) {
          if (!d) return null;
          var detected = d.detected_values && d.detected_values.country
            ? String(d.detected_values.country.handle || '').toUpperCase()
            : null;
          var suggestions = Array.isArray(d.suggestions) ? d.suggestions : [];
          return { detected: detected, suggestions: suggestions };
        })
        .catch(function () { return null; });
      return _discoverPromise;
    }

    // Read the recommended target country (uppercase ISO) from a discovery
    // suggestion, tolerating minor shape differences across the 4 sites.
    function suggestionCountry(s) {
      try {
        var c = s && s.parts && s.parts.country;
        var handle = c && (c.handle || c.iso_code);
        return handle ? String(handle).toUpperCase() : null;
      } catch (e) { return null; }
    }

    // M3 trigger (LOC-POP-01/02/04/05/07/10). Resolves to:
    //   { mismatch, detected, target: { country, currency }, reason }
    // mismatch=true ONLY when: not a bot, no stored preference, not dismissed
    // this session, discovery succeeded, and it yielded a sellable target
    // country ≠ the current one.
    //
    // Target precedence: the IP-DETECTED country wins when present, because the
    // spec is written about the visitor's own country — a detected country
    // outside the sellable set must NOT prompt (LOC-POP-04), even if Shopify
    // recommends a nearby market. `suggestions[0]` is the fallback for
    // responses that carry no `detected_values` (it is already filtered to
    // enabled countries ≠ current).
    function decideAutoPrompt() {
      if (isBot()) return Promise.resolve({ mismatch: false, reason: 'bot' });
      if (hasPreference()) return Promise.resolve({ mismatch: false, reason: 'has-preference' });
      if (seenThisSession()) return Promise.resolve({ mismatch: false, reason: 'seen-session' });
      return discover().then(function (res) {
        if (!res) return { mismatch: false, reason: 'no-detection' };
        var cur = currentCountry();
        var target;

        if (res.detected) {
          if (res.detected === cur) return { mismatch: false, reason: 'same-country' };
          if (!currencyFor(res.detected)) return { mismatch: false, reason: 'not-shippable' };
          target = res.detected;
        } else {
          if (!res.suggestions.length) return { mismatch: false, reason: 'no-suggestion' };
          target = suggestionCountry(res.suggestions[0]);
          if (!target) return { mismatch: false, reason: 'unparsable-suggestion' };
          if (target === cur) return { mismatch: false, reason: 'same-country' };
        }

        var ccy = currencyFor(target);
        if (!ccy) return { mismatch: false, reason: 'unsupported-target' };
        return {
          mismatch: true,
          detected: res.detected,
          target: { country: target, currency: ccy },
          reason: 'mismatch'
        };
      });
    }

    // ── Cross-domain choice hand-off (LOC-POP-06) ──
    // localStorage does NOT cross the three registered domains, so a visitor who
    // confirms "United Kingdom" on `.com` lands on `.co.uk` with no stored
    // preference — geo would then see detected US ≠ current GB and immediately
    // re-prompt them back to the US: a confirm→re-prompt loop.
    // Shopify's localization form preserves OUR OWN `return_to` query across the
    // cross-domain redirect (verified 2026-07-28: confirming NZ on `.com` landed
    // on `www.bonvale.co.nz/?bv_region=NZ&shpxid=…`), so the choice travels in
    // `bv_region` and is adopted on arrival. Preferred over sniffing `shpxid`,
    // which Shopify appends to ANY cross-domain navigation (a plain cross-domain
    // link would then silently write a preference).
    var HANDOFF_PARAM = 'bv_region';
    // M2: the language travels alongside the country. Without it the visitor
    // arrives on the destination domain with a country preference but no locale,
    // and decideAutoLocale would immediately switch them again.
    var HANDOFF_LOCALE_PARAM = 'bv_locale';

    // Remove one query parameter from a `?a=1&b=2` string, leaving no `?&`,
    // `&&` or trailing separator behind. Extracted so the country and locale
    // markers share one implementation — the original inline version was fixed
    // by 10 boundary cases (marker first / middle / last), and a second copy
    // would only re-earn those bugs.
    function stripParam(qs, name) {
      return (qs || '')
        .replace(new RegExp('([?&])' + name + '=[^&]*'), '$1')
        .replace(/&{2,}/g, '&')
        .replace(/[?&]+$/, '')
        .replace(/^\?&+/, '?');
    }

    // Build the `return_to` value that carries the choice to the target domain.
    function handoffReturnTo(iso, locale) {
      var path = location.pathname || '/';
      var qs = stripParam(stripParam(location.search || '', HANDOFF_PARAM), HANDOFF_LOCALE_PARAM);
      if (qs === '?') qs = '';
      var out = path + qs + (qs ? '&' : '?') + HANDOFF_PARAM + '=' + encodeURIComponent(iso);
      if (locale) out += '&' + HANDOFF_LOCALE_PARAM + '=' + encodeURIComponent(locale);
      return out;
    }

    // Adopt an incoming hand-off, then strip the markers so they never linger in
    // copied/shared URLs. Returns `{ country, locale }` for the adopted choice
    // (locale may be null), or null when this is not a hand-off arrival.
    function adoptHandoff() {
      var search = location.search || '';
      var m = /[?&]bv_region=([A-Za-z]{2})(?:&|$)/.exec(search);
      if (!m) return null;
      var iso = m[1].toUpperCase();
      var lm = /[?&]bv_locale=([A-Za-z0-9-]+)(?:&|$)/.exec(search);
      var locale = lm ? decodeURIComponent(lm[1]) : null;
      var ccy = currencyFor(iso);
      // The hand-off carries a choice the visitor JUST made, so it wins over
      // whatever this domain remembered from an earlier visit (PRD LOC-LANG-07:
      // "新的手工选择必须覆盖目标域名已存的旧偏好"). v1.1 deferred to the stored
      // preference instead — correct then, wrong now: deferring means someone
      // who explicitly picks United Kingdom lands on .co.uk and is silently put
      // back into the country they browsed months ago, with no way to tell why.
      if (ccy) setPreference({ country: iso, currency: ccy, locale: locale });
      try {
        var url = new URL(location.href);
        url.searchParams.delete(HANDOFF_PARAM);
        url.searchParams.delete(HANDOFF_LOCALE_PARAM);
        history.replaceState(null, '', url.pathname + url.search + url.hash);
      } catch (e) {}
      return { country: iso, locale: locale };
    }

    // ── Cross-domain country re-apply (LOC-POP-02) ────────────────────────
    // Measured on prod 2026-07-31, submitting the localization form on
    // `www.bonvale.co.uk` with country_code=DE: the visitor is ROUTED to
    // `www.bonvale.com/de/` (right domain, and the LOCALE does cross — the page
    // renders in German) but the COUNTRY is not applied there. The destination
    // re-resolves it from its own localization cookie / IP, so the page priced
    // in whatever that domain last remembered: DKK on the test egress, USD for
    // the reporter who had confirmed United States there minutes earlier.
    // Re-submitting country_code=DE on `.com` sticks (country=DE, EUR, €30,95),
    // which is what this does on arrival.
    //
    // So writing the preference is necessary but NOT sufficient: the preference
    // only silences the popup, it does not change what Shopify renders. Without
    // this step the visitor sees the popup stay away AND the old currency stay
    // put — a switch that looks accepted and did nothing.
    //
    // One attempt per country per session. If the re-submit does not take (an
    // unsellable country, a market change mid-session), the alternative is
    // submitting the same form on every page load forever. Keyed by country
    // rather than a bare flag so a second cross-domain switch in the same
    // session — exactly the reported repro — is still reconciled.
    var COUNTRY_NAV_KEY = 'bonvale_region_nav_session_v1';
    function countryAttempted(iso) {
      try { return sessionStorage.getItem(COUNTRY_NAV_KEY) === iso; } catch (e) { return false; }
    }
    function markCountryAttempted(iso) {
      try { sessionStorage.setItem(COUNTRY_NAV_KEY, iso); } catch (e) {}
    }
    function clearCountryAttempt() {
      try { sessionStorage.removeItem(COUNTRY_NAV_KEY); } catch (e) {}
    }

    // Re-apply `iso` on THIS domain. Returns true when a navigation has been
    // started — the caller must then do nothing else, or it cancels the submit.
    function reconcileCountry(iso, locale) {
      if (isBot()) return false;
      if (!iso) return false;
      if (currentCountry() === iso) { clearCountryAttempt(); return false; }
      // Not sellable here ⇒ the submit cannot succeed, and firing it anyway
      // would bounce the visitor through a navigation that changes nothing.
      if (!currencyFor(iso)) return false;
      if (countryAttempted(iso)) return false;

      var form = document.getElementById('bonvale-region-reconcile-form');
      if (!form) return false;
      var countryInput = form.querySelector('[data-reconcile-country]');
      // Shopify's own `return_to`, rewritten rather than duplicated (see the
      // comment on the form). Created if a future Shopify form drops it.
      var returnInput = form.querySelector('input[name="return_to"]');
      if (!countryInput) return false;
      if (!returnInput) {
        returnInput = document.createElement('input');
        returnInput.type = 'hidden';
        returnInput.name = 'return_to';
        form.appendChild(returnInput);
      }

      countryInput.value = iso;
      // Carry the language through. The hand-off has already put the visitor on
      // the locale they chose; submitting the country alone lets the destination
      // market's default language win and silently undoes that half.
      var localeInput = form.querySelector('[data-reconcile-locale]');
      if (localeInput) localeInput.value = locale || currentLocale();
      // Markers are stripped by adoptHandoff before this runs, so the current
      // URL is already the clean one to come back to. Hash is dropped — Shopify
      // does not preserve it through `return_to` (same as handoffReturnTo).
      returnInput.value = (location.pathname || '/') + (location.search || '');

      markCountryAttempted(iso);
      // Same treatment as a switcher submit: a full navigation with no native
      // feedback otherwise looks like a frozen page (CSS in `header`).
      document.documentElement.classList.add('country-switching');
      // Same safety net as the switcher's own submit: that class also LOCKS the
      // country options, so if the navigation never happens it would leave the
      // visitor unable to switch at all on this page.
      setTimeout(function () {
        document.documentElement.classList.remove('country-switching');
      }, 10000);
      form.submit();
      return true;
    }

    // Order matters: adopt first. A cross-domain arrival carries its locale in
    // `bv_locale`, and adopting it writes the preference that makes the
    // auto-switch below stand down. Reversed, the visitor would be switched
    // away from the language they just chose.
    var adopted = adoptHandoff();

    // Then re-apply the country Shopify dropped in transit. This navigates when
    // it has work to do, so the language step below must stand down — calling
    // `location.replace` after a `form.submit()` cancels the submit, leaving the
    // visitor on the wrong currency with the attempt already marked as spent.
    var countryNavigating = adopted ? reconcileCountry(adopted.country, adopted.locale) : false;

    // ── First-arrival local language (LOC-LANG-01) ────────────────────────
    // One navigation, at most once per visitor: after it the preference records
    // the locale and decideAutoLocale stops firing. Bots are excluded inside
    // decideAutoLocale — a crawler bounced from `/` to `/de` would scramble the
    // hreflang crawl paths, and SEO indexing of the local-language pages is the
    // return this whole project is chasing (LOC-LANG-08).
    //
    // TODO(perceived speed): this runs from the bundled javascript block, so a
    // first-time DE visitor briefly sees the English page before the switch. The
    // fallback if that reads badly on real hardware is to drop the navigation and
    // only pre-select the local language in the popup — same spec intent, no
    // redirect. Measure before adding a second copy of this rule in <head>.
    (function applyLocale() {
      if (countryNavigating) return;

      // Reconcile first: an explicit choice outranks any inferred default.
      var fix = reconcileLocale();
      if (fix.switch) {
        markLocaleNavAttempted();
        location.replace(fix.url);
        return;
      }

      var decision = decideAutoLocale();
      if (!decision.switch) return;
      markLocaleNavAttempted();
      var existing = getPreference();
      var country = (existing && existing.country) || currentCountry();
      setPreference({
        country: country,
        currency: (existing && existing.currency) || currencyFor(country),
        locale: decision.target.code
      });
      location.replace(decision.url);
    })();

    /* QA BUG-BV-67: announce cart lines Shopify silently dropped in a market
       switch. region-popup snapshots the cart into sessionStorage right before
       submitting the localization form; this runs on the landing page, compares
       against the live cart, and toasts what disappeared. The marker is consumed
       (removed) up front so a shopper editing their bag later can never re-trigger
       it. Same-origin switches only — cross-domain markets have separate carts,
       so there is nothing to announce there. */
    (function announceDroppedCartLines() {
      var SNAP_KEY = 'bonvale:cart:preswitch';
      var raw;
      try {
        raw = sessionStorage.getItem(SNAP_KEY);
        if (raw) sessionStorage.removeItem(SNAP_KEY);
      } catch (e) { return; }
      if (!raw) return;
      var snap;
      try { snap = JSON.parse(raw); } catch (e) { return; }
      if (!snap || !snap.lines || !snap.lines.length) return;
      fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart || !cart.items) return;
          var have = {};
          cart.items.forEach(function (i) { have[i.key] = true; });
          var dropped = snap.lines.filter(function (l) { return !have[l.k]; });
          if (!dropped.length || !window.__showQuickAddToast) return;
          var dataEl = document.getElementById('bonvale-region-data');
          var labels = {};
          try { labels = JSON.parse(dataEl.textContent); } catch (e) {}
          var msg;
          if (dropped.length === 1 && labels.cart_removed_one) {
            msg = labels.cart_removed_one.replace('%%TITLE%%', dropped[0].t);
          } else if (labels.cart_removed_many) {
            msg = labels.cart_removed_many.replace('%%COUNT%%', String(dropped.length));
          }
          if (msg) window.__showQuickAddToast(msg, true, 7000);
        })
        .catch(function () { /* cart unreadable — stay silent rather than guess */ });
    })();

    window.BonvaleRegion = {
      data: readData(),
      handoffReturnTo: handoffReturnTo,
      adoptHandoff: adoptHandoff,
      reconcileCountry: reconcileCountry,
      getPreference: getPreference,
      hasPreference: hasPreference,
      setPreference: setPreference,
      seenThisSession: seenThisSession,
      markSeenThisSession: markSeenThisSession,
      isBot: isBot,
      currentCountry: currentCountry,
      currencyFor: currencyFor,
      discover: discover,
      decideAutoPrompt: decideAutoPrompt,
      // M2 language
      primaryLocale: primaryLocale,
      currentLocale: currentLocale,
      localesFor: localesFor,
      defaultLocaleFor: defaultLocaleFor,
      localeUrl: localeUrl,
      decideAutoLocale: decideAutoLocale,
      expectLocale: expectLocale,
      reconcileLocale: reconcileLocale
    };
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["region-popup"] && !Shopify.designMode) return;
  try {
    (function () {
    var dlg = document.getElementById('region-popup');
    if (!dlg) return;

    var form = document.getElementById('region-popup-form');
    var hiddenInput = dlg.querySelector('[data-region-country-input]');
    var toggle = dlg.querySelector('[data-region-select-toggle]');
    var panel = dlg.querySelector('[data-region-panel]');
    var caret = dlg.querySelector('.geo-popup__caret');
    var search = dlg.querySelector('[data-region-search]');
    var list = dlg.querySelector('[data-region-list]');
    var empty = dlg.querySelector('[data-region-empty]');
    var currentFlag = dlg.querySelector('[data-region-current-flag]');
    var currentLabel = dlg.querySelector('[data-region-current-label]');
    var currencyLabel = dlg.querySelector('[data-region-currency-label]');
    var bodyEl = dlg.querySelector('[data-region-body]');
    var confirmBtn = dlg.querySelector('[data-region-confirm]');
    var localeInput = dlg.querySelector('[data-region-locale-input]');
    var langField = dlg.querySelector('[data-region-language-field]');
    var langSelect = dlg.querySelector('[data-region-language-select]');
    var langToggle = dlg.querySelector('[data-region-language-toggle]');
    var langPanel = dlg.querySelector('[data-region-language-panel]');
    var langList = dlg.querySelector('[data-region-language-list]');
    var langLabel = dlg.querySelector('[data-region-language-label]');
    var langCaret = langToggle ? langToggle.querySelector('.geo-popup__caret') : null;
    var langStatic = dlg.querySelector('[data-region-language-static]');
    var langStaticLabel = dlg.querySelector('[data-region-language-static-label]');

    // The country this page was RENDERED for. Captured once, before anything can
    // call setSelected() — the hidden input is mutable state (a geo auto-open
    // overwrites it with the suggested country), so it must not be used as the
    // "current context" reference.
    var INITIAL_COUNTRY = hiddenInput ? hiddenInput.value : null;

    // Market handles whose prices include duties + taxes, so the body line is
    // true there. Declared in the markup (see the comment beside the <p>);
    // anything not listed — today only `rest-of-world` — gets no line at all.
    var DDP_MARKETS = ((bodyEl && bodyEl.getAttribute('data-ddp-markets')) || '')
      .split(',')
      .filter(function (handle) { return handle; });

    function dutiesCovered(market) {
      return !!market && DDP_MARKETS.indexOf(market) !== -1;
    }

    // ISO code of the selected country's currency, e.g. "GBP". Kept as state
    // rather than re-read from the Currency row, which now displays a full name
    // ("British Pound (GBP)") and is a display string, not a value.
    var selectedCurrency = null;

    function currentContextCountry() {
      if (window.BonvaleRegion && window.BonvaleRegion.currentCountry()) {
        return window.BonvaleRegion.currentCountry();
      }
      return INITIAL_COUNTRY;
    }

    function fill(tmpl, token, value) {
      return (tmpl || '').split(token).join(value);
    }

    function openDialog() {
      try { dlg.showModal(); } catch (e) { dlg.setAttribute('open', ''); }
    }
    function closeDialog() {
      try { dlg.close(); } catch (e) { dlg.removeAttribute('open'); }
    }
    function closePanel() {
      panel.classList.remove('geo-popup__select-panel--open');
      toggle.setAttribute('aria-expanded', 'false');
      if (caret) caret.classList.remove('geo-popup__caret--open');
    }
    function closeLangPanel() {
      if (!langPanel || !langToggle) return;
      langPanel.classList.remove('geo-popup__select-panel--open');
      langToggle.setAttribute('aria-expanded', 'false');
      if (langCaret) langCaret.classList.remove('geo-popup__caret--open');
    }

    // Show the "more below" fade only while the list really has more to reveal.
    // Recomputed on open, on scroll and after every filter — a search that
    // narrows 48 countries down to two must not keep claiming there is more.
    function updateScrollHint() {
      if (!list || !panel) return;
      var more = list.scrollHeight - list.clientHeight - list.scrollTop > 4;
      panel.classList.toggle('geo-popup__select-panel--more', more);
    }
    if (list) list.addEventListener('scroll', updateScrollHint);

    // Clear a previous search so reopening never shows a stale filtered list
    // (e.g. search "fran", close, reopen → only France listed).
    function resetSearch() {
      if (search) search.value = '';
      if (list) {
        var opts = list.querySelectorAll('[data-country-code]');
        for (var i = 0; i < opts.length; i++) {
          if (opts[i].parentNode) opts[i].parentNode.hidden = false;
        }
      }
      if (empty) empty.hidden = true;
      if (list) list.scrollTop = 0;
      updateScrollHint();
    }

    // Set when the visitor actually touches the Language control during this
    // opening; cleared every time the dialog opens. It is what separates "the
    // language shown happens to be English" from "the visitor chose English".
    var localeTouched = false;

    // Rebuild the Language row for a country (LOC-LANG-02). Called ONLY from
    // setSelected, so there is exactly one path that can leave this row stale.
    //
    // Which language ends up selected, in priority order:
    //   1. one the visitor explicitly picked here — kept while the new country
    //      still offers it (DE→AT keeps Deutsch)
    //   2. for the country the page is CURRENTLY rendered for, the language it
    //      is currently rendered in (a manual open must show the real context)
    //   3. otherwise the NEW country's default (PRD §5.2)
    //
    // Rule 3 is the one that needed fixing: English is appended to every
    // country's candidate list as the way back, so "keep the current selection
    // if it is still offered" silently kept English for every country and made
    // the §5.2 default table unreachable — caught on the test store, where
    // picking a de/fr country still showed English.
    function preferredLocaleFor(iso) {
      if (localeTouched && localeInput && localeInput.value) return localeInput.value;
      if (iso === currentContextCountry() && window.BonvaleRegion) {
        return window.BonvaleRegion.currentLocale();
      }
      return null; // let the country's default win
    }

    function setLanguages(iso, preferred) {
      if (!langField) return;
      var R = window.BonvaleRegion;
      var locales = R && R.localesFor ? R.localesFor(iso) : [];

      // Single-language store, or a country with only one option: no choice to
      // present. Show the LOCKED treatment (grey + check-circle), identical to
      // Currency, rather than a one-item dropdown that looks changeable.
      if (locales.length < 2) {
        var only = locales[0] || (R && R.defaultLocaleFor ? R.defaultLocaleFor(iso) : null);
        if (!only) { langField.hidden = true; return; }
        langField.hidden = false;
        if (langSelect) langSelect.hidden = true;
        closeLangPanel();
        if (langStatic) langStatic.hidden = false;
        if (langStaticLabel) langStaticLabel.textContent = localeName(only);
        if (localeInput) localeInput.value = only.code;
        return;
      }

      langField.hidden = false;
      if (langStatic) langStatic.hidden = true;
      if (!langSelect || !langList) return;
      langSelect.hidden = false;
      // A country change rebuilds this list, so an open panel would be showing
      // the previous country's languages against the new country's label.
      closeLangPanel();

      var wanted = null;
      for (var i = 0; i < locales.length; i++) if (locales[i].code === preferred) wanted = preferred;
      if (!wanted) wanted = locales[0].code; // the country's default is first

      langList.innerHTML = '';
      for (var j = 0; j < locales.length; j++) {
        var name = localeName(locales[j]);
        var active = locales[j].code === wanted;
        var li = document.createElement('li');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'geo-popup__option' + (active ? ' geo-popup__option--active' : '');
        btn.setAttribute('role', 'option');
        btn.setAttribute('aria-selected', active ? 'true' : 'false');
        btn.setAttribute('data-locale-code', locales[j].code);
        btn.textContent = name;
        li.appendChild(btn);
        langList.appendChild(li);
        if (active) setLanguageLabel(name);
      }
      if (localeInput) localeInput.value = wanted;
    }

    function localeName(locale) {
      return locale.endonym || locale.name || locale.code;
    }

    function setLanguageLabel(name) {
      if (langLabel) langLabel.textContent = name;
    }

    function selectedLocale() {
      if (localeInput && localeInput.value) return localeInput.value;
      if (window.BonvaleRegion) return window.BonvaleRegion.currentLocale();
      return null;
    }

    // Apply a country selection to the whole popup (label, flag, currency,
    // body copy, hidden inputs, language row, active state).
    function setSelected(iso) {
      var opt = list.querySelector('[data-country-code="' + (iso || '').replace(/"/g, '') + '"]');
      if (!opt) return;
      var name = opt.getAttribute('data-country-name') || '';
      var ccy = opt.getAttribute('data-currency') || '';
      var ccyName = opt.getAttribute('data-currency-name') || '';
      var img = opt.querySelector('img');

      selectedCurrency = ccy;
      if (hiddenInput) hiddenInput.value = iso;
      if (currentLabel) currentLabel.textContent = name;
      if (currentFlag && img) {
        currentFlag.src = img.src;
        if (img.srcset) currentFlag.srcset = img.srcset;
        currentFlag.style.visibility = '';
      }
      // "British Pound (GBP)" — the name alone is ambiguous across dollar
      // countries, the code alone is jargon. Fall back to the bare code if the
      // Liquid side ever stops emitting a name.
      if (currencyLabel) {
        currencyLabel.textContent = ccyName ? ccyName + ' (' + ccy + ')' : ccy;
      }
      if (bodyEl) {
        bodyEl.textContent = fill(bodyEl.getAttribute('data-tmpl'), '__CCY__', ccy);
        bodyEl.hidden = !dutiesCovered(opt.getAttribute('data-market'));
      }

      setLanguages(iso, preferredLocaleFor(iso));

      var prev = list.querySelector('.geo-popup__option--active');
      if (prev) prev.classList.remove('geo-popup__option--active');
      opt.classList.add('geo-popup__option--active');
    }

    // Keep the hidden input in step with the visible control so the submit path
    // has one place to read from, whichever form the row is currently in.
    if (langToggle && langPanel) {
      langToggle.addEventListener('click', function (e) {
        e.stopPropagation();
        closePanel(); // only one panel open at a time
        var open = langPanel.classList.toggle('geo-popup__select-panel--open');
        langToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (langCaret) langCaret.classList.toggle('geo-popup__caret--open', open);
      });
      langList.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-locale-code]');
        if (!opt) return;
        e.stopPropagation();
        var prev = langList.querySelector('.geo-popup__option--active');
        if (prev) {
          prev.classList.remove('geo-popup__option--active');
          prev.setAttribute('aria-selected', 'false');
        }
        opt.classList.add('geo-popup__option--active');
        opt.setAttribute('aria-selected', 'true');
        setLanguageLabel(opt.textContent);
        if (localeInput) localeInput.value = opt.getAttribute('data-locale-code');
        localeTouched = true;
        closeLangPanel();
      });
      dlg.addEventListener('click', function (e) {
        if (langToggle.contains(e.target) || langPanel.contains(e.target)) return;
        closeLangPanel();
      });
    }

    // Initialise to the currently selected country. The body copy, currency and
    // language row are all JS-filled, so without this the popup renders with an
    // empty intro line and empty Currency/Languages rows for every open path
    // other than geo-auto-open — including the M4 switcher entry points. The
    // auto-open path calls setSelected() again with the geo target.
    if (INITIAL_COUNTRY) setSelected(INITIAL_COUNTRY);

    // ── Manual entry points (LOC-SEL-01) ──
    // Any `[data-region-open]` element opens THIS dialog, so the header
    // announcement bar, the footer Country/Region control and the mobile menu
    // all share one popup and one country data source. Delegated on document so
    // it works regardless of section render order.
    document.addEventListener('click', function (e) {
      if (!e.target || !e.target.closest) return;
      var trigger = e.target.closest('[data-region-open]');
      if (!trigger) return;
      e.preventDefault();
      // Always reopen on the CURRENT context — an earlier geo auto-open leaves
      // the SUGGESTED country selected, which would otherwise make the manual
      // entry points show the wrong country and the wrong currency. The
      // language is reset the same way and for the same reason: whatever was
      // last shown in this dialog is not necessarily what the page is rendered
      // in now.
      localeTouched = false;
      if (localeInput && window.BonvaleRegion) localeInput.value = window.BonvaleRegion.currentLocale();
      var cur = currentContextCountry();
      if (cur) setSelected(cur);
      resetSearch();
      closePanel();
      closeLangPanel();
      openDialog();
    });

    // ── Search filter (LOC-POP-09: empty state) ──
    if (search) {
      search.addEventListener('input', function () {
        var q = search.value.trim().toLowerCase();
        var anyVisible = false;
        var opts = list.querySelectorAll('[data-country-code]');
        for (var i = 0; i < opts.length; i++) {
          /* QA BUG-BV-49: matching on the country NAME alone sent shoppers looking for
             a word that is printed on the option but cannot be searched. Every option
             is labelled "<Country> (<CCY>)", yet typing "CHF" returned nothing and "CH"
             returned Chile and Czechia — both contain the letters "ch" — while
             Switzerland, whose ISO code IS "CH", was filtered out. Measured on prod
             2026-08-07 across all 48 options: CH → 2 wrong hits, CHF → 0, and "Swiss"
             → 0 (the name is "Switzerland").

             The ISO code, currency code and currency name were already on the element
             (country-options.liquid emits all four) and the popup already reads two of
             them to render the Currency row — so this is purely which fields the filter
             consults. Codes are matched with `indexOf` like the name rather than as a
             prefix: "CHF" has to hit "CHF", and a shopper typing "usd" expects the
             USD markets whatever position it sits in. */
          var opt = opts[i];
          var name = (opt.getAttribute('data-country-name') || '').toLowerCase();
          var code = (opt.getAttribute('data-country-code') || '').toLowerCase();
          var ccy = (opt.getAttribute('data-currency') || '').toLowerCase();
          var ccyName = (opt.getAttribute('data-currency-name') || '').toLowerCase();
          var li = opt.parentNode;
          var match = !q ||
            name.indexOf(q) !== -1 ||
            code.indexOf(q) !== -1 ||
            ccy.indexOf(q) !== -1 ||
            ccyName.indexOf(q) !== -1;
          if (li) li.hidden = !match;
          if (match) anyVisible = true;
        }
        if (empty) empty.hidden = anyVisible;
        // The list just changed length — and it may have scrolled itself.
        list.scrollTop = 0;
        updateScrollHint();
      });
    }

    // ── Select toggle open/close ──
    if (toggle && panel) {
      toggle.addEventListener('click', function (e) {
        e.stopPropagation();
        closeLangPanel(); // only one panel open at a time
        var open = panel.classList.toggle('geo-popup__select-panel--open');
        toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (caret) caret.classList.toggle('geo-popup__caret--open', open);
        if (open && search) { search.focus(); }
        if (open) updateScrollHint(); else panel.classList.remove('geo-popup__select-panel--more');
      });
      dlg.addEventListener('click', function (e) {
        if (toggle.contains(e.target) || panel.contains(e.target)) return;
        closePanel();
      });
      list.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-country-code]');
        if (!opt) return;
        e.stopPropagation();
        setSelected(opt.getAttribute('data-country-code'));
        closePanel();
      });
    }

    // ── Dismiss (X / "Skip updating my preferences" / backdrop) — no permanent
    // preference; mark the session so it won't auto-reopen this session
    // (layer 2). A new session may prompt again (geo can misjudge via
    // VPN/travel/corp egress). ──
    function dismiss() {
      if (window.BonvaleRegion) window.BonvaleRegion.markSeenThisSession();
      closeDialog();
    }
    dlg.addEventListener('click', function (e) {
      if (e.target.closest('[data-region-close]') || e.target.closest('[data-region-dismiss]')) {
        dismiss();
      }
    });
    var downTarget = null;
    dlg.addEventListener('mousedown', function (e) { downTarget = e.target; });
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg && downTarget === dlg) dismiss();
    });

    // ── Confirm — persist shared preference, then submit ──
    if (confirmBtn && form) {
      confirmBtn.addEventListener('click', function () {
        var iso = hiddenInput ? hiddenInput.value : null;
        var ccy = selectedCurrency;
        var locale = selectedLocale();
        if (window.BonvaleRegion) {
          // Preference is written BEFORE the submit. Writing it after would not
          // survive the navigation — that is the v1.1 bug where a switch left no
          // preference and the popup came straight back (LOC-SEL-02).
          window.BonvaleRegion.setPreference({ country: iso, currency: ccy, locale: locale });
          window.BonvaleRegion.markSeenThisSession();
          // Arm the one-shot check that the locale half of this submit actually
          // landed. Verified 2026-07-30 that it normally does; the endpoint has
          // been seen applying a submission partially and silently, so this is
          // the only signal that would otherwise be missing.
          // The country rides along so the check only fires when THIS submit
          // lands here — on a cross-domain switch the marker stays behind on
          // this origin and must not bounce a later, unrelated arrival (#4).
          window.BonvaleRegion.expectLocale(locale, iso);
          // Carry the choice across the domain boundary. Shopify redirects a
          // GB/NZ pick to `.co.uk`/`.co.nz`, where localStorage is a different
          // origin — without this the visitor arrives preference-less and gets
          // re-prompted straight back (LOC-POP-06). Shopify preserves this
          // `return_to`, so `region-detect` adopts it on arrival.
          var returnTo = form.querySelector('input[name="return_to"]');
          if (!returnTo) {
            returnTo = document.createElement('input');
            returnTo.type = 'hidden';
            returnTo.name = 'return_to';
            form.appendChild(returnTo);
          }
          returnTo.value = window.BonvaleRegion.handoffReturnTo(iso, locale);
        }
        document.documentElement.classList.add('country-switching');
        /* QA BUG-BV-67: switching market makes Shopify silently DROP any cart line
           the target market doesn't sell (each market has its own gift card, so
           every cross-market switch can hit this) — no toast, not recoverable.
           The platform won't let us keep the line, but we can at least say so:
           snapshot the cart before the submit; `region-detect` compares on the
           landing page and announces what was removed. Same-origin switches only —
           a GB/NZ pick lands on another domain where sessionStorage (and the cart
           itself) is a different world. The snapshot fetch is raced against a
           1.5s timeout so a slow /cart.js can never block the switch. */
        var submitted = false;
        var go = function () { if (!submitted) { submitted = true; form.submit(); } };
        try {
          Promise.race([
            fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { cache: 'no-store' })
              .then(function (r) { return r.ok ? r.json() : null; })
              .then(function (cart) {
                if (!cart || !cart.items) return;
                try {
                  sessionStorage.setItem('bonvale:cart:preswitch', JSON.stringify({
                    lines: cart.items.map(function (i) { return { k: i.key, t: i.product_title }; })
                  }));
                } catch (e) { /* storage full/blocked — switch proceeds without the notice */ }
              }),
            new Promise(function (resolve) { setTimeout(resolve, 1500); })
          ]).then(go, go);
        } catch (e) { go(); }
      });
    }

    // ── Overlay priority (LOC-MOB-01): cookie bar > region popup > sticky CTA ──
    // The bar auto-shows for first-time visitors — exactly when the geo
    // suggestion matters most — and it does so ASYNCHRONOUSLY (after
    // `Shopify.loadFeatures`). So we neither race a one-shot visibility check
    // nor drop the prompt: we predict the bar using its own contract
    // (`data-auto-show` + its acted key) and, when it is or will be up, queue
    // the popup until it hides.
    var cookieBar = document.getElementById('cookie-consent');
    var COOKIE_ACTED_KEY = 'bonvale:cookie:acted';

    function cookieBarShowing() {
      if (!cookieBar) return false;
      if (!cookieBar.hidden) return true;
      if (cookieBar.getAttribute('data-auto-show') !== 'true') return false;
      try { return !localStorage.getItem(COOKIE_ACTED_KEY); } catch (e) { return false; }
    }

    // Mark the session only when the popup is ACTUALLY shown — not when it is
    // queued behind the cookie bar. Marking at queue time would burn the
    // session's one prompt for a visitor who navigates away while the cookie
    // bar is still up, so they'd never see it this session.
    function autoOpen() {
      window.BonvaleRegion.markSeenThisSession();
      openDialog();
    }

    function openAfterCookieBar() {
      if (!cookieBarShowing()) { autoOpen(); return; }
      var obs = new MutationObserver(function () {
        if (!cookieBar.hidden) return;
        obs.disconnect();
        autoOpen();
      });
      obs.observe(cookieBar, { attributes: true, attributeFilter: ['hidden'] });
    }

    // ── Auto-open on geo mismatch (LOC-POP-01) ──
    function maybeAutoOpen() {
      if (!window.BonvaleRegion) return; // foundation not present → no prompt
      window.BonvaleRegion.decideAutoPrompt().then(function (res) {
        if (!res || !res.mismatch) return;
        setSelected(res.target.country);
        openAfterCookieBar();
      });
    }

    // No fixed delay (per Dongwen): the discovery request IS the delay — we only
    // open once it resolves with a suggestion, so the popup never flashes then
    // vanishes.
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', maybeAutoOpen);
    } else {
      maybeAutoOpen();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["size-guide-modal"] && !Shopify.designMode) return;
  try {
    (function () {
  // Bind close / tabs / unit for every overlay present at load (PDP + hidden shell).
  // The location dropdown is handled by document-level delegation below so it also
  // covers overlays injected later by the quick-add / cart flows.
  function bindOverlay(overlay) {
    if (!overlay || overlay.dataset.sgBound) return;
    overlay.dataset.sgBound = '1';
    var modal = overlay.querySelector('[data-sg-modal]');
    var returnFocus = null;
    var focusSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

    function close() {
      overlay.classList.remove('sg-overlay--open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (returnFocus && returnFocus.focus) returnFocus.focus();
      returnFocus = null;
      var done = false;
      function hide() {
        if (done) return;
        done = true;
        overlay.style.display = 'none';
        if (modal) modal.removeEventListener('transitionend', hide);
      }
      if (modal) modal.addEventListener('transitionend', hide);
      setTimeout(hide, 400);
    }
    overlay._sgClose = close;
    overlay._sgOpen = function () {
      returnFocus = document.activeElement;
      var target = overlay.querySelector('[data-sg-close]') || modal;
      if (target) requestAnimationFrame(function () { target.focus(); });
    };
    overlay._sgTrapTab = function (e) {
      var items = [].filter.call(modal.querySelectorAll(focusSelector), function (el) {
        return el.getClientRects().length && !el.hidden;
      });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };

    overlay.querySelectorAll('[data-sg-close]').forEach(function (btn) {
      btn.addEventListener('click', close);
    });
    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    var tabs = overlay.querySelectorAll('[data-sg-tab]');
    var panels = overlay.querySelectorAll('[data-sg-panel]');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = this.dataset.sgTab;
        tabs.forEach(function (t) { t.classList.remove('sg-modal__tab--active'); });
        this.classList.add('sg-modal__tab--active');
        panels.forEach(function (p) { p.style.display = p.dataset.sgPanel === target ? '' : 'none'; });
      });
    });

    var unitBtns = overlay.querySelectorAll('[data-sg-unit]');
    var unitTables = overlay.querySelectorAll('[data-sg-table]');
    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = this.dataset.sgUnit;
        unitBtns.forEach(function (b) { b.classList.remove('sg-modal__unit--active'); });
        this.classList.add('sg-modal__unit--active');
        unitTables.forEach(function (t) { t.style.display = t.dataset.sgTable === unit ? '' : 'none'; });
      });
    });
  }

  function openOverlay(overlay) {
    if (!overlay) return;
    overlay.style.display = '';
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (overlay._sgOpen) overlay._sgOpen();
    requestAnimationFrame(function () { overlay.classList.add('sg-overlay--open'); });
  }

  function initAll() {
    document.querySelectorAll('[data-sg-overlay]').forEach(bindOverlay);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Open — delegated. Target the overlay in the trigger's section, skipping the
  // inert shell overlay used only to load CSS.
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-sg-open]');
    if (!openBtn) return;
    var scope = openBtn.closest('.shopify-section') || document;
    var overlay = scope.querySelector('[data-sg-overlay]:not([data-sg-shell])')
      || document.querySelector('[data-sg-overlay]:not([data-sg-shell])');
    if (overlay) {
      bindOverlay(overlay);
      openOverlay(overlay);
    }
  });

  // Location dropdown — delegated so injected overlays (quick-add / cart) work too.
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-sg-location]');
    if (!select) return;
    var overlay = select.closest('[data-sg-overlay]');
    if (!overlay) return;
    var key = select.value;
    overlay.querySelectorAll('.sg-table__conv').forEach(function (tr) {
      tr.hidden = tr.dataset.sgConv !== key;
    });
  });

  // Escape closes any open overlay.
  document.addEventListener('keydown', function (e) {
    document.querySelectorAll('[data-sg-overlay]').forEach(function (overlay) {
      if (overlay.style.display === 'none') return;
      if (e.key === 'Escape' && overlay._sgClose) overlay._sgClose();
      else if (e.key === 'Tab' && overlay._sgTrapTab) overlay._sgTrapTab(e);
    });
  });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["taste-grid"] && !Shopify.designMode) return;
  try {
    (function() {
  /* Locale-aware root: '' on the primary locale, '/fr' etc. on secondary ones.
     Recommendation/product fetches MUST carry it or Shopify answers in the shop's
     DEFAULT locale (untranslated card markup and product titles). */
  var LOCALE_ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root || '/').replace(/\/$/, '');

  var STORAGE_KEY = 'bonvale_recently_viewed';
  var MAX_ANCHORS = 3;
  var REC_LIMIT = 10;
  var DRAG_THRESHOLD = 5;

  function initTasteGrids() {
  document.querySelectorAll('[data-taste]').forEach(function(el) {
    if (el.dataset.tasteInit === '1') return;
    el.dataset.tasteInit = '1';

    var viewport = el.querySelector('[data-taste-viewport]');
    var track = el.querySelector('[data-taste-track]');
    var prev = el.querySelector('[data-taste-prev]');
    var next = el.querySelector('[data-taste-next]');
    var dotsEl = el.querySelector('[data-taste-dots]');
    var arrowsEl = el.querySelector('.taste-grid__arrows');
    var handle = el.dataset.tasteHandle;
    var labelAddCart = el.dataset.tasteLabelAddCart || 'Add to cart';
    var labelAddBag = el.dataset.tasteLabelAddBag || 'Add to bag';
    var labelPage = el.dataset.tasteLabelPage || 'Page %%N%%';
    var tagLabels = {};
    try { tagLabels = JSON.parse(el.dataset.tasteTagLabels || '{}'); } catch (e) { /* keep {} — badges are skipped, never shown in English */ }
    var perPage = parseInt(el.dataset.tastePerPage) || 8;
    var moneyFormat = el.dataset.tasteMoneyFormat || ('$' + '{' + '{amount}}');
    /* Empty unless the presentment currency's symbol is ambiguous — see snippets/currency-code. */
    var moneyCode = el.dataset.tasteMoneyCode || '';
    var cardMode = el.dataset.tasteCardMode || '';
    /* Fixed product list (merchant-picked): all pages are server-rendered;
       personalization and collection fetching are disabled. */
    var fixed = el.dataset.tasteFixed === '1';

    if (!viewport || !track) return;
    if (!handle && !fixed) return;

    var totalPages = parseInt(el.dataset.tasteTotalPages) || 1;
    var currentPage = 1;
    var cache = {};
    var personalized = false;

    track.querySelectorAll('[data-taste-page]').forEach(function(pageEl) {
      cache[parseInt(pageEl.dataset.tastePage, 10)] = pageEl;
    });

    function renderDots(count) {
      if (arrowsEl) arrowsEl.classList.toggle('taste-grid__arrows--hidden', count <= 1);
      if (!dotsEl) return;
      dotsEl.classList.toggle('taste-grid__dots--hidden', count <= 1);
      dotsEl.innerHTML = '';
      for (var i = 1; i <= count; i++) {
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'taste-grid__dot' + (i === currentPage ? ' taste-grid__dot--active' : '');
        btn.setAttribute('data-taste-dot', i);
        btn.setAttribute('aria-label', labelPage.replace('%%N%%', i));
        dotsEl.appendChild(btn);
      }
    }

    function updateUI() {
      if (prev) prev.disabled = currentPage <= 1;
      if (next) next.disabled = currentPage >= totalPages;
      if (dotsEl) {
        var dots = dotsEl.querySelectorAll('.taste-grid__dot');
        for (var i = 0; i < dots.length; i++) {
          dots[i].classList.toggle('taste-grid__dot--active', i + 1 === currentPage);
        }
      }
    }

    function scrollToPage(page) {
      if (page < 1 || page > totalPages) return;
      var doScroll = function() {
        viewport.scrollTo({ left: (page - 1) * viewport.clientWidth, behavior: 'smooth' });
      };
      if (cache[page]) {
        doScroll();
      } else if (!personalized && !fixed) {
        /* Load missing pages up to the target sequentially so every page
           before it exists in the DOM and the scroll offset stays correct. */
        ensurePagesThrough(page).then(function() { if (cache[page]) doScroll(); });
      }
    }

    /* Read recently viewed and try to personalize. Fixed lists never
       personalize — the merchant-picked order is authoritative. */
    var anchorIds = [];
    var anchorHandles = {};
    if (!fixed) try {
      var raw = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      raw.forEach(function(it) {
        if (it && typeof it === 'object' && it.id && it.handle) {
          anchorHandles[it.handle] = true;
          if (anchorIds.length < MAX_ANCHORS) anchorIds.push(it.id);
        }
      });
    } catch(e) {}

    if (anchorIds.length > 0) {
      var requests = anchorIds.map(function(id) {
        return fetch(LOCALE_ROOT + '/recommendations/products?product_id=' + id + '&intent=related&limit=' + REC_LIMIT + '&section_id=more-to-explore-content')
          .then(function(r) { return r.text(); })
          .then(function(html) {
            var tmp = document.createElement('div');
            tmp.innerHTML = html;
            return Array.prototype.slice.call(tmp.querySelectorAll('.product-card'));
          })
          .catch(function() { return []; });
      });

      Promise.all(requests).then(function(results) {
        var byHandle = {};
        var order = [];
        results.forEach(function(cards) {
          cards.forEach(function(card) {
            var href = card.getAttribute('href') || '';
            var parts = href.split('/products/');
            if (parts.length < 2) return;
            var h = parts[1].split('?')[0].split('#')[0].replace(/\/$/, '');
            if (!h || anchorHandles[h]) return;
            if (!byHandle[h]) {
              byHandle[h] = { card: card, score: 0 };
              order.push(h);
            }
            byHandle[h].score += 1;
          });
        });
        order.sort(function(a, b) { return byHandle[b].score - byHandle[a].score; });

        if (order.length === 0) {
          prefetchNext();
          return;
        }

        personalized = true;
        var personalPages = Math.ceil(order.length / perPage);
        track.innerHTML = '';
        cache = {};
        for (var p = 1; p <= personalPages; p++) {
          var slice = order.slice((p - 1) * perPage, p * perPage);
          var pageEl = document.createElement('div');
          pageEl.className = 'taste-grid__page';
          pageEl.dataset.tastePage = p;
          slice.forEach(function(h) { pageEl.appendChild(byHandle[h].card); });
          track.appendChild(pageEl);
          cache[p] = pageEl;
        }
        totalPages = personalPages;
        currentPage = 1;
        viewport.scrollLeft = 0;
        renderDots(totalPages);
        if (window.Wishlist) window.Wishlist.updateAll();
        updateUI();
      });
    } else {
      prefetchNext();
    }

    /* Shared formatter first (snippets/money-format) — it is the only path that
       gets Eurozone / apostrophe / space separators right. Note the argument here
       is MAJOR units (the taste endpoint returns e.g. "31.95"), so convert.
       Local path kept only as a degradation route. */
    function formatMoney(price) {
      var amount = parseFloat(price);
      if (isNaN(amount)) return '';
      if (window.BonvaleMoney) return window.BonvaleMoney.format(Math.round(amount * 100));
      var formatted = amount.toFixed(2);
      return moneyFormat
        .replace('{' + '{amount}}', formatted)
        .replace('{' + '{amount_no_decimals}}', Math.round(amount)) + moneyCode;
    }

    /* Card image delivery, kept in step with snippets/product-card + image-srcset:
       same widths ladder, same 1.331 rendered crop, same CDN quality, same `sizes`.
       Was a single fixed 580×772 at the CDN's default quality (~85) with no srcset —
       measured 31-45 KB per card where the ladder + quality=70 serves 4-19 KB. The
       cart drawer is in layout/theme.liquid, so this grid's images load on EVERY
       page, competing with whatever that page's own LCP image is. */
    var CARD_WIDTHS = [290, 360, 435, 520, 640, 870, 1160];
    var CARD_RATIO = 1.331;
    var CARD_SIZES = '(max-width: 768px) calc((100vw - 36px) / 2), 25vw';

    function cardImageUrl(src, w) {
      // products.json image URLs carry a ?v= query string, so size via query
      // params (a filename-suffix replace anchored at $ would never match).
      return src + (src.indexOf('?') === -1 ? '?' : '&') +
        'width=' + w + '&height=' + Math.round(w * CARD_RATIO) + '&crop=center&quality=70';
    }

    function buildCard(p) {
      var imgSrc = p.images && p.images[0] ? p.images[0].src : '';
      var img = imgSrc
        ? '<img class="product-card__img" src="' + cardImageUrl(imgSrc, 640) + '"' +
          ' srcset="' + CARD_WIDTHS.map(function (w) { return cardImageUrl(imgSrc, w) + ' ' + w + 'w'; }).join(', ') + '"' +
          ' sizes="' + CARD_SIZES + '"' +
          ' loading="lazy" width="290" height="386" alt="' + (p.images[0].alt || p.title).replace(/"/g, '&quot;') + '">'
        : '<div class="product-card__placeholder"></div>';

      var tags = '';
      if (p.tags) {
        /* "Best Seller" is always the BOTTOM chip of the stack (Figma v1.3
           16754:113006, promotional chips above it) — same two-pass order as
           product-card.liquid. */
        var promoTags = '', bestTags = '';
        p.tags.forEach(function(tag) {
          var lower = tag.toLowerCase();
          if (lower.indexOf('limited') > -1 || lower.indexOf('save') > -1 || lower.indexOf('new') > -1 || lower.indexOf('sale') > -1 || lower.indexOf('best') > -1) {
            /* Never echo the raw tag: it is English in every locale. Unmapped
               tags render no badge, exactly as product-card.liquid does. */
            var tagLabel = tagLabels[lower];
            if (!tagLabel) return;
            var chip = '<span class="product-card__tag">' + tagLabel + '</span>';
            if (lower.indexOf('best') > -1) bestTags += chip; else promoTags += chip;
          }
        });
        tags = promoTags + bestTags;
      }

      var variant = p.variants && p.variants[0];
      var price = variant ? variant.price : p.price;
      var comparePrice = variant ? variant.compare_at_price : p.compare_at_price;

      var compare = '';
      if (comparePrice && parseFloat(comparePrice) > parseFloat(price)) {
        compare = '<p class="product-card__compare">' + formatMoney(comparePrice) + '</p>';
      }

      var isQuickAdd = cardMode === 'quick-add';
      var variantId = p.variants && p.variants[0] ? p.variants[0].id : '';
      var wishlistBtn = isQuickAdd ? '' :
        '<span class="product-card__heart">' +
        (window.Wishlist ? window.Wishlist.renderBtn({
          id: p.id, variantId: variantId,
          url: window.location.origin + LOCALE_ROOT + '/products/' + p.handle,
          title: p.title, price: price,
          image: p.images && p.images[0] ? p.images[0].src : ''
        }) : '') + '</span>';
      var plusBtn = isQuickAdd ? '' :
        '<button type="button" class="product-card__add" data-quick-add data-product-handle="' + p.handle + '" onclick="event.preventDefault();event.stopPropagation();" aria-label="' + labelAddCart + '"><svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg" style="display:block" aria-hidden="true"><path d="M16 7.33333H8.66667V0H7.33333V7.33333H0V8.66667H7.33333V16H8.66667V8.66667H16V7.33333Z"/></svg></button>';

      var openTag = isQuickAdd
        ? '<div class="product-card product-card__link--quick-add" data-quick-add data-product-handle="' + p.handle + '" role="button" tabindex="0" aria-label="' + labelAddBag + '">'
        : '<a href="' + (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'products/' + p.handle + '" class="product-card">';
      var closeTag = isQuickAdd ? '</div>' : '</a>';

      return openTag +
        '<div class="product-card__image">' + img +
          '<div class="product-card__tags">' + tags + '</div>' +
          wishlistBtn +
          plusBtn +
        '</div>' +
        '<div class="product-card__info">' +
          '<p class="product-card__title">' + p.title + '</p>' +
          '<div class="product-card__prices">' +
            '<p class="product-card__price">' + formatMoney(price) + '</p>' +
            compare +
          '</div>' +
        '</div>' +
      closeTag;
    }

    function fetchPage(page) {
      if (cache[page]) return Promise.resolve(cache[page]);
      return fetch(LOCALE_ROOT + '/collections/' + handle + '/products.json?page=' + page + '&limit=' + perPage)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          var products = data.products || [];
          if (products.length === 0) {
            if (page <= totalPages) {
              totalPages = page - 1;
              renderDots(totalPages);
              updateUI();
            }
            return null;
          }
          if (products.length < perPage && page < totalPages) {
            totalPages = page;
            renderDots(totalPages);
            updateUI();
          }
          var pageEl = document.createElement('div');
          pageEl.className = 'taste-grid__page';
          pageEl.dataset.tastePage = page;
          pageEl.innerHTML = products.map(buildCard).join('');
          insertPage(pageEl, page);
          cache[page] = pageEl;
          if (window.Wishlist) window.Wishlist.updateAll();
          return pageEl;
        })
        .catch(function() { return null; });
    }

    function insertPage(pageEl, page) {
      var pages = track.querySelectorAll('[data-taste-page]');
      var inserted = false;
      for (var i = 0; i < pages.length; i++) {
        var n = parseInt(pages[i].dataset.tastePage, 10);
        if (n > page) {
          track.insertBefore(pageEl, pages[i]);
          inserted = true;
          break;
        }
      }
      if (!inserted) track.appendChild(pageEl);
    }

    function ensurePagesThrough(page) {
      var p = 2;
      function step() {
        if (p > page || p > totalPages) return Promise.resolve();
        var cur = p++;
        if (cache[cur]) return step();
        return fetchPage(cur).then(step);
      }
      return step();
    }

    /* Keep exactly one page ahead of the user instead of prefetching every
       fallback page at once — the old burst tripped Shopify's 429 rate limit. */
    function prefetchNext() {
      if (personalized || fixed) return;
      var p = currentPage + 1;
      if (p <= totalPages && !cache[p]) fetchPage(p);
    }

    /* Scroll listener — track current page and sync UI. */
    var scrollRaf = null;
    viewport.addEventListener('scroll', function() {
      if (scrollRaf) return;
      scrollRaf = requestAnimationFrame(function() {
        scrollRaf = null;
        var w = viewport.clientWidth;
        if (w === 0) return;
        var page = Math.round(viewport.scrollLeft / w) + 1;
        if (page !== currentPage) {
          currentPage = page;
          updateUI();
          prefetchNext();
        }
      });
    });

    if (prev) prev.addEventListener('click', function() { scrollToPage(currentPage - 1); });
    if (next) next.addEventListener('click', function() { scrollToPage(currentPage + 1); });
    if (dotsEl) {
      dotsEl.addEventListener('click', function(e) {
        var btn = e.target.closest('[data-taste-dot]');
        if (!btn) return;
        scrollToPage(parseInt(btn.dataset.tasteDot, 10));
      });
    }

    /* PC mouse drag-to-scroll. */
    var isDown = false;
    var dragStartX = 0;
    var dragStartScroll = 0;
    var dragMoved = 0;
    viewport.addEventListener('mousedown', function(e) {
      if (e.button !== 0) return;
      isDown = true;
      dragMoved = 0;
      dragStartX = e.pageX;
      dragStartScroll = viewport.scrollLeft;
      viewport.classList.add('taste-grid__viewport--grabbing');
    });
    document.addEventListener('mousemove', function(e) {
      if (!isDown) return;
      var dx = e.pageX - dragStartX;
      dragMoved = Math.abs(dx);
      if (dragMoved > DRAG_THRESHOLD) {
        viewport.scrollLeft = dragStartScroll - dx;
      }
    });
    document.addEventListener('mouseup', function() {
      if (!isDown) return;
      isDown = false;
      viewport.classList.remove('taste-grid__viewport--grabbing');
    });
    viewport.addEventListener('click', function(e) {
      if (dragMoved > DRAG_THRESHOLD) {
        e.preventDefault();
        e.stopPropagation();
        dragMoved = 0;
      }
    }, true);

    window.addEventListener('resize', function() {
      viewport.scrollLeft = (currentPage - 1) * viewport.clientWidth;
    });

    updateUI();
  });
  }
  initTasteGrids();

  /* Re-runnable so a grid that gets replaced wholesale can be brought back to
     life. The /cart page swaps its whole `#cdp` subtree — which contains the
     inline "You May Also Like" grid — on every quantity change, removal and
     quick-add; the arrows, the drag handling and (in card_mode 'quick-add') the
     click-to-open-the-sheet handler are all bound to nodes that swap discards,
     so without this the grid is left inert and a card click walks off to the PDP
     instead of opening quick-add. The per-element data-taste-init guard makes a
     repeat call a no-op for grids that are still live. */
  window.__initTasteGrids = initTasteGrids;
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["track-order-drawer"] && !Shopify.designMode) return;
  try {
    (function () {
  const drawer = document.querySelector('[data-track-drawer]');
  if (!drawer) return;

  let labels = {};
  try {
    const raw = drawer.parentNode.querySelector('[data-track-drawer-labels]');
    if (raw) labels = JSON.parse(raw.textContent);
  } catch (e) { labels = {}; }
  // Shopify's `t` filter HTML-escapes apostrophes etc. (e.g. "couldn&#39;t");
  // decode via a textarea so labels render as real text.
  const decoder = document.createElement('textarea');
  Object.keys(labels).forEach(function (k) {
    if (typeof labels[k] === 'string' && labels[k].indexOf('&') !== -1) {
      decoder.innerHTML = labels[k];
      labels[k] = decoder.value;
    }
  });
  const labelFor = (k) => labels[k] || k;

  const guestEndpoint = drawer.dataset.guestEndpoint || '/apps/track-order/guest-tracking';
  const introEl = drawer.querySelector('[data-track-drawer-intro]');
  const form = drawer.querySelector('[data-track-drawer-form]');
  const orderInput = drawer.querySelector('[data-track-drawer-order]');
  const emailRow = drawer.querySelector('[data-track-drawer-email-row]');
  const emailInput = drawer.querySelector('[data-track-drawer-email]');
  const signinRow = drawer.querySelector('[data-track-drawer-signin]');
  const checkBtn = drawer.querySelector('[data-track-drawer-check]');
  const resultWrap = drawer.querySelector('[data-track-drawer-result]');
  const resultHead = drawer.querySelector('.acd-modal__result');
  const numberEl = drawer.querySelector('[data-track-drawer-number]');
  const bodyEl = drawer.querySelector('[data-track-drawer-body]');
  const panel = drawer.querySelector('[role="dialog"]');
  const focusSelector = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  let returnFocus = null;

  function trapTab(e) {
    if (e.key !== 'Tab' || drawer.hidden || !panel) return;
    const items = Array.from(panel.querySelectorAll(focusSelector)).filter((el) => el.getClientRects().length && !el.hidden);
    if (!items.length) { e.preventDefault(); panel.focus(); return; }
    const first = items[0];
    const last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  const DATE_LOCALE = document.documentElement.lang || 'en';

  function el(tag, cls, text) {
    const node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  }

  function formatDateTime(iso) {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    const time = d.toLocaleTimeString(DATE_LOCALE, { hour: 'numeric', minute: '2-digit', hour12: true }).toLowerCase();
    const date = d.toLocaleDateString(DATE_LOCALE, { month: '2-digit', day: '2-digit', year: 'numeric' });
    return time + ', ' + date;
  }

  // Date above the label; the current node's ring icon is pure CSS.
  function milestone(key, date, current, location) {
    const li = el('li', 'acd__ms' + (current ? ' acd__ms--current' : ''));
    li.appendChild(el('span', 'acd__ms-icon'));
    const text = el('span', 'acd__ms-text');
    const when = formatDateTime(date);
    if (when || location) {
      text.appendChild(el('p', 'acd__ms-date', when + (location ? (when ? ' · ' : '') + location : '')));
    }
    text.appendChild(el('p', 'acd__ms-label', labelFor(key)));
    li.appendChild(text);
    return li;
  }

  // State for the current open session.
  let mode = 'customer';
  let ctxShipments = [];
  let ctxProcessedAt = null;

  function setLoading(on) {
    if (!checkBtn) return;
    checkBtn.disabled = on;
    const idle = checkBtn.querySelector('[data-label-idle]');
    const loading = checkBtn.querySelector('[data-label-loading]');
    if (idle) idle.hidden = on;
    if (loading) loading.hidden = !on;
  }

  function pickShipment(shipments) {
    if (!Array.isArray(shipments) || !shipments.length) return null;
    return shipments.find((s) => s && s.events && s.events.length) || shipments[0];
  }

  function renderResult(processedAt, shipment) {
    numberEl.textContent = (shipment && shipment.number) || (orderInput ? orderInput.value.trim().replace(/^#/, '') : '');
    if (shipment && shipment.events && shipment.events.length) {
      const list = el('ul', 'acd__timeline');
      shipment.events.forEach((ev, i) => list.appendChild(milestone(ev.key, ev.time, i === 0, ev.location)));
      if (processedAt) list.appendChild(milestone('confirmed', processedAt, false));
      bodyEl.replaceChildren(list);
    } else {
      const empty = el('div');
      empty.appendChild(el('p', 'acd-modal__empty', labelFor('empty')));
      if (processedAt) {
        const list = el('ul', 'acd__timeline');
        list.appendChild(milestone('confirmed', processedAt, true));
        empty.appendChild(list);
      }
      bodyEl.replaceChildren(empty);
    }
    if (resultHead) resultHead.hidden = false;
    resultWrap.hidden = false;
  }

  // not-found / error: show only the message — no "Tracking result for
  // <number>" header, since there is no order to label.
  function showMessage(msg) {
    if (resultHead) resultHead.hidden = true;
    bodyEl.replaceChildren(el('p', 'acd-modal__empty', msg));
    resultWrap.hidden = false;
  }

  async function runCheck() {
    const orderVal = orderInput ? orderInput.value.trim().replace(/^#/, '') : '';
    if (!orderVal) { if (orderInput) orderInput.focus(); return; }

    if (mode === 'customer') {
      // Trajectory already loaded by the order detail page — render from it.
      renderResult(ctxProcessedAt, pickShipment(ctxShipments) || { number: '', events: [] });
      return;
    }

    // Guest: verify order number + email before revealing anything.
    const emailVal = emailInput ? emailInput.value.trim() : '';
    if (!emailVal) { if (emailInput) emailInput.focus(); return; }
    setLoading(true);
    try {
      const res = await fetch(guestEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ order_number: orderVal, email: emailVal }),
      });
      const data = res.ok ? await res.json() : null;
      if (data && data.status === 'ok') {
        renderResult(data.processed_at || null, pickShipment(data.shipments) || { number: '', events: [] });
      } else if (data && data.status === 'not_found') {
        showMessage(labelFor('not_found'));
      } else {
        showMessage(labelFor('error'));
      }
    } catch (e) {
      showMessage(labelFor('error'));
    } finally {
      setLoading(false);
    }
  }

  function close() {
    if (drawer.hidden) return;
    drawer.hidden = true;
    document.documentElement.style.overflow = '';
    if (returnFocus && returnFocus.focus) returnFocus.focus();
    returnFocus = null;
  }

  // Public opener. opts:
  //   mode: 'customer' | 'guest'
  //   orderNumber: string (customer: prefilled + read-only)
  //   shipments: array (customer: preloaded KEC shipments)
  //   processedAt: string (customer: order.processed_at → Confirmed base node)
  function open(opts) {
    opts = opts || {};
    mode = opts.mode === 'guest' ? 'guest' : 'customer';
    ctxShipments = Array.isArray(opts.shipments) ? opts.shipments : [];
    ctxProcessedAt = opts.processedAt || null;

    if (introEl) introEl.textContent = labelFor(mode === 'guest' ? 'intro_guest' : 'intro_customer');
    if (orderInput) {
      orderInput.value = opts.orderNumber ? String(opts.orderNumber).replace(/^#/, '') : '';
      orderInput.readOnly = mode === 'customer';
    }
    if (emailRow) emailRow.hidden = mode !== 'guest';
    if (signinRow) signinRow.hidden = mode !== 'guest';
    if (emailInput) emailInput.value = '';
    if (resultWrap) resultWrap.hidden = true;
    if (resultHead) resultHead.hidden = false;
    if (bodyEl) bodyEl.replaceChildren();
    setLoading(false);

    returnFocus = document.activeElement;
    drawer.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    // Guests type; customers just confirm — focus the field that needs input.
    if (orderInput) orderInput.focus();
  }

  if (form) form.addEventListener('submit', (e) => { e.preventDefault(); runCheck(); });
  drawer.querySelectorAll('[data-track-drawer-close]').forEach((n) => n.addEventListener('click', close));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
    else trapTab(e);
  });

  // Footer "Track Your Orders" (and any track-order link) opens the guest
  // drawer for logged-out visitors instead of navigating to the standalone
  // page. Logged-in visitors fall through to their account order pages.
  const isGuest = drawer.dataset.loggedIn !== 'true';
  document.addEventListener('click', function (e) {
    if (!isGuest) return;
    const link = e.target.closest('a[href*="/pages/track-my-order"]');
    if (!link) return;
    e.preventDefault();
    open({ mode: 'guest' });
  });

  window.BonvaleTrackDrawer = { open: open, close: close };
})();
  } catch(e) { console.error(e); }
})();

})();
